import { Injectable } from '@angular/core';
@Injectable({
  providedIn: 'root'
})
export class DataProviderService {
  selectedNews: any;
  public selectedGallery = {
    "Index": "1",
    "Title": "Launch of Intelliseat",
    "News": "/Gallery/News/1",
    "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/1",
    "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
    "count": 26
  };

  public links = {
    "Links": [
      {
        "Title": "International Ergonomics Association",
        "Link": "http://www.iea.cc/",
        "Logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/3.png"
      },
      {
        "Title": "Human Factors and Ergonomics Society",
        "Link": "https://www.hfes.org/",
        "Logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/4.png"
      },
      {
        "Title": "Rehabilitation Bioengineering Group",
        "Link": "https://ed.iitm.ac.in/~vb/index.html",
        "Logo": "https://ed.iitm.ac.in/~vb/assets/img/rr.png"
      },
      {
        "Title": "Department of Engineering Design",
        "Link": "https://ed.iitm.ac.in/",
        "Logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/5.png"
      },
      {
        "Title": "Indian Institute of Technology Madras",
        "Link": "https://www.iitm.ac.in/",
        "Logo": "https://ed.iitm.ac.in/~vb/assets/img/ttt.png"
      },


      {
        "Title": "Ministry of Road Transport and Highways",
        "Link": "https://morth.nic.in/",
        "Logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/27.png"
      },
      {
        "Title": "Tamil Nadu Police",
        "Link": "https://eservices.tnpolice.gov.in/CCTNSNICSDC/Index?0",
        "Logo": "https://ed.iitm.ac.in/~vb/assets/img/Tn-police-logo.png"
      },
      {
        "Title": "Anand Group",
        "Link": "https://www.anandgroupindia.com/",
        "Logo": "https://ed.iitm.ac.in/~vb/assets/img/Logos/29.png"
      }


    ]
  }
  public expressions = {
    "Expressions": [
      {
        "Title": "Team RBG congratulates Dr. Soma Guhathakurta on receiving the \"Biotech product, process development and commercilization award for the year 2017\" from the Honoroble President of India"
      },
      {
        "Title": "Team RBG welcomes the new scholar entrants Priyadarshini N. and Mohanraj B"
      },
      {
        "Title": "Team RBG congratulates Mr. Anand Parikh on receiving GYTI Award for his innovation named Nstomoz - Vascular Anastomosis Assist Device, under the gudiance of Prof. Venkatesh Balasubramanian and Dr. V B Narayanamurthy"
      },
      {
        "Title": "Team RBG congratulates Mr. Gnanavel for his presentation at AHFE'15 international conference at Las Vegas"
      },
      {
        "Title": "Team RBG congratulates Mr. S.M Vadivel on his MS graduation"
      },
      {
        "Title": "Team RBG congratulates Dr. A. Mohammed Faisal on his Ph.D graduation"
      },
      {
        "Title": "Team RBG congratulates Mr. Rahul Bhardwaj on the auspicious occasion of his son's birth"
      },
      {
        "Title": "Team RBG congratulates Mr. Narayanan on the auspicious occasion of his daughter's birth"
      },
      {
        "Title": "Team RBG proud to announce the visit of Honourable Transport Minister of Tamilnadu Thiru. V. Senthil Balaji for a meeting with the members on 24th July,2014"
      },
      {
        "Title": "Team RBG congratulates Dr. V. Susila Anand on her graduating as Ph.D"
      },
      {
        "Title": "Team RBG welcomes the new scholar entrants Swathy P. and Minerva R."
      },
      {
        "Title": "Team RBG wishes Mr. Rahul, Scholar a \"Happy Wedding Bliss!\""
      },
      {
        "Title": "Team RBG expresses its support and admiration to Mr. Srinivassan in his fight against cancer"
      }
    ]
  }
  public projects = {
    "Projects": [
      {
        "name": "Indigenous technologies for ubiquitous monitoring of driver performance and behaviour",
        "fundingAgency": "M/s Harita Seating Systems Ltd.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/6.png"
      },
      {
        "name": "Identifying Real Time Physiological Parameters to Test Physical and Cognitive Fatigue While Driving in a Simulated Environment",
        "fundingAgency": "M/s Renault Nissan Technology & Business Centre India Private Limited (RNTBCI)",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/7.png"
      },
      {
        "name": "Innovative New Products Development and Process Improvement ",
        "fundingAgency": "M/s Sundaram Brake Linings, Ltd",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/8.png"
      },
      {
        "name": "Innovative and Disruptive Products for Medical Applications ",
        "fundingAgency": "M/s Sundaram Medical Devices, Ltd, India.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/9.png"
      },
      {
        "name": "Anand Manufacturing Excellence ",
        "fundingAgency": "M/s Anand Automotive Limited, India.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/10.png"
      },
      {
        "name": "Operational Strategies for Implementing Lean Ergonomics using RBG Risk Scale (RBGRS)",
        "fundingAgency": "M/s Spicer India Ltd, India.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/11.png"
      },
      {
        "name": "Visionary leaders for Manufacturing (VLFM) and Visionary SME (VSME) ",
        "fundingAgency": "Joint Program of IIT Madras, IIT Kanpur, IIM Calcutta",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/12.png"
      },
      {
        "name": "Phantom Design and Development for Vascular Applications",
        "fundingAgency": "M/s Philips Electronics Ltd.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/13.png"
      },
      {
        "name": "Quantitative assessment of Effect of Two Wheeler Rider Posture on Riding Fatigue and Vehicle Handling ",
        "fundingAgency": "M/s TVS Motor Company Ltd, India.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/14.png"
      },
      {
        "name": "Start-up on Nature Based Technologies for Closed Room Air quality Improvement ",
        "fundingAgency": "Maham Holding Private Limited, India."
      },
      {
        "name": "Strategic Productivity Improvement in Leather Goods Manufacturing",
        "fundingAgency": "M/s AVT Leather & Allied Products India, Ltd Chennai.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/15.png"
      },
      {
        "name": "Finite Element ATD neck model for use in rollover simulations",
        "fundingAgency": "M/s General Motors R&D, India Science Lab, Bangalore.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/16.png"
      },
      {
        "name": "Ergonomic Study to Improve Workforce Productivity in a Large Earth Mover Wheel Manufacturing Plant",
        "fundingAgency": "M/s Wheels India Limited, Chennai.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/17.png"
      },
      {
        "name": "Plant Layout Optimization and Ergonomic Workplace Design ",
        "fundingAgency": "M/s Borg-Warner Cooling Systems Limited, Chennai.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/18.png"
      },
      {
        "name": "Workforce Productivity Improvement in a passenger car Wheel Manufacturing Plant ",
        "fundingAgency": "M/s Wheels India Limited, Chennai.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/17.png"
      },
      {
        "name": "Productivity Improvement and Resource Planning ",
        "fundingAgency": "M/s Leather Crafts India (P) Ltd, Chennai.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/19.png"
      },
      {
        "name": "Ergonomic Study to Improve Workforce Productivity in a Commercial Vehicle Wheel Manufacturing Plant ",
        "fundingAgency": "M/s Wheels India Limited, Chennai.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/17.png"
      },
      {
        "name": "Productivity Improvement and Product Development Cycle Time Reduction",
        "fundingAgency": "M/s Rabia Leather Industries, Chennai.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/20.png"
      },
      {
        "name": "Human Factors in Manufacturing and Product Design",
        "fundingAgency": "IIT Madras",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/1.png"
      },
      {
        "name": "Ergonomics in Computer Centric Workplaces",
        "fundingAgency": "IIT Madras",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/1.png"
      },
      {
        "name": "Introduction to Industrial Engineering and Ergonomics ",
        "fundingAgency": "M/s Baxter India, Chennai.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/21.png"
      },
      {
        "name": "Primer Course in Biomedical Engineering  ",
        "fundingAgency": "AICTE, India.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/22.png"
      },
      {
        "name": "Digital Monitoring of Trainee Posture and Weapon Position",
        "fundingAgency": "Army Technology Board, Indian Army.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/23.png"
      },
      {
        "name": "SAHA – A Semi-Automatic Mechanical Hammer for Quarry Workers",
        "fundingAgency": "Dept of Sci and Tech (RuTAG), Government of India.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/24.png"
      },
      {
        "name": "Development of Ergonomics and Sports Biomechanics Laboratory ",
        "fundingAgency": "MHRD Government of India.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/25.png"
      },
      {
        "name": "Design and Fabrication of Silicon Micropump for drug delivery and dosage control ",
        "fundingAgency": "NPSM, India."
      },
      {
        "name": "Strategic Road Map to Create a Structured Maintenance of Medical Equipments ",
        "fundingAgency": "TNMSC, State Government of Tamilnadu, India.",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/26.png"
      },
      {
        "name": "Rehabilitation Biomechanics and Biomedical Measurements ",
        "fundingAgency": "IDRG, IIT Madras."
      },
      {
        "name": "Ergonomic studies of bar bending  ",
        "fundingAgency": "New faculty grant, IIT Madras",
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Logos/1.png"
      }
    ]
  }
  public gallery = {
    "Gallery": [

      
      {
        "Index": "15",
        "Title": "Strategic Planning Workshop on Safer Roads in Tamil Nadu Stakeholder Agencies",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/26",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 7
      },



      {
        "Index": "12",
        "Title": "National Seminar on Road Safety: Safer Road That Save Lives, in Ranchi, Jharkhand",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/25",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 27
      },

      {
        "Index": "12",
        "Title": "Workshop on Data Driven Approach to Road Safety for Uttar Pradesh Stake Holder Departments",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/22",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 7
      },
      {
        "Index": "13",
        "Title": "Aligning the Andhra Pradesh State for iRAD induction.",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/23",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 7
      },
      {
        "Index": "14",
        "Title": "Training Rajasthan Stake Holder departments in Implementing TN model",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/24",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 3
      },






      {
        "Index": "10",
        "Title": "GoI launches IRAD for Road Safety",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/18",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 4
      },


      {
        "Index": "11",
        "Title": "Demystifying Design Thinking - A Pathway to Practice",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/19",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 3
      },
      {
        "Index": "1",
        "Title": "Launch of Intelliseat",
        "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/1",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 26
      },
      {
        "Index": "2",
        "Title": "Health Technology Assessment Partner Meeting with NHM",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/2",
        "GoogleLink": "https://photos.google.com/share/AF1QipNLYSoQWvlj3GvW2cjSULXp78XaFK7hr1NEEb7mrTFCslGYf_xSZniCS-SSolzrSQ?key=RUxPdmdMcGZjaGxVTDFwUEQ5VDdWTWo0ZnFiNnBn",
        "count": 10
      },
      {
        "Index": "3",
        "Title": "Roundtable on Visionary Leadership for Manufacturing",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/3",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipNQGZR8AXfsaXuGQmpgIChx2fvy1tp0OamGaDFt?source=pwa&authKey=CKa0sfT3vbvvZg#slideshow/6275950062901818402",
        "Writeup": "/Gallery/News/3/write_up_v4mii.docx",
        "count": 15
      },
      {
        "Index": "4",
        "Title": "Technology transfer between IITM and Harita Seating System Ltd",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/4",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipOKlp5-ckSQt3DQjP3IP5u8X-n58O6wcAijFZkZ?source=pwa&authKey=CJvD0b_Uk8eBVA#slideshow/6189809970302168098",
        "count": 14
      },
      {
        "Index": "5",
        "Title": "RATH 2015",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/5",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipOyHpI6w_LO47xaJiPiX-GNbGQWC0OTJgofe2Gm?source=pwa&authKey=CPvny6r15PmeDg#slideshow/6111603848661303202",
        "count": 33
      },
      {
        "Index": "6",
        "Title": "Honourable Transport Minister, Thiru. V. Senthil Balaji, Govt. of Tamil Nadu visit to RBG Lab",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/6",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipPBVIfIs9B6LVm7i_cWxItgC6JWHwXg6-qiAgOY?source=pwa&authKey=CMqh08Xb0ajJyQE#slideshow/6041342160026327394",
        "count": 25
      },
      {
        "Index": "7",
        "Title": "RBG Lab Events",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/7",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipN-8YHfkCKDHtmXA_K6_ZxHGTJ391QUshD3dwzo?source=pwa&authKey=CKyE-YG0qJaHhAE#slideshow/5964181785425589762",
        "count": 12
      },
      {
        "Index": "8",
        "Title": "HWWE Conference 2014",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/8",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipNX0bg5uMICJPJlqD9Wb1qa8QkM94-6quNBejlx?source=pwa&authKey=CP-jovv5odLRswE#slideshow/5964609685186901602",
        "count": 27
      },
      {
        "Index": "9",
        "Title": "NTRI Workshop",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/14",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipNX0bg5uMICJPJlqD9Wb1qa8QkM94-6quNBejlx?source=pwa&authKey=CP-jovv5odLRswE#slideshow/5964609685186901602",
        "count": 18
      }
    ]
  }


  public invited = {
    "Invited": [
      {
        "Number": "1",
        "Name": "V. Balasubramanian",
        "Title": "Biomedical Engineering - Frontiers and opportunities",
        "Conference": "National Seminar on Medical Instrumentation- Application and Design",
        "Location": "SREC Coimbatore",
        "Date": " August 31, 2013"
      },
      {
        "Number": "2",
        "Name": "V. Balasubramanian",
        "Title": "Operational Risk Management using RBG Risk Scale (RBGRS)",
        "Conference": "42nd National Safety Day",
        "Location": "L&T Chennai",
        "Date": "March 4,2013"
      },
      {
        "Number": "3",
        "Name": "V. Balasubramanian",
        "Title": "Translational Research in Biomedical Engineering in RBG , IIT Madras,",
        "Conference": "Pan IIT Alumni Meet",
        "Location": "Kolkata",
        "Date": "December 8, 2012"
      },
      {
        "Number": "4",
        "Name": "V. Balasubramanian",
        "Title": "Understating Disruptive and Sustaining Innovation",
        "Conference": " Workshop on Innovation in Manufacturing Excellence",
        "Location": "Monash University, Malaysia",
        "Date": "November 19, 2012"
      },
      {
        "Number": "5",
        "Name": "V. Balasubramanian",
        "Title": "Manufacturing Excellence - The Indian Way",
        "Conference": "Workshop on Innovation in Manufacturing Excellence",
        "Location": "Monash University, Malaysia",
        "Date": "October 4, 2012"
      },
      {
        "Number": "6",
        "Name": "V. Balasubramanian",
        "Title": "Challenges for Medical Imaging Technologies in Contemporary India",
        "Conference": " Workshop on Engineering and Radiology",
        "Location": "IIT Madras",
        "Date": "August 21, 2012"
      },
      {
        "Number": "7",
        "Name": "V. Balasubramanian",
        "Title": "Back Pain: Pain for Whom?",
        "Conference": "Harnam Singh CME and BRACE CME 2012",
        "Location": "Chennai",
        "Date": "July 14, 2012"
      },
      {
        "Number": "8",
        "Name": "V. Balasubramanian",
        "Title": "Occupational Psychology and its Implications",
        "Conference": "Regional Labor Institute (RLI)",
        "Location": " Chennai",
        "Date": "February 21, 2012"
      },
      {
        "Number": "9",
        "Name": "V. Balasubramanian",
        "Title": "Limiting Occupational Hazards and Enhancing Operational Risk Management using RBGRS",
        "Conference": "Regional Labor Institute (RLI)",
        "Location": "Chennai",
        "Date": "January 23, 2012"
      },
      {
        "Number": "10",
        "Name": "V. Balasubramanian",
        "Title": "Essence of Disruptive Innovations and New Product Development ",
        "Conference": "Off-Highway Truck Product Group Meeting, Caterpillar",
        "Location": "India , Thiruvallur",
        "Date": "January 6, 2012"
      },
      {
        "Number": "11",
        "Name": "V. Balasubramanian",
        "Title": "Cognitive Evaluation of Driver Performance",
        "Conference": " Cognitive Neuroscience Workshop",
        "Location": "SSN College, Chennai",
        "Date": "January 5,2012"
      },
      {
        "Number": "12",
        "Name": "V. Balasubramanian",
        "Title": "Operational Risk Management using RBG Risk Scale (RBGRS)",
        "Conference": " National Quality Summit",
        "Location": "Bangalore",
        "Date": "December 2, 2011"
      },
      {
        "Number": "13",
        "Name": "V. Balasubramanian",
        "Title": "Disruptive Innovations in Medical Diagnostics Therapy and Rehabilitation",
        "Conference": "IITM-DCU Workshop",
        "Location": "Chennai",
        "Date": "September 22, 2011"
      },

      {
        "Number": "14",
        "Name": "V. Balasubramanian",
        "Title": "Human System Interfaces for Rehabilitation and Augmentation",
        "Conference": "Rajalakshmi Engineering College",
        "Location": "Chennai",
        "Date": "July 8, 2011"
      },
      {
        "Number": "15",
        "Name": "V. Balasubramanian",
        "Title": "Innovation and NPD - The Indian Way",
        "Conference": "NIH-ERC, A",
        "Location": "North Carolina A&T, US",
        "Date": " December 9, 2010"
      },
      {
        "Number": "16",
        "Name": "V. Balasubramanian",
        "Title": "Xenogenic Materials for Corporeal Use - The Promise for Future",
        "Conference": "International Conference on Recent Advances in Biomaterials (CRAB 2010)",
        "Location": "Chennai",
        "Date": "December 17, 2010"
      },
      {
        "Number": "17",
        "Name": "V. Balasubramanian",
        "Title": "Biomechanics & Leather Industry - Insights and Perspectives",
        "Conference": "Leather Research Industry Get-together, LERIG",
        "Location": "Chennai",
        "Date": "January 30,2010"
      },
      {
        "Number": "18",
        "Name": "V. Balasubramanian",
        "Title": "Multimodal Human System interface using physiological signals",
        "Conference": "National Workshop on Scientific computing on Biomedical Engineering",
        "Location": "Agra",
        "Date": "August 30-31, 2008"
      },
      {
        "Number": "19",
        "Name": "V. Balasubramanian",
        "Title": "Developing a Business Strategy",
        "Conference": "Program for Senior Managers on Visionary Leaders for Manufacturing",
        "Location": "CII Gurgaon",
        "Date": "December 21, 2008"
      },
      {
        "Number": "20",
        "Name": "V. Balasubramanian",
        "Title": "Biomechanics of Total Knee Replacement",
        "Conference": "Current Trends in Biomaterials, SVCE",
        "Location": "Chennai",
        "Date": " July 18, 2008"
      },
      {
        "Number": "21",
        "Name": "V. Balasubramanian",
        "Title": "Human Factors in Design ",
        "Conference": "STTP on Engineering Design and New Product Development",
        "Location": "IIT Madras",
        "Date": "July 2, 2008"
      },
      {
        "Number": "22",
        "Name": "V. Balasubramanian",
        "Title": "Human System Interface – A Rehabilitative Tool",
        "Conference": "AICTE-ISTE Sponsored Short Term Training Program on Biological System Design and Information Processing",
        "Location": "Dindigul",
        "Date": " May 5, 2008"
      },
      {
        "Number": "23",
        "Name": "V. Balasubramanian",
        "Title": "Human Factors in Heavy Vehicle Design",
        "Conference": "Workshop on Future Vehicle Development for Construction Industry, Ashok Leyland",
        "Location": "Hosur",
        "Date": "April 28-29, 2008"
      },
      {
        "Number": "24",
        "Name": "V. Balasubramanian",
        "Title": "Introduction to Biomechanics",
        "Conference": "Shaastra",
        "Location": "IIT Madras.",
        "Date": "October 5, 2007"
      },
      {
        "Number": "25",
        "Name": "V. Balasubramanian",
        "Title": "Bio-signal Based Human System Interface – A RBG Experience",
        "Conference": " The Frontiers of Dementia Care & Research [13th Congress of the Alzheimer's and Related Disorders Society of India (ARDSI) & 1st Congress of the Asian Society Against Dementia (ASAD)]",
        "Date": "September 28, 2007"
      },
      {
        "Number": "26",
        "Name": "V. Balasubramanian",
        "Title": "Use of Biofeedback to Enhance Simulator Performance and Assist in UserEvaluation",
        "Conference": "Simulator Development Division, Army Training Command",
        "Location": "Hyderabad",
        "Date": "June 30, 2007"
      },
      {
        "Number": "27",
        "Name": "V. Balasubramanian",
        "Title": "“Helicopter cockpit ergonomics – Study of LBP and neck pain in Chetak helicopters",
        "Conference": "RWRTC,HAL",
        "Location": " Bangalore",
        "Date": " February 22, 2007"
      },

      {
        "Number": "28",
        "Name": "V. Balasubramanian",
        "Title": "Bio-signal based HSI for rehabilitation – A RBG Experience",
        "Location": "IIT Kanpur",
        "Date": "January 30, 2007"
      },
      {
        "Number": "29",
        "Name": "V. Balasubramanian",
        "Title": "“Human body modeling – Cervical Spine models",
        "Conference": "JFWTC, General Electric",
        "Location": "Bangalore",
        "Date": "December 27, 2006"
      },
      {
        "Number": "30",
        "Name": "V. Balasubramanian",
        "Title": "Occupant ergonomics – Objective evaluation of ride comfort",
        "Conference": "TVS Motors R&D ",
        "Location": "Hosur",
        "Date": "December 26, 2006"
      },
      {
        "Number": "31",
        "Name": "V. Balasubramanian",
        "Title": "Ergonomics, aesthetics and design",
        "Conference": " D J Academy of Design",
        "Location": "Coimbatore",
        "Date": "November, 11, 2006"
      },
      {
        "Number": "32",
        "Name": "V. Balasubramanian",
        "Title": "Introduction to ergonomics",
        "Conference": " M/s LMW",
        "Location": "Coimbatore",
        "Date": "November, 10, 2006"
      },
      {
        "Number": "33",
        "Name": "V. Balasubramanian",
        "Title": "Frontiers in biomedical engineering",
        "Conference": "Armed Forces Medical College SD",
        "Location": "Pune",
        "Date": "September 23, 2006"
      },
      {
        "Number": "34",
        "Name": "V. Balasubramanian",
        "Title": "“A method for objective evaluation of driver performance",
        "Conference": "Mechanical Transport Training Institute, IAF",
        "Location": " Avadi",
        "Date": "July 13, 2006"
      },
      {
        "Number": "35",
        "Name": "V. Balasubramanian",
        "Title": "CAE applications in development novel orthopaedic implants",
        "Conference": "M/s Sushrut-Adler Orthopaedics",
        "Location": "Pune",
        "Date": "April 28, 2006"
      },
      {
        "Number": "36",
        "Name": "V. Balasubramanian",
        "Title": "“Introduction to Cognitive Ergonomics",
        "Conference": "Keynote lecture presented at the National Conference on Emerging Trends in Instrumentation and Communication Technologies, Sethu Institute of Technology",
        "Location": " Virudhunagar, India",
        "Date": "March 17, 2006"
      },
      {
        "Number": "37",
        "Name": "V. Balasubramanian",
        "Title": "Helicopter Ergonomics – Study of LBP and Neck Pain in Chetak Helicopters",
        "Conference": "HAL Management Academy",
        "Location": "Bangalore",
        "Date": "February 3,2006"
      },
      {
        "Number": "38",
        "Name": "V. Balasubramanian",
        "Title": "DSS in Defense: A Model of Armored Combat,” Logistics – The Challenges Ahead",
        "Conference": "Vellore Institute of Technology",
        "Date": "January, 2006"
      },
      {
        "Number": "39",
        "Name": "V. Balasubramanian",
        "Title": "Understanding Human Brain",
        "Conference": "Invited lecture presented at ThiagarajarCollege of engineering",
        "Location": "Madurai",
        "Date": "September 30, 2005"
      },
      {
        "Number": "40",
        "Name": "V. Balasubramanian",
        "Title": "Human System Interface – Biofeedback in Automation",
        "Conference": "Keynote lecture presented at the National Conference on Intelligent Computing in Communication and Automation, Arulmigu Kalasalingam College of Engineering",
        "Location": "Krishnankoil, India",
        "Date": "April 2, 2005"
      },
      {
        "Number": "41",
        "Name": "V. Balasubramanian",
        "Title": "Biomedical Engineering – A Perspective for Career,”",
        "Conference": "Invited lecture presented at SHASTRA University",
        "Location": "Tanjore , India",
        "Date": "September 25, 2004"
      },
      {
        "Number": "42",
        "Name": "V. Balasubramanian",
        "Title": "Advances in Biomedical Engineering",
        "Conference": "Invited lecture presented atThiagarajar College of engineering",
        "Location": "Madurai",
        "Date": "September 13, 2004"
      },
      {
        "Number": "43",
        "Name": "V. Balasubramanian",
        "Title": "Military Ergonomics",
        "Conference": "Invited lecture at Defense Electronics and Biomedical Engineering Laboratory (DEBEL)",
        "Location": "Bangalore",
        "Date": "April 12,2004"
      },
      {
        "Number": "44",
        "Name": "V. Balasubramanian,",
        "Title": "Biomechanics of Total Knee Replacement",
        "Conference": "Invited lecture presented at Vellore Institute of Technology",
        "Date": "July 25, 2003"
      },
      {
        "Number": "45",
        "Name": "V. Balasubramanian",
        "Title": "“Sports Biomechanics",
        "Conference": "Presented at the Army Sports Institute, Ghorpuri",
        "Location": "Pune",
        "Date": "on July 10, 2003"
      },
      {
      "Number":"46",
      "Name":"V. Balasubramanian,",
      "Title":"Demystifying TN Model – iRAD Background & Implementation",
      "Conference":"Online Course on Traffic Management and Road Safety for Senior Police officers at SVP National Police Academy,",
      "Location":"Hyderabad, India,",
      "Date":"December 22, 2020"
      },
      {
        "Number":"47",
              "Name":"V. Balasubramanian",
              "Tittle":"TN Model of Road Safety,",
              "Conference":"2nd National Conference on Traffic Technologies, CAPT BPRD",
              "Location":"Bhopal, India, ",

              "Date":"February 23, 2020"
        },
        {
          "Number":"48",
                "Name":"V. Balasubramanian,",
                "Tittle":"Data Driven Initiatives in Road Safety,",
                "Conference":"Conference on Safe Mobility and Regional Connectivity in SASEC",
                "Location":"New Delhi,India",
                "Date":"January 21, 2020, "
               },
               {
                "Number":"49",
                      "Name":"V. Balasubramanian,",
                      "Title":"Roads Safety Initiatives and Interventions — A Systems Approach,",
                      "Conference":"International Seminar on Road Safety, AITD and UN ESCAP",
                      "Location":", Chennai, India,",
                      "Date":"April 25, 2019"
                },
                {
                  "Number":"50",
                   "Name":"V. Balasubramanian, ",
                   "Title":"Demystifying Design Thinking – Pathway to Practice",
                   "Conference":"Invited Lecture for Senior Executives of Ford India Limited",
                   "Location":"Chennai, India,",
                   "Date":"November 9, 2019."
                  },
                  {
                    "Number":"51",
                     "Name":"V. Balasubramanian,",
                     "Title":"Digital Initiatives for Manufacturing 4.0 – Long March from Hype to Necessity,",
                     "Conference":"Keynote Lecture at Daimler India Commercial Vehicles,",
                     "Location":"Chennai, India,",
                     "Date":"May , 2019"
                    },
                    {
                      "Number":"52",
                       "Name":"V. Balasubramanian, ",
                       "Title":"Suzhal Management System (SMS) – A Framework for Lean Implementation,",
                       "Conference":"Keynote address at 29th Annual Convention of GMA,",
                       "Location":"Ghaziabad, India,",
                       "Date":"January 19, 2019 "
                      },

                      {
                        "Number":"52",
                         "Name":"V. Balasubramanian,",
                         "Title":"Man in Management – Factoring Humans for Operational Excellence,",
                         "Conference":"Keynote address at Conference on Total Employee for Operational Excellence",
                         "Location":"CII Mysuru, India, ",
                         "Date":"December 18, 2018."
                        },
                        {
                          "Number":"53",
                           "Name":"V. Balasubramanian,",
                           "Title":"Comprehensive Data Driven Road Safety – Framework and Process Plan,",
                           "Conference":"Keynote address at Tamil Nadu Police District Additional Superintendent Conference, Chennai,",
                           "Location":"Chennai,India",
                           "Date":"September 28, 20185"
                          },
                          {
                            "Number":"54",
                             "Name":"V. Balasubramanian,",
                             "Title":"Business Excellence in Engineering – Concepts to Practice,",
                             "Conference":"Engineers Day address at Neyveli Lignite Corporation,",
                             "Location":"Neyveli, India,",
                             "Date":"September 15, 2018."
                            },
                            {
                              "Number":"55",
                               "Name":"V. Balasubramanian,",
                               "Title":"Road Safety Research at RBG Labs – Past, Present and Future,",
                               "Conference":"Keynote Address in the FICCI Road Safety Conference,",
                               "Location":"Chennai, India, ",
                               "Date":"July 31, 2018 "
                              },
                              {
                                "Number":"56",
                                 "Name":"V. Balasubramanian, ",
                                 "Title":"Auditing the 4.0 World – Challenges and Opportunities,",
                                 "Conference":",” Keynote Address in the Goal setting meeting for Internal Auditors of M/s Anand Automotive",
                                 "Location":"Chennai, India, ",
                                 "Date":"January 17, 2018."
                                },
                                {
                                  "Number":"57",
                                   "Name":"V. Balasubramanian,",
                                   "Title":"Meeting Sustainable Development Goals (SDG) in Road Safety – The Tamil Nadu Journey,",
                                   "Conference":"Inaugural Keynote Address at the Annual Conference of the Indian Society of Ergonomics, HWWE 2017",
                                   "Location":"Aligarh Muslim University, Aligarh, India, ",
                                   "Date":"December 5, 2017."
                                  },
                                  {
                                    "Number":"58",
                                     "Name":"V. Balasubramanian,",
                                     "Title":"Integrating Databases & Registry – Past, Present & Future,",
                                     "Conference":"Keynote Address at Indo-Australian Workshop for Trauma and Emergency Care",
                                     "Location":"Chennai, India, ",
                                     "Date":"November 9, 2017."
                                    },
                                    {
                                      "Number":"59",
                                       "Name":"V. Balasubramanian,",
                                       "Title":"Customer Driven Engineering – Leveraging Human Factors & RIP,",
                                       "Conference":"Keynote Address in the Transportation Technical Committee Meeting of Government of Tamil Nadu",
                                       "Location":"Chennai, India,",
                                       "Date":"August 13, 2017"
                                      },
                                      {
                                        "Number":"60",
                                         "Name":"V. Balasubramanian,",
                                         "Title":"Quest for Innovation – Thoughts on Disruption,",
                                         "Conference":"Keynote Address in Innovation Day for M/s CapGemini",
                                         "Location":"Chennai, India,",
                                         "Date":"April 10, 2017."
                                        },
                                        {
                                          "Number":"61",
                                           "Name":"V. Balasubramanian,",
                                           "Title":"Process Excellence Using Suzhal Management System (SMS) – Concepts to Practice,” National Health Mission",
                                           "Conference":"National Health Mission",
                                           "Location":"Chennai, India",
                                           "Date":"February 28, 2017."
                                          },
                                          {
                                            "Number":"62",
                                             "Name":"V. Balasubramanian,",
                                             "Title":"Intelligent Vehicles in Pursuit of Road Safety,",
                                             "Conference":"Keynote Address in Faculty Development Program of Institute of Human Resource Development",
                                             "Location":"Govt of Kerala, Trivandrum,India ",
                                             "Date":"April 27, 2016."
                                            },
                                            {
                                              "Number":"64",
                                               "Name":"V. Balasubramanian,",
                                               "Title":"Challenging the Frontiers – Research @ RBG, IIT Madras,",
                                               "Conference":"TCS Innovation Labs",
                                               "Location":"Kolkata, India,",
                                               "Date":"June 2, 2016."
                                              },
                                              {
                                                "Number":"65",
                                                 "Name":"V. Balasubramanian,",
                                                 "Title":"Human Factors in Product Development and Off Highway Vehicle Design,",
                                                 "Conference":"Keynote Address in SAE Regional Meet,",
                                                 "Location":"M/s TAFE Ltd, Chennai, ",
                                                 "Date":"June 24, 2016."
                                                },
                                                {
                                                  "Number":"66",
                                                   "Name":"V. Balasubramanian,",
                                                   "Title":"Assistive Devices as Educational tools,",
                                                   "Conference":"Keynote Address in Workshop on Disability, Centre for Disability Studies,",
                                                   "Location":"Trivandrum, India, ",
                                                   "Date":"July 8, 2016."
                                                  },
                                                  {
                                                    "Number":"67",
                                                     "Name":"V. Balasubramanian,",
                                                     "Title":"Human Factors in Transportation – Getting to Know the Driver While Driving,",
                                                     "Conference":"",
                                                     "Location":"M/s Rivigo Services Private Ltd, New Delhi",
                                                     "Date":"August 9, 2016."
                                                    },
                                                    {
                                                      "Number":"68",
                                                       "Name":"V. Balasubramanian,",
                                                       "Title":"Essence of Operational Risk Management and Safety Audit,",
                                                       "Conference":"Keynote Address in the Training Program on Safety Audit,",
                                                       "Location":"Regional Labour Institute, Chennai,",
                                                       "Date":"August 25, 2014."
                                                      },
                                                      {
                                                        "Number":"69",
                                                         "Name":"V. Balasubramanian,",
                                                         "Title":"Human System Interfaces – Rehabilitation and Augmentation,",
                                                         "Conference":"Conference on Assistive and Rehabilitation Technologies – Inclusive Technologies for an Improved Quality of Life",
                                                         "Location":"Organized by CII",
                                                         "Date":"August 22, 2014."
                                                        },
                                                        {
                                                          "Number":"70",
                                                           "Name":"V. Balasubramanian,",
                                                           "Title":"Translational Research in Biomedical Engineering in RBG, IIT Madras",
                                                           "Conference":"",
                                                           "Location":"Ordnance Factory, ",
                                                           "Date":"Medak, June 7, 2014."
                                                          }


    ]
  }
  public acknowled = {
    "Acknowled": [
      {
        "Index": "1",
        "Aclogo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Acknowledgement/1.png",
      },
      {
        "Index": "2",
        "Aclogo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Acknowledgement/2.png"
      },
      {
        "Index": "3",
        "Aclogo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Acknowledgement/3.png"
      },
      {
        "Index": "4",
        "Aclogo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Acknowledgement/4.png"
      },
      {
        "Index": "5",
        "Aclogo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Acknowledgement/5.png"
      },
      {
        "Index": "6",
        "Aclogo": "https://ed.iitm.ac.in/~vb/assets/Gallery/Acknowledgement/6.png"
      }
    ]
  }

  public events = {
    "Events": [
      {
        "Index": "1",
        "conferencetitle": "",
        "Downloadlink": "",
        "Cep": "",
        "Title": "",
        "Subtitle": "",
        "Date": "",
        "Objectivies": "",
        "Venueimage": "",
        "Venuetitle": "",
        "Singleimage": "",
        "Imagecontents": "",
        "Coursecontent": "",
        "Locationcontent": "",
        "Locationimage": "",
        "Frombus": "",
        "Tobus": "",
        "Busno": "",
        "Calltaxioperator": "",
        "Phoneno": "",
        "Professorname": "",
        "Address": "",
        "Email": "",
        "Mobilno": "",
        "links": ""

      }

    ]
  }



  public people = [

    {

      "Name": "Dr. Darez Ahamed, IAS",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/DarezAhamed.jpg",
      "designation1": "Former MD NHM",
      "PeronalWebpage": "https://en.wikipedia.org/wiki/Darez_Ahamed"
      // "designation2": "RBG Labs, IIT Madras"

    },


    {
      "Name": "Prof. Indumathy Santhanam MD, DCH",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/indumathy.jpg",
      "designation1": "Former HoD, Pediatric Emergency Care, ICH",
      "designation2": "Former PREM - State Nodal Officer, NHM, TN",
      "PeronalWebpage": "https://www.linkedin.com/in/indumathi-santhanam-a5481518/?originalSubdomain=in"
    },
    {
      "Name": "Thiru Karan Singha, IPS",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/karansingha.jpg",
      "PeronalWebpage": "https://www.tn.gov.in/detail_contact/7095/4",
      "designation1": " Director General of Police (Trg)"
    },
    // {
    //   "Name": "Dr. Gitakrishnan Ramadurai",
    //   "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Gitakrishnan.jpg",
    //   "PeronalWebpage": "https://www.iitm.ac.in/info/fac/gitakrishnan",
    //   "designation1": "Associate Professor",
    //   "designation2": " CE, IIT Madras"
    // },
    // {
    //   "Name": "Dr. R. Lakshmi Narasimhan",
    //   "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/download.jpg",
    //   "PeronalWebpage": "https://www.researchgate.net/profile/Ranganathanp_Lakshmi_Narasimhan",
    //   "designation1": "Director & Head of Neurology, ",
    //   "designation2": "Madras Medical College"
    // },
    // {
    //   "Name": "Dr. V.B Narayana Murthy",
    //   "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/download.jpg",
    //   "PeronalWebpage": "http://www.kauveryhospital.com/Doctor/157/Chennai/Plastic-Surgery/Dr-V-B-Narayana-Murthy",
    //   "designation1": "Adjunct Professor, ",
    //   "designation2": "Applied Mechanics"
    // },
    // {
    //   "Name": "Dr. Bruno Mascarenhas",
    //   "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/download.jpg",
    //   "PeronalWebpage": "https://in.linkedin.com/in/spinebrainsurgeon",
    //   "designation1": "Advisor, ",
    //   "designation2": "RBG Labs, IITM"
    // }
  ];
  public staff = [

    {
      "Name": "Dr.E.R. Rajkumar",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/rajkumar.jpg",
      "Qualification": "Chief Operating Officer & Principal Data Scientist",
      "Joined on": "2020",
      "personalwebpageteam": 0
    },
    {
      "Name": "Dr. Sathish kumar",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/sathish.jpg",
      "Qualification": "Senior Manager and Data Scientist",
      "Joined on": "2018",
      "personalwebpageteam": 1
    },
    {
      "Name": "Mr. Keerthi Kumar B",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/keerthi.jpg",
      "Joined on": "2019",
      "Qualification": "Project Manager",
      "personalwebpageteam": 2
    },
    {
      "Name": "Mr. Manikandan.D",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/mani.jpg",
      "Qualification": "Junior Executive",
      "Joined on": "2019",
      "personalwebpageteam": 3
      // "Area of Interest": "Software Architect",
      // "cvLink": ""
    },
    {
      "Name": "Mr. Kush Trivedi",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/kush.jpg",
      "Qualification": "Senior Project Engineer",
      "Joined on": "2020",
      "personalwebpageteam": 4
      // "Area of Interest": "Software Developer",
      // "cvLink": ""
    },
    //{
      //"Name": "Mr. Vishal Kannan",
      //"ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/vishal.jpg",
     // "Qualification": "Project Engineer",
      //"Joined on": "2020",
     // "personalwebpageteam": 5
    //},
    //{
     // "Name": "Mr. Praveen Kumar",
      //"ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/praveen.jpg",
      //"Qualification": "Project Associate",
      //"Joined on": "2020",
      //"personalwebpageteam": 6
   // },
    //{
     // "Name": "Ms. Lavanya",
     // "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/lavanyak.jpg",
     // "Qualification": "software developer",
     // "Joined on": "2018",
     // "personalwebpageteam": 7
   // },

    {
      "Name": "Dr. Srinath",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Srinath.jpg",
      "Qualification": "Senior Manager",
      "Joined on": "2020",
      "personalwebpageteam": 8
    },
    {
      "Name": "Ms. Minerva",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Minerva.jpg",
      "Qualification": "Senior Manager",
      "Joined on": "2020",
      "personalwebpageteam": 9
    },
    {
      "Name": "Ms. Swathy P",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Swathy.jpg",
      "Qualification": "Senior Manager",
      "personalwebpageteam": 10,
      "Joined on": "2020",
    },
    {
      "Name": "Dr. Nijina M Nazar",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/nijina.jpg",
      "Qualification": "Senior Manager",
      "personalwebpageteam": 11,
      "Joined on": "2020",
    },

    {
      "Name": "Vadhul Krishnan V",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/vadhul.jpg",
      "Qualification": "Project Engineer",
      "personalwebpageteam": 12,
      "Joined on": "2020",
    },
    {
      "Name": "Bhagavath Sinth",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/bhagavath.jpg",
      "Qualification": "Project Engineer",
      "personalwebpageteam": 13,
      "Joined on": "2020",
    },
    {
      "Name": "Praveen R.J",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/praveenrj.jpg",
      "Qualification": "Junior Technician",
      "personalwebpageteam": 14,
      "Joined on": "2020",
    },
    //{
      //"Name": "Giri Goutham",
      //"ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/giri.jpg",
      //"Qualification": "Project Associate",
      //"personalwebpageteam": 15,
      //"Joined on": "2020",
    //},
  ];

  public researchGuidancePhd = [
    {
      "Name": "Dr. Karthi S",
      "Branch": "Biotechnology",
      "Year": "2007",
    },
    {
      "Name": "Dr. Soma Guhathakurtha",
      "Branch": "Biotechnology",
      "Year": "2007",
    },
    {
      "Name": "Dr. Srinivasan J",
      "Branch": "Biotechnology",
      "Year": "2008",
    },
    {
      "Name": "Dr. Adalarasu K",
      "Branch": "Biotechnology",
      "Year": "2010",
    },
    {
      "Name": "Dr. Jagannathan M",
      "Branch": "Engineering Design",
      "Year": "2012",
    },
    {
      "Name": "Dr. Aravind Krishna T",
      "Branch": "Management Studies",
      "Year": "2013",
    },
    {
      "Name": "Dr. Susila Anand V",
      "Branch": "Engineering Design",
      "Year": "2014",
    },
    {
      "Name": "Dr. Mohamed Faisal A",
      "Branch": "Management Studies",
      "Year": "2015",
    },
    {
      "Name": "Dr. Rahul Bhardwaj",
      "Branch": "Engineering Design",
      "Year": "2019",
    },
  ];
  public researchGuidanceMs = [
    {
      "Name": "Swamiprasad G",
      "Branch": "Biotechnology",
      "Year": "2005",
    },
    {
      "Name": "Manjusha J",
      "Branch": "Mechanical Engineering",
      "Year": "2005",
    },
    {
      "Name": "Manika Puri",
      "Branch": "Biomedical Engineering",
      "Year": "2005",
    },
    {
      "Name": "Swapna B",
      "Branch": "Biotechnology",
      "Year": "2007",
    },
    {
      "Name": "Varadhan S. K. M",
      "Branch": "Biotechnology",
      "Year": "2008",
    },
    {
      "Name": "Vadivel S. M",
      "Branch": "Engineering Design",
      "Year": "2016",
    },
    {
      "Name": "Gnanavel S. S",
      "Branch": "Management Studies",
      "Year": "2017",
    },
  ];





  public alumniphd = [
    {
      "Name": "Dr. Karthik S",
      "Title": "EEG based Identification and Classification of Epileptic Seizures using Independent Component Analysis",
      "Branch": "Biotechnology",
      "Year": "2007"
    },
    {
      "Name": "Dr. Soma Guhathakurtha",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/3.jpg",
      "Title": "Processing of Bovine Pericardium as a Biomaterial in Cardio Vascular surgery",
      "Branch": "Biotechnology",
      "Year": "2007"
    },
    {
      "Name": "Dr. Srinivasan J",
      "Title": "Biological Polysignal Based Multimodal Human System Interface",
      "Branch": "Biotechnology",
      "Year": "2008"
    },
    {
      "Name": "Dr. Adalarasu K",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/7.jpg",
      "Title": "Detection of early onset of driver fatigue using multimodal biosignal",
      "Branch": "Biotechnology",
      "Year": "2010"
    },
    {
      "Name": "Dr. Jagannathan M",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/8.jpg",
      "Title": "Evaluation of multimodal analysis of driver fatigue in three different modes",
      "Branch": "Engineering Design",
      "Year": "2012"
    },
    {
      "Name": "Dr. Aravind Krishna T",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/9.jpg",
      "Title": "A Study of ergonimic considerations in shop floor operations management",
      "Branch": "Management Studies",
      "Year": "2013"
    },
    {
      "Name": "Dr. Susila Anand",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/10.jpg",
      "Title": "Development Of Novel Dental Composites By Matrix and Filler Modifications",
      "Branch": "Engineering Design",
      "Year": "2014"
    },
    {
      "Name": "Dr. Mohammed Faizal A",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/11.png",
      "Title": "A Framework for implementing comprehensive lean manufacturing strategies for labour-intensive small and medium enterprises (SMES)",
      "Branch": "Biotechnology",
      "Year": "2015"
    },
    {
      "Name": "Dr. Rahul Bhardwaj",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/15.jpg",
      "Title": "Evaluation of Behavior and Cognitive State to Improve Occupant and Pedestrian Safety",
      "Branch": "Engineering Design",
      "Year": "2018"
    },
    {
      "Name": "Dr. Swathika M",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/15.jpg",
      "Title": "Scientific investigation of mechanics and biosignals generated due to fluid impact on human forehead in shirodhara",
      "Branch": "Applied Mechanics",
      "Year": "2019"
    },
    {
      "Name": "Dr. Sivasankari S",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/15.jpg",
      "Title": "Hi-Fidelity Finite Element Thoracolumbar Spine Development and Assessing it for Autonomous Vehicle and Bio Environment",

      "Branch": "Engineering Design",
      "Year": "2020"
    },
    {
      "Name": "Dr. Sathish kumar S",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/15.jpg",
      "Title": "Investigation of Factors Associated with Road Crashes due to Pedestrian And Occupant Behaviours In Indian Scenarios",
      "Branch": "Engineering Design",
      "Year": "2020"
    },
  ];


  public alumnims = [
    {
      "Name": "Mr. G. Swamiprasad ",
      "Title": "Ergonomic Studies of Manual Bar Bending in Civil Construction ",
      "Branch": "Biotechnology",
      "Year": "2005"
    },
    {
      "Name": "Ms.J. Manjusha ",
      "Title": "Response of Spine to Vehicular Vibration ",
      "Branch": "Mechanical Engineering",
      "Year": "2005"
    },
    {
      "Name": "Mr. Manika Puri ",
      "Title": "Analysis of Foot Sole Soft Tissue Texture in Diabetic Neuropathy",
      "Branch": "Biomedical Engineering",
      "Year": "2005"
    },
    {
      "Name": "Ms. B. Swapna ",
      "Title": "Development, Validation and Application of 3D Finite Element Model of Cervical Spine ",
      "Branch": "Biotechnology",
      "Year": "2007"
    },
    {
      "Name": "Dr. S. K. M. Varadhan ",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/12.jpg",
      "Title": "Analysis of Comfort in Computerized Workplaces ",
      "Branch": "Biotechnology",
      "Year": "2008"
    },
    {
      "Name": "Mr. S. M. Vadivel ",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/13.jpg",
      "Title": "Implementing lean ergonomics in service industry – a case study in indian postal service",
      "Branch": "Engineering Design",
      "Year": " 2016 "
    },
    {
      "Name": "Mr. S.S Gnanavel ",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/23.jpg",
      "Title": "A framework for implementing Lean Ergonomics in labour intensive operations",
      "Qualification": "B.E (Mechanical Engineering)",
      "Joined on": "2014",
      "Branch": "Engineering Design",
      "Year": "2017"
    }

    // {
    //   "Name": "Mr. S.Premananth ",
    //   "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/23.jpg",
    //   "Branch": "Mechanical Engineering",
    //   "Year": "2016"
    // },
  ];

  public alumnidual = [

    {

      "Name": "Maj Sanjeev Sharma",
      "Title": "Ergonomics of Loading Artillery Guns in Combat Tanks",
      "Branch": "Biomedical Engineering",
      "Year": "2004"
    },
    {

      "Name": "K. Adal Arasu",
      "Title": "Effect of Diabetes and Peripheral Neuropathy on Ankle Strategy to Detect Acceleration Perturbation",
      "Branch": "Biomedical Engineering",
      "Year": "2004"
    },
    {

      "Name": "S. Mythili",
      "Title": "Head Acceleration Parameters as a Detection Strategy of Acceleration Perturbation",
      "Branch": "Biomedical Engineering",
      "Year": "2004"
    },
    {

      "Name": "Jayesh S. Zadokar",
      "Title": "Study of Biomechanical Response of a Motorcycle Rider",
      "Branch": "Industrial Tribology",
      "Year": "2004"
    },
    {
      "Name": "Lt Col Shobit Rai",
      "Title": "Effect of Cockpit Ergonomics on Pilot Health: A Biomechanical Evaluation of Chetak Helicopter",
      "Branch": "Biomedical Engineering",
      "Year": "2005"
    },
    {

      "Name": "Lt Col Ashwani Dutt",
      "Title": "Analysis of Flight Induced Muscle Fatigue in Chetak Helicopter Pilot Using EMG",
      "Branch": "Biomedical Engineering",
      "Year": "2005"
    },
    {

      "Name": "M. Gopi",
      "Title": "EMG Based Human System Interface",
      "Branch": "Biomedical Engineering",
      "Year": "2005"
    },
    {

      "Name": "D. Shanti",
      "Title": "Ergonomic Study of Computer Game Players",
      "Branch": "Biomedical Engineering",
      "Year": "2005"
    },
    {

      "Name": "Inderpal Singh Varun",
      "Title": "Numerical Simulation of a Bearingless Centrifugal Blood Pump",
      "Branch": "Biomedical Engineering",
      "Year": "2005"
    },
    {
      "Name": "V. Sai Praveen",
      "Title": "Accident Reduction and Productivity Enhancement in a Manufacturing Industry – An Ergonomic Approach",
      "Branch": "Mechanical Engineering",
      "Year": "2006"
    },
    {
      "Name": "Abhishek Goyal",
      "Title": "Spring Loaded Inverted Pendulum Running – Simple Approximate Solution",
      "Branch": "Mechanical Engineering",
      "Year": "2006"
    },
    {

      "Name": "Chakradhar Naidu",
      "Title": "Investigation of Bus Driver Cabin Ergonomics",
      "Branch": "Mechanical Engineering",
      "Year": "2006"
    },
    {

      "Name": " Rahul Regulapati",
      "Title": "A Neuromusculoskletal Model of Lower Back to Predict Erector Spinae Muscle Force from EMG Signal – Development and Validation",
      "Branch": "Biotechnology",
      "Year": "2007"
    },
    {

      "Name": "Ruchi Gupta",
      "Title": "Processing of Xenograft towards Development of Micro Free Natural Biomaterial for Clinical Applications",
      "Branch": "Biotechnology",
      "Year": "2007"
    },
    {

      "Name": "B. Ananthakrishnan",
      "Title": "Characterization and Cell Seeding of Biological Scaffold ",
      "Branch": "Biotechnology",
      "Year": "2007"
    },
    {

      "Name": "Chandreshwar Rao",
      "Title": "Design Evaluation of Cervical Spine Stabilization Implants",
      "Branch": "Civil Engineering",
      "Year": "2007"
    },
    {
      "Name": "Vijay Bhaskar Reddy",
      "Title": "The use of EMG for Erector Spinae Muscle Force Prediction During Manual Lifting",
      "Branch": "Biotechnology",
      "Year": "2008"
    },
    {
      "Name": "Purvi Gupta",
      "Title": "Design and Develop an Aortic valve using Bioprosthetic material using a computational model",
      "Branch": "Biotechnology",
      "Year": "2009"
    },
    {
      "Name": "Srikar Chindada",
      "Title": "CFD Simulation of the Tri Leaflet Aortic Valve and Study of Pressures on the Leaflets during Aortic Stenosis",
      "Branch": "Biotechnology",
      "Year": "2010"
    },
    {
      "Name": "Bharath Kumar Gudem",
      "Title": "Determination of Stresses in the Femur-Pelvis Region to Understand the Ride Comfort on Motor Bike",
      "Branch": "Engineering Design",
      "Year": "2011"
    },
    {
      "Name": "D Jithender",
      "Title": "Developing and Validating Patient Specific Finite Element Model of the Lumbosacral Spine (L1-S1)",
      "Branch": "Engineering Design",
      "Year": "2012"
    },
    {
      "Name": "Imran Parvez A L",
      "Title": "Generation of 3D Parametric Finite Element modeling of Thoracolumbar Spine for Dynamic Analysis",
      "Branch": "Engineering Design",
      "Year": "2012"
    },
    {
      "Name": "Siddhartha Samanath",
      "Title": "Cognitive Evaluation of Consumer Response to Online Advertisement",
      "Branch": "Engineering Design",
      "Year": "2013"
    },
    {
      "Name": "Saurav Roy",
      "Title": "Cognitive Evaluation of the Difference in Perception Between Print and TVC Advertisements",
      "Branch": "Engineering Design",
      "Year": "2013"
    },
    {
      "Name": "Ravi Kumar V",
      "Title": "Development of Automated Acoustical Tap Testing System",
      "Branch": "Engineering Design",
      "Year": "2014"
    },

    {
      "Name": "Atul Kumar Singh",
      "Title": "Cognitive Task Analysis in Neuromarketing using EEG",
      "Branch": "Engineering Design",
      "Year": "2014"
    },
    {
      "Name": "Sumedh P. Inje",
      "Title": "Cognitive Studies on Perceptional Activity",
      "Branch": "Engineering Design",
      "Year": "2014"
    },
    {
      "Name": "Raunaq M Banga",
      "Title": "Human Factors in Product Design",
      "Branch": "Engineering Design",
      "Year": "2015"
    },
    {
      "Name": "Anand Parikh",
      "Title": "Developing Disruptive Instrumentation for Micro-Surgery",
      "Branch": "Engineering Design",
      "Year": "2015"
    },
    {
      "Name": "Prem Kumar Dharmani",
      "Title": "Human Factors and Radiation Safety in Commonly Used Radiation Based Diagnostic Devices",
      "Branch": "Engineering Design",
      "Year": "2015"
    },
    {
      "Name": "Balaji S",
      "Title": "Biomechanics Research on Wicket-Keeping",
      "Branch": "Engineering Design",
      "Year": "2016"
    },
    {
      "Name": "Kunigiri Venkatesh",
      "Title": "Unobtrusive stress detection of smart phone users",
      "Branch": "Engineering Design",
      "Year": "2017"
    },
    {
      "Name": "Aswin R",
      "Title": "Effect of Music on Driver Stress",
      "Branch": "Engineering Design",
      "Year": "2017"
    },
    {
      "Name": "Nivea Valsaraj",
      "Title": "Design of Test Battery for Conventional Personality Type",
      "Branch": "Engineering Design",
      "Year": "2017"
    },
    {
      "Name": "Karthikeyan R",
      "Title": "Suzhal Cell – A Novel Comprehensive Framework for Implementing Lean Ergonomics",
      "Branch": "Engineering Design",
      "Year": "2018"
    },
    {
      "Name": "Chaitanya Repakula",
      "Title": "Attention Analysis using EEG While Driving",
      "Branch": "Engineering Design",
      "Year": "2018"
    },
    {
      "Name": "Tanay Garg",
      "Title": "Increasing Process Efficiency of Fracture Plate Fixation Surgeries",
      "Branch": "Engineering Design",
      "Year": "2018"
    },
    {
      "Name": "Ajit Raghavendra",
      "Title": "Real-Time Tracking System for Radial and Ulnar Deviation",
      "Branch": "Engineering Design",
      "Year": "2019"
    },
    {
      "Name": "Bethi Yeshwanthi",
      "Title": "Classification of mental Stress using EEG Signals",
      "Branch": "Engineering Design",
      "Year": "2019"
    },
    {
      "Name": "Surabhi Vineeth Rao",
      "Title": "Mobile Application for Tremor Analysis",
      "Branch": "Engineering Design",
      "Year": "2019"
    },
    {
      "Name": "Zenith",
      "Title": "Data Preprocessing and Decision Tree Classification for Prediction of Road Accident Severity",
      "Branch": "Engineering Design",
      "Year": "2019"
    },

  ];

  public alumnibtech = [
    {
      "Name": "Avartan A. Bokil",
      "Title": "Back problems in civil construction workers – biomechanical analysis of bar bending",
      "Branch": "Civil Engineering",
      "Year": "2003"
    },
    {
      "Name": "Krishna V. Raghavan",
      "Title": "EEG Based Monitoring of Consciousness",
      "Branch": "Biotechnology",
      "Year": "2006"
    },
    {
      "Name": "Ashutosh Gupta",
      "Title": "EEG Based Study of Driver Alertness in Simulated Driving",
      "Branch": "Biotechnology",
      "Year": "2006"
    },
    {
      "Name": "Sumakanth Challa",
      "Title": "Comparison of the Effect of Carnatic and Heavy metal Music on CNS",
      "Branch": "Biotechnology",
      "Year": "2007"
    },
    {
      "Name": "K. M. Ashwin Kumar",
      "Title": "Effect of Music while Running on Treadmill",
      "Branch": "Biotechnology",
      "Year": "2008"
    },
    {
      "Name": "Banu Prasad",
      "Title": "Muscle Training Game for Rehabilitation",
      "Branch": "Biotechnology",
      "Year": " 2008 "
    },
    {
      "Name": "Prabhu Kiran",
      "Title": "Rehabilitation Engineering",
      "Branch": "Biotechnology",
      "Year": "2008"
    }
  ];

  public phdstudents = [
    {
      "Name": "Mr. Venkataraman G, (IPS)",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/download.jpg",
      "Qualification": "ADGP, Cyber Crime Wing, O/o the Director General of Police, Chennai",
      "Joined on": "2018",
      "personalwebpage": 0
      // "Area of Interest": "Product Design and Manufacturing",
      // "cvLink": "CV/2_hari.pdf"
    },



    {
      "Name": "Mr. Rangam Harikrishna",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Rangam.jpg",
      "Qualification": "M.Tech (Industrial Design)",
      "Joined on": "2018",
      "personalwebpage": 1,
      "Area of Interest": "Product Design and Manufacturing",
      "cvLink": "CV/2_hari.pdf"
    },
    {
      "Name": "Mr. Harikrishna Manager, Ashok Leyland",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Harikrishna.jpg",
      "Qualification": "B.E (Mechanical Engineering) ",
      "Joined on": "2018",
      "personalwebpage": 2,
      "Area of Interest": "Transportation Human Factors",
    },
    {
      "Name": "Ms. Priya Natarajan  ",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/priya.jpg",
      "Qualification": "M.Tech.(Biomedical Engineering)",
      "personalwebpage": 3,
      "Joined on": "2017",
      "Area of Interest": "Biomedical Devices and Rehabilitation Engineering",
      "About": "Main research interests lie in Human-machine/computer-interfaces and their application in Clinical Neurosciences, Human Factors, Artificial Intelligence Biomedical Signal Analysis, Wearable Ubiquitous Computing"
    },
    {
      "Name": "Ms. Minerva",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Minerva.jpg",
      "Qualification": "M.Tech.(Biomedical Engineering)",
      "Joined on": "2014",
      "personalwebpage": 4,
      "Area of Interest": "Cognitive sciences, EEG Analysis, Sustained attention",
      "About": "Mind wandering! An unavoidable phenomenon experienced by everyone at any time. My research area focuses on identifying the factors contributing to mind wandering and analyzing the underlying electrophysiological changes due to mind wandering."
    },
    {
      "Name": "Ms. Swathy P",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Swathy.jpg",
      "Qualification": "M.Tech.(Biomedical Engineering) ",
      "personalwebpage": 5,
      "Joined on": "2014",
      "Area of Interest": "Biosignal processing",
      "About": "Distress is characterized by episodes of anxiety and depression. A transition from stress to distress has so far been studied through questionnaires and empirical evidence of the same is yet to be established. I am interested in determining the onset for distress from physiological manifestation. Research Interest: Bio Signal Processing, Psycho Physiology"
    },
    // {
    //   "Name": "Mr. Sathish kumar",
    //   "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/14.jpg",
    //   "Qualification": "M.Des.(Mechanical Systems Design)",
    //   "Joined on": "2014",

    //   "personalwebpage": 6,
    //   "Area of Interest": "Human factors in Transportation, Road accident analysis, Road Safety, Ergonomics for improving productivity, Industrial Ergonomics, Occupational ergonomics, Human factors in Design",
    //   "About": "Mr. Sathish kumar Sivasankaran is currently Doctoral Student at the Rehabilitation Bioengineering Group, Department of Engineering Design, IIT Madras. His research and work interest broadly spans the field of Human factors and Ergonomics. Currently he works on Human factors in Transportation, Road accident analysis, Road Safety, Ergonomics for improving productivity, Industrial Ergonomics and Occupational ergonomics.",
    //   "Research proposal": "Title : Evaluating the fitness of long distance drivers through Checkout simulator",
    //   "Abstract": "Roadways is an important mode of transportation of goods and services across the world. In developing countries like India, there is a large impetus given to increase the limited network of roads. However a major impediment severely impacting the road transportation are the accidents and its associated cost. Latest road accidents report published by of National Crime Research Bureau (2016), shows that 4,64,674 road accidents happened in India resulting in 4,82,389 injuries and 1,48,707 deaths in India. It is reported that about 77% of these accidents happen due to driver error (MoRTH, 2016). Typically it is drivers who drive long distances who are at a higher risk of being in a fatigue related accidents. In this study, we are proposing to evaluate fitness of long distant drivers through a low cost checkout simulator system. A brief overview of previous studies to determine fitness of drivers involving physiological signals will be presented. Advantages and limitations of the previous studies will be presented. Building on prior work done in this field at RBG, IIT Madras, a conceptual need and efficacy working proposed design of the low-cost simulator will be presented.",
    // },
    // {
    //   "Name": "Ms. Sivasankari ",
    //   "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/18.jpg",
    //   "Qualification": "B.E (Production Engineering) ",
    //   "personalwebpage": 7,
    //   "Joined on": "2012",
    //   "Area of Interest": "Spine modeling ",
    //   "About": "Development and validation of Hi-fidelity 3D Finite Element Modelling and analysis of Lumbar & Thoracic Spine. This Research focuses on converting the medical images into the mechanical simulation model, in which the model is aimed at representing the high Fidel bio-mechanical behavior, as that of a human spine. Fidelity is to gain importance in terms of physiological mechanism and material behavior, by primarily developing and validating it, using the finite element tool"
    // },
    {
      "Name": "Mr. Mohanraj B, Mahindra & Mahindra",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Mohanraj.jpg",
      "Qualification": "B.E (Automobile Engineering) ",
      "Joined on": "2016"
    }
  ];
  public msscholers = [

    {
      "Name": "Mr. Mohanraj B, Mahindra & Mahindra ",
      "ProfilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/25.jpg",
      "Qualification": "B.E (Automobile Engineering) ",
      "Joined on": "2016"
    }

  ];
  public Dual = [{
    "name": "Mr. Jaideep",
    "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/download.jpg",
    "qualification": "DDP (Biomedical Engineering)",
    "joinedOn": "2020",
    "areaOfInterest": "Hand Motion Data Acquisition System",
    "cvLink": ""
  },
  {
    "name": "Mr. Apoorv",
    "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/download.jpg",
    "qualification": "DDP (Biomedical Engineering)",
    "joinedOn": "2020",
    "areaOfInterest": "Data Pre-Processing and Predictive Model Building",
    "cvLink": ""
  },
  {
    "name": "Mr. Kapilesh",
    "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/download.jpg",
    "qualification": "DDP (Biotech)",
    "joinedOn": "2020",
    "areaOfInterest": "Exploratory Data Analytics",
    "cvLink": ""
  },
  {
    "name": "Ms. Nandhini",
    "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/download.jpg",
    "qualification": "DDP (Biomedical Engineering)",
    "joinedOn": "2020",
    "areaOfInterest": "Data Analytics in Transportation",
    "cvLink": ""
  },

  ];
  public Intern = [
    {
      "name": "Ms. Pragya Ananth",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Pragya.jpg",
      "qualification": " Integrated M. Sc. Data Science (from 2018)",
      "joinedOn": "2020",
      // "areaOfInterest": "Biomedical device and product design, Rehabilitation engineering.",
      "cvLink": ""
    },
    {
      "name": "Ms. Manasa Pendyala",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Manasa.jpg",
      "qualification": " Integrated M. Sc. Data Science (from 2018)",
      "joinedOn": "2020",
      // "areaOfInterest": "Biomedical device and product design, Rehabilitation engineering.",
      "cvLink": ""
    }
  ];

  public dental = [
    {

      "Image": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/5/1.jpg"
    }

  ];
  public pericardial = [
    {

      "Image": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/3/1.jpg"
    },
    {
      "Image": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/3/2.jpg"
    },
    {
      "Image": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/3/3.jpg"
    },
    {
      "Image": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/3/4.jpg"
    },
    {
      "Image": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/3/5.jpg"
    },
    {
      "Image": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/3/6.jpg"
    },
    {
      "Image": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/3/7.jpg"
    },
    {
      "Image": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/3/8.jpg"
    }
  ];
  public surgery = [
    {

      "Image": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/4/1.jpg"
    }

  ];


  public newSinglesample = [
    {
      "Title": "Data-driven strategies proposed to improve road safety in State",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/27",
      "NewsArticlesCount": 1,
      "Link0": "https://www.thehindu.com/news/national/tamil-nadu/data-driven-strategies-proposed-to-improve-road-safety-in-state/article36996169.ece"
    },
    {
      "Title": "IIT-M working on data-based plan for road safety in TN",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/28",
      "NewsArticlesCount": 1,
      "Link0": "https://www.thehindubusinessline.com/news/national/iit-madras-develops-data-based-strategy-for-road-safety-in-tn/article36980548.ece"
    },
    {
      "Title": "IIT-M move to make to make roads safer",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/29",
      "NewsArticlesCount": 1,
      "Link0": "https://timesofindia.indiatimes.com/city/chennai/iit-madras-move-to-make-roads-safer/articleshow/87010416.cms"
    },
    {
      "Title": "IIT-Madras organises workshop to boost road safety in Tamil Nadu",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/30",
      "NewsArticlesCount": 1,
    },
    {
      "Title": "Data-driven Strategies to enhance road safety in TN",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/31",
      "NewsArticlesCount": 1,
      "Link0": "https://newstodaynet.com/index.php/2021/10/15/data-driven-strategies-to-enhance-road-safety-in-tn/"
    },
    {
      "Title": "TAEI helps reduce trauma of road accident deaths",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/26",
      "NewsArticlesCount": 1,
    },
    {
      "Title": "On spot recording of road accidents to be rolled out in six states in first phase",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/24",
      "NewsArticlesCount": 2,
    },
    {
      "Title": "IITM is going to curb/control deaths due to road accidents",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/25",
      "NewsArticlesCount": 1,
    },




    {
      "Title": "TN model can help reduce road fatalities by 30%",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/23",
      "NewsArticlesCount": 1,
    },

    {
      "Title": "Rajasthan will follow TN roadmap to put brakes on accidents",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/22",
      "NewsArticlesCount": 1,
      "Link0": "https://timesofindia.indiatimes.com/city/jaipur/raj-will-follow-tn-roadmap-to-put-brakes-on-accidents/articleshow/74233513.cms"
    },
    {
      "Title": "GoI launches IRAD for Road Safety",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/21",
      "NewsArticlesCount": 2,
      "Link0": "https://www.thehindu.com/news/national/govt-launches-road-accident-database/article30559706.ece",
      "NewsArticles1": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/19",
      "NewsArticlesCount2": 1,
      // "Link1": "https://www.thehindu.com/news/national/govt-launches-road-accident-database/article30559706.ece",
      "NewsArticles2": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/18",
      "NewsArticlesCount3": 2,
      "Link2": "https://www.jatinverma.org/govt-launches-road-accident-database",
      "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/18",
      "EventPhotosCount": 4
    },
    {
      "Title": "Presentation of Intelliseat™ & capacitive ECG System at ARTECH Defence Seminar ",
      "Content": "",
      "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/20",
      "EventPhotosCount": 2

    },



    {
      "Title": "Investigation of Pedestrian Accidents and its causes in Tamil Nadu",
      "Content": "Pedestrian safety is of growing concern with an increasing number of traffic accidents, especially in developing economies like India.In 2017, there were 20, 457 pedestrian fatalities in India.Pedestrian crashes have also become a key concern in the state of Tamilnadu, India, due to the high percentage of deaths.If the available datasets are large and complex, identifying key factors is a challenging task.In this study, Multiple Correspondence Analysis(MCA), an exploratory data analysis technique wasused to explore the roadway, traffic, crash, and pedestrian- related variables influencing pedestriancrashes.This study used the data from Government of Tamilnadu Road Accident Traffic Management System(RADMS) database, to analyse accident data of nine years(2009–2017) related to pedestrian crashes.The results of the study show that crashes occurring on the express highways on a multilane road are often associated with hit - and - run behaviour among drivers.Factors such as lighting conditions, location, pedestrian behaviour, crossings, and physical separation are also significantly contributing to pedestrian crashes.The key advantage of MCA is that it identifies a possible association between various contributing factors.The findings from this study will be useful for state transport authorities to improve countermeasures for mitigating pedestrian crashes and fatalities.",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/17",
      "NewsArticlesCount": 3,
      "Link": "https://www.tandfonline.com/doi/full/10.1080/17457300.2019.1681005"

    },
    {
      "Title": "Enforcement of traffic rules makes Chennai streets a lot safer",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/16",
      "NewsArticlesCount": 3,
      "Link0": "https://www.thehindu.com/news/cities/chennai/enforcement-of-traffic-rules-makes-city-streets-a-lot-safer/article30153397.ece"
    },
    {
      "Title": "Demystifying Design Thinking - A Pathway to Practice",
      "Content": "Talk at Ford Global Technology Business Centre on 29/11/2019 in Chennai.",
      "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/19",
      "EventPhotosCount": 3
    },

    {
      "Title": "Spotlight on Tamil Nadu’s data-driven road safety initiatives",
      "Content": "According to the National Crime Records Bureau, out of 1,47,913 accident deaths in 2017 across the country, 16,517 took place in Tamil Nadu. In other words, the state accounted for nearly 11% of all road fatalities in the country. In the following year, the number of deaths fell to 12,213. This is a drop of 24.39%.",
      "Content1": "Senior officials from the Union Ministry of Road Transport and Highways, Additional Director General of Police of Karnataka, Rajasthan, Maharashtra and Madhya Pradesh were at the Indian Institute of Technology-Madras (IIT-M) to understand the Tamil Nadu model of integrated data-driven road safety initiatives. The Tamil Nadu team had the DGP and several senior police officials, Trauma Commissioner from the Health Department and senior officials from the highways and transport departments, and IIT-M faculty.",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/14",
      "NewsArticlesCount": 1,
      "Link0": "https://www.thehindu.com/news/cities/chennai/spotlight-on-tamil-nadus-data-driven-road-safety-initiatives/article28068134.ece",
      "NewsArticles1": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/15",
      "NewsArticlesCount2": 9,
      "Link1": "https://www.thebetterindia.com/186803/tamil-nadu-road-accidents-iit-supreme-court-india/"

    },
    {
      "Title": "Indian Railway Service of Mechanical Engineers (IRSME) 2017 batch training at IIT Madras",
      "Content": "Indian Railway Service of Mechanical Engineers (IRSME) 2017 batch participated in the Continuing Education Program on 'Operational Excellence through Lean Principles using SMS', organized by the Department of Engineering Design during 03-28 June, 2019.",
      "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/16",
      "EventPhotosCount": 5
    },
    {
      "Title": "Transportation Accident Reporting App (TARA) - Pilot Deployment and Training at Kanchipuram and Dharmapuri",
      "Content": "TARA is a comprehensive accident reporting system developed by RBG Labs, IIT Madras as an easy to use RADMS interface to further the data-driven transportation safety framework developed by RBG Labs. All key stakeholder Departments, i.e., Highways, Transport, Police, Health and Education contribute to the TARA ecosystem as either data provider or user for the furtherance of a common goal of zero accidental deaths.",
      "Content1": "Pilot testing of TARA mobile interface for RADMS was deployed in two districts, i.e., Kanchipuram (39 stations) and Dharmapuri (20 stations). An 8-inch tablet with a hard cover was procured through ELCOT and the devices were handed over to district police Headquarters at Kanchipuram and Dharmapuri after installing TARA interface.",
      "Content2": "Hands-on training for entering accident data based on real life accidents by looking at accident videos were provided to the police officers. A continuous support in clarifying doubts and difficulties in entering data through TARA interface is being provided by the RBG Labs team",
      "Content3": "Multiple inputs on implementation are being identified from the pilot studies to make the iRAD ecosystem work better. The success of any monitoring system will be in its ability to be continuously evolving based on feedbacks.",
      "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/15",
      "EventPhotosCount": 2
    },
    {
      "Title": "Anand Excellence in Manufacturing (AMX) B7 batch training at IIT Madras",
      "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/10",
      "EventPhotosCount": 2
    },
    {
      "Title": "Launch of TAEI App developed at IITM",
      "Content": "An International Workshop on Trauma Care Systems jointly organized by Tamil Nadu Accident and Emergency Care Initiative, Govt of Tamil Nadu (TAEI), National Trauma Research Institute, Australia (NTRI) and Indian Institute of Technology, Madras (IIT-M)",
      "Link": "http://www.taeionline.com/ntri-workshop-9th-10th-november-iit-madras-research-park/14",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/2",
      "NewsArticlesCount": 3
    },
    {
      "Title": "NTRI Workshop 9th & 10th November, IIT Madras Research Park",
      "Content": "An International Workshop on Trauma Care Systems jointly organized by Tamil Nadu Accident and Emergency Care Initiative, Govt of Tamil Nadu (TAEI), National Trauma Research Institute, Australia (NTRI) and Indian Institute of Technology, Madras (IIT-M)",
      "Link": "http://www.taeionline.com/ntri-workshop-9th-10th-november-iit-madras-research-park/14",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/2",
      "NewsArticlesCount": 3


    },
    {
      "GalleryIndex": 1,
      "Title": "Launch of Intelliseat - a joint venture from IIT-M and Harita Seating System Ltd.",
      "Content": "Intelliseat was developed at IIT Madras with collaborative research with Harita Seating System Ltd. The seat incorporates sensors that monitor driver fatigue and provide early warnings. This device can help prevent accidents and bring down accident rate",
      "Link": "",
      "Video": "https://www.youtube.com/watch?v=QEUFR7swGcc&t=1s",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/1",
      "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/1",
      "NewsArticlesCount": 7,
      "EventPhotosCount": 26
    },
    {
      "Title": "IIT Madras signs MOU with chennai-based SynkroMax Biotech Pvt. Ltd. (SMBPL) for technology transfer",
      "Content": "  IIT Madras and SynkroMax Biotech have signed a technology transfer agreement for a Tissue Engineered Bovine Pericardial Patch.The Indian Institute of Technology Madras has signed a memorandum of understanding (MoU) with Chennai-based SynkroMax Biotech (SMBPL) on November 2, 2016 for a Technology Transfer.The MoU was signed by Prof.Krishnan Balasubramanian, Dean, ICSR, IIT Madras and C V Seshadri, MD, SMBPL.Researchers at IIT Madras have developed a tissue engineered indigenous pericardial patch which is superior in many aspects having the property of regeneration and integration in the body and ease of handling by the surgeons. In a way, it is a lifesaving implant for critical cardiovascular patients with anatomical and structural deficiency in the system. In future, it may be applicable for many other areas of surgical practice for its inherent properties. It is said to be the first-of-its-kind in India and the whole of Asia.",
      "Link": "http://www.ableindia.in/frontend/briefnews/240"

    },
    {
      "Title": "IIT-M researchers develop indigenous pericardial patch for cardiovascular patients",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/3",
      "NewsArticlesCount": 8
    },
    {
      "Title": "Clamp from IIT-M to help surgeons suture blood vessels",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/4",
      "NewsArticlesCount": 1
    },
    {
      "Title": "IIT researcher patents painless dental composite",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/5",
      "InterviewLink": "https://youtu.be/Mum68WLSRdU",
      "NewsArticlesCount": 1
    },
    {
      "Title": "IITM - RBG Lab transfers road safety technology to Harita Seating System Limited",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/6",
      "NewsArticlesCount": 12
    },
    {
      "Title": "News 7 interview - Prof.Venkatesh Balasubramanian",
      "Content": "Driver fatigue behind rampant road accidents on Highways, Maiyam - News7 Tamil",
      "Link": "https://www.youtube.com/watch?v=_Q9K9jcEPpY&list=PLeD8z5CshgSGprfczWL1Uh4THJ9aEWhuA"
    },
    {
      "Title": "RATH 2015 - Media coverage",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/11",
      "NewsArticlesCount": 5
    },
    {
      "GalleryIndex": 5,
      "Title": "National Conference on Recent Advances in Transportation Human Factors",
      "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/5",
      "EventPhotosCount": 33
    },
    {
      "Title": "Brain Wakes Up to Modi Wave Faster than RaGa - article in The New Indian Express",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/7",
      "NewsArticlesCount": 1
    },
    {
      "Title": "IIT-M’s Wake-up call for tired drivers - article in Times of India",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/8",
      "NewsArticlesCount": 2
    },
    {
      "Title": "Detecting motorcycle rider local physical fatigue and discomfort using surface electromyography and seat interface pressure",
      "Content": "Whilst motorcycling is an activity of pleasure in most parts of the world, in India it is a regular mode of commuting. Incidence of fatigue is substantially higher among motorcycle riders than drivers of other modes of transport. The objective of this study was to detect physical fatigue due to motorcycle riding for an hour using surface electromyography (sEMG) and seat interface pressure. Twenty healthy male participants performed 60 min of motorcycle riding in a low traffic density environment. Muscle activity was recorded bilaterally from extensor carpi radialis (ECR), biceps brachii (BB), trapezius medial (TM), sternocleldomastoid (S) latissimus dorsi (LD) and erector spinae (ES) muscle groups. Interface seat pressure distribution was monitored using a pressure mapping system. Results showed that participants have significant (p < 0.05) physical fatigue in TM, LD and ES muscle groups during 60 min of motorcycle riding. Seat pressure distribution was found to be non-uniform during the course of motorcycling. Results suggest that the impact on local physical fatigue and seat discomfort are probably due to static seating demand and prolonged sitting posture balance required to ride the motorcycle for an hour.",
      "Link": "http://www.sciencedirect.com/science/article/pii/S1369847813001393"
    },
    {
      "Title": "Ergonomically redesigned Postal CRC - article in Hindu",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/9",
      "NewsArticlesCount": 1
    },
    {
      "Title": "Muscle fatigue based evaluation of bicycle design",
      "Content": "Bicycling posture leads to considerable discomfort and a variety of chronic injuries. This necessitates a proper bicycle design to avoid injuries and thereby enhance rider comfort. The objective of this study was to investigate the muscle activity during cycling on three different bicycle designs, i.e., rigid frame (RF), suspension (SU) and sports (SP) using surface electromyography (sEMG). Twelve male volunteers participated in this study. sEMG signals were acquired bilaterally from extensor carpi radialis (ECR), trapezius medial (TM), latissimus dorsi medial (LDM) and erector spinae (ES), during 30 min of cycling on each bicycle and after cycling. Time domain (RMS) and frequency domain (MPF) parameters were extracted from acquired sEMG signals. From the sEMG study, it was found that the fatigue in right LDM and ES were significantly (p < 0.05) higher in SP bicycle. This was corroborated by a psychophysical assessment based on RBG pain scale. The study also showed that there was a significantly lesser fatigue with the SU bicycle than the RF and SP bicycles.",
      "Link": "http://www.sciencedirect.com/science/article/pii/S0003687013000859"
    },
    {
      "Title": "Effect of resin chemistry on depth of cure and cytotoxicity of dental resin composites",
      "Content": " New dental composite restorative materials are being introduced aiming to overcome the disadvantages of contemporary materials. Hence there is a need to analyze the critical properties of these composites to aid in clinical application. This study aims to comparatively analyze the degree of conversion (DC), residual reactivity (DBC/reactivity) and cytotoxicity of 2 composites based on different resin chemistry. Ceram X and Filtek P90 were used in the study to prepare disc shaped samples of 2 mm thickness and 4 mm diameter. The samples for cytotoxicity were cured for 40 s and those of Fourier Transform Infra-red Spectroscopy (FTIR) (DBC/reactivity and DC) for 5 s, 10 s, 20 s and 40 s, at an average intensity of 800 mW/cm2 with Quartz–Tungsten–Halogen (QTH) light. DC was calculated in 60–100 μm thick and 6 mm diameter samples. Double bonds concentration/reactivity was measured in approximately 80 μm thick sections prepared from the 2 mm thick discs using a hard tissue microtome. The cell viability was scored by Trypan blue exclusion staining technique at 24 h and 48 h. Both composites showed a progressive increase in double bonds/reactivity as the distance from curing probe increased which was inversely proportional to the curing time. The DC of Filtek P90 was 20% and 96% and that of Ceram X 33% and 50% at 5 s and 40 s, respectively. Ceram X showed statistically significantly higher cell viability score at both 24 h and 48 h than Filtek P90. The results were statistically analyzed using non-parametric Kruskal–Wallis, Mann–Whitney U and Wilcoxon Signed Ranks tests. Though DC plays an important role in biocompatibility of dental composites, other factors like elution may play a significant role and hence need further evaluation.",
      "Link": "http://www.sciencedirect.com/science/article/pii/S0921510713003140"
    },
    {
      "Title": "Turning the tables on bad posture - article in business line",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/10",
      "NewsArticlesCount": 2
    }
  ];
  public award = [
    {
      "Title": "Tamil Nadu receives Best Performance in Road Safety award",
      "Content": "",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/20",
      "NewsArticlesCount": 2
    },
    {
      "Title": "Launch of CEmONC App developed at IITM ",
      "Content": "Comprehensive Emergency Obstetric and New born Care App (CEmONC App) was officially launched by Dr. C. Vijaya Baskar, Minister for Health and Family Welfare Department on 15.08.2018. The app was also awarded as one of the best interventions by the Minister for Health and Family Welfare Department",
      "NewsArticles": "https://ed.iitm.ac.in/~vb/assets/Gallery/News/12",
      "NewsArticlesCount": 2
    },
    {
      "Title": "Prof. Venkatesh Balasubramanian wins 'Congress Competition for Practice Examples' of IEA",
      "Content": "Prof. Venkatesh Balasubramanian, Department of Engineering Design has won the 'Congress Competition for Practice Examples’ of the 20th Congress of the International Ergonomics Association (IEA) at Florence, Italy.  This award was for a case study,  “Tamil Nadu Accident & Emergency care Initiative (TAEI) - Impact of Lean Ergonomics on Emergency Care.”",
    },
    {
      "Title": "TAEI initiative wins Best Practices Award by Chief Minister of Tamil Nadu",
      "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/13",
      "EventPhotosCount": 1
    },
    {
      "Title": "Harita Intelliseat has won the Apollo CV award 2018",
      "Content": "Harita Intelliseat was developed as a joint venture between Indian Institute of Technology Madras and Harita Seatings Systems Ltd",
      "Link": "",
      "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/9",

      "EventPhotosCount": 1
    },
    // {
    //   "Title": "Dr. Venkatesh Balasubramanian appointed as Advisor to TAEI",
    //   "Content": "Dr. Venkatesh Balasubramanian appointed as Advisor to Tamil Nadu Accident and Emergency Care Initiative (TAEI) initiative by National Health Mission, Tamil Nadu"
    // }
  ];



  public eventsWebpage = [
    {
      "eventNo": "1",
      "buttonName": "RATH 2015",
      "headerTitle": "National Conference on",
      "Title": "Recent Advances in Transportation Human Factors – Driver Performance Monitoring",
      "subTitle": "",
      "logoLinks": [{
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/1/logos/1.png",
        "link": "https://www.iitm.ac.in/"
      }, {
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/1/logos/2.png",
        "link": "https://ed.iitm.ac.in/~vb/index.html"
      }, {
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/1/logos/3.png",
        "link": "http://www.tn.gov.in/"
      }, {
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/1/logos/4.png",
        "link": "http://www.irtchennai.in/"
      }],
      "date": "January 29, 2015",
      "brochure": "https://ed.iitm.ac.in/~vb/rath/brochure.pdf",
      "registrationForm": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/1/registrationForm/1.doc",
      "schedule": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/1/schedule/1.png",

      "earlyBirdRegistration": "",
      "lastDateForRegistration": "",



      "add1": "IC&SR",
      "add2": "Indian Institute of Technology Madras",
      "add3": "Chennai - 600 036",

      "importantLinks": [{
        "name": "Indian Institute of Technology Madras",
        "link": "https://www.iitm.ac.in/"
      }, {
        "name": "Centre for Continuing Education",
        "link": "https://www.iitm.ac.in/cce"
      }, {
        "name": "Department of Engineering Design",
        "link": "https://ed.iitm.ac.in/"
      }],

      "objective": [{
        "para": "There were about 3,94,982 accidental deaths reported in India in 2012. Of these, about 35.2% (1,39,034) of them have been attributed to road accidents. This unfortunate statistic put us nearly at the top of the world to have such deaths. On detail study of accidents over a period of time, researchers have attributed more than 40% of such deaths to human error or driver fatigue. With such growing number of accidents and the cost associated with it occupant and pedestrian safety are under sharp focus of Government, Non-Governmental Agencies and Industry around the world."
      },
      {
        "para": "Driver fatigue may be defined as decline in driver’s performance. A driver’s performance and behavior is greatly influenced by physical and cognitive factors. Its contribution to individual cases is hard to measure post-facto and therefore is often difficult to conclusive state as cause of crash. Therefore it is important to know about driver’s behavior, fatigue, and performance to give appropriate interventions to avoid road accidents. Human factors engineering is used to better understand driver performance and behavior."
      },
      {
        "para": "Human factors engineering is the scientific discipline concerned with the understanding of interactions among human being and other elements of a system. It involves theory, principles, data and design methods, in order to optimize human well-being and overall system performance."
      },
      {
        "para": "This program is designed to give an introductory overview to human factors engineering and its application in transportation. Various state-of-art tools and techniques used to determine driver performance and behavior will be demonstrated. Application of these tools, which can be used both at the design stage as well as on-road monitoring of driver performances and behavior will be demonstrated. Some of the recent advances in addressing driver fatigue and performance in industry will also be shared in the program."
      }
      ],

      "aboutUs": [{
        "name": "Indian Institute of Technology Madras",
        "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/1/images/1.jpg",
        "content": "Indian Institute of Technology Madras is one of the premier institutions of national importance in higher technical education and basic & applied research. It was established in 1959 by the Government of India in collaboration with the German Government. IIT Madras is a township of about one square mile area located in the city of Chennai, previously known as Madras. It is a residential institution with nearly 450 faculty members, 6200 students and 1000 administrative and supporting staff. The self-contained IIT campus is located in a beautiful wooded land with flora and fauna, carved out of the Guindy National Park. The campus has about 300 species of trees and plants including native wild ones. The Institute has sixteen academic departments and a few advanced research centers in various disciplines of engineering and pure sciences, with nearly 100 laboratories. It is conveniently located at a distance of about 12 km each from airport and railway station."
      },
      {
        "name": "Department of Engineering Design",
        "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/1/images/2.png",
        "content": "The Department of Engineering Design was established in IIT Madras as its 16th Department with a focus on interdisciplinary teaching and research. The Department launched the novel dual degree programme in Engineering Design with a view to providing the much needed leadership in this area. The first of its kind in the country, the programme constitutes a B.Tech specialisation in Engineering Design and M.Tech specilisations in Automotive Engineering and in Biomedical Design with a strong thrust on the modern practices of design."
      },
      {
        "name": "Rehabilitation Bioengineering Group",
        "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/1/images/3.png",
        "content": "The Rehabilitation Bioengineering Group, a team comprising physicians, health care professionals, engineers and basic scientists. This group works on the broad area of biomedical engineering, its application in healthcare product/ process development and technology Management."
      },
      {
        "name": "Institute of Road Transport, Chennai",
        "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/1/images/4.jpg",
        "content": "Institute of Road Transport (IRT) was established in 1976 under the Control of Government of Tamil Nadu and has been registered as a society under the Indian Societies Registration Act 1860. The prime objective of IRT is to conduct research studies on the various issues relating to Road Transport sector with a view to improve the performance of bus transportation by updating and adopting the latest developments that are taking place around the world. The aim of the Institute is to disseminate knowledge on various aspects of technology developments and transport management to the officers and supervisory staff of State Transport Undertakings in Tamilnadu by organizing training courses, seminars, workshops and circulation of journals."
      }],

      "locationTravel": [{
        "image1": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/5.jpg",
        "paras": "The IIT campus is located on the Sardar Patel Road, midway between the Raj Bhavan and Adyar bus terminus and is around 12 km from Chennai Central Railway Station. Other landmarks include the Guindy Snake Park near the IIT main gate and the Central Leather Reasearch Institute (CLRI) campus opposite the IIT campus. If you have light luggage (a bag or an attache) you could consider taking a bus to IIT. The bus stop is just across the road from the Central Railway Station. You could use the subway to cross the road which is perpetually busy. There are direct buses to IIT, which start at the Central Station bus stop. If you take any of them, get down at Gandhi Mandapam, which is at walking distance from the IIT main gate. Otherwise, take any bus to Saidapet and from there, any bus heading for Adyar or Besant Nagar which will drop you right in front of the IIT gate. You could also take any bus to Adyar; there are frequent buses from Adyar Signal to the campus. Once you reach the In gate, there are buses to Gajendra Circle (near the administrative block and Central Library), the academic zone and the hostels (they are around 3.8 km from the main gate!) almost every 30 minutes."
      },
      {
        "image1": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/6.png",
        "paras": "If you have luggage, an auto-rickshaw or taxi would be the most comfortable option. The fare will be about Rs. 120 for an auto-rickshaw and Rs. 250 for a taxi. If you arrive at Egmore Station, you could take buses to IIT, Gandhi Mandapam or Adyar from where there are number of buses to the IIT. Current auto- rickshaw and taxi fares from Egmore are approximately Rs.100 and Rs.200 respectively."
      }],

      "accommodation": "",
      "courseContent": "",
      "callForPapers": [{

        "content": "Human factors principles and applications"
      }, {
        "content": "Physical and cognitive Fatigue "
      }, {
        "content": "Case studies of human factors application in Transportation"
      }, {
        "content": "Safety in Road Transportation"
      }, {
        "content": "Road Transportation Act and Rules"
      }, {
        "content": "Accident Prevention"
      }, {
        "content": "Accident prevention"
      }, {
        "content": "First aid and occupational health issues in road transportation"
      }, {
        "content": "Practical sessions in detection driver’s behavior using electrophysiological measurements"
      }
      ],
      "Speakers": "",

      "contactUs": [{
        "name": "Prof. Venkatesh Balasubramanian ",
        "department": "Department of Engineering Design",
        "institute": "Indian Institute of Technology Madras",
        "address1": "Chennai - 600 036",
        "address2": "Tamilnadu",
        "phone": "91-44-2257-5618",
        "email1": "office@rbg.iitm.ac.in/ vboffice@rbg.iitm.ac.in"
      }]
    },
    {
      "eventNo": "2",
      "buttonName": "OHS 2012",
      "headerTitle": "National Workshop on",
      "Title": "Human Factors & Occupational Safety in Construction Industry",
      "subTitle": "",
      "logoLinks": [{
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/logos/1.png",
        "link": "https://www.iitm.ac.in/"
      }, {
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/logos/2.png",
        "link": "http://dgfasli.nic.in/"
      }, {
        "logo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/logos/3.png",
        "link": "http://www.tn.gov.in/"
      }],

      "brochure": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/brochure/1.pdf",
      "registrationForm": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/registrationForm/1.doc",
      "schedule": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/schedule/1.png",

      "earlyBirdRegistration": "10-10-2012",
      "lastDateForRegistration ": "10-12-2012",
      "workshopStartDate": "17-12-2012",


      "add1": "IC&SR",
      "add2": "Indian Institute of Technology Madras",
      "add3": "Chennai - 600 036",
      "date": "December 17 - 21, 2012",

      "importantLinks": [{
        "name": "Indian Institute of Technology Madras",
        "link": "https://www.iitm.ac.in/"
      }, {
        "name": "Centre for Continuing Education",
        "link": "https://www.iitm.ac.in/cce"
      }, {
        "name": "Department of Engineering Design",
        "link": "https://ed.iitm.ac.in/"
      }],

      "objective": [{
        "para": "Human Factors Engineering is the scientific discipline concerned with the understanding of interactions among human beings and other elements of a system. It applies theory, principles, data and methods to design, in order to optimize human well-being and overall system performance. Ergonomists contribute to the design and evaluation of tasks, jobs, products, environments and systems in order to make them compatible with the needs, abilities and limitations of people."
      },
      { "para": "In a developing country like India where large numbers of construction activities are going on with diverse and complex nature, the task of protecting safety and health of workers is enormous. Utilizing the principles of human factors will help to enhance system productivity without compromising on the safety and well-being." },
      { "para": "Construction is one of the sectors where high risks are involved wherein prompt and practical safety measures are to be practiced constantly. The occupational safety and health in construction industries is achieved through the combined efforts of management, employers, contractors and employees. The Government, employers, employees and society expect more sense of responsibility among all concerned in construction activities to ensure safe and healthy work environment. Keeping this in view, this training programme has been designed to discuss various Safety and Health issues in construction industries." }
      ],

      "aboutUs": [{
        "name": "Indian Institute of Technology Madras",
        "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/1.png",
        "content": "Indian Institute of Technology Madras is one of the premier institutions of national importance in higher technical education and basic & applied research. It was established in 1959 by the Government of India in collaboration with the German Government. IIT Madras is a township of about one square mile area located in the city of Chennai, previously known as Madras. It is a residential institution with nearly 450 faculty members, 6200 students and 1000 administrative and supporting staff.The self-contained IIT campus is located in a beautiful wooded land with flora and fauna, carved out of the Guindy National Park. The campus has about 300 species of trees and plants including native wild ones. The Institute has sixteen academic departments and a few advanced research centers in various disciplines of engineering and pure sciences, with nearly 100 laboratories. It is conveniently located at a distance of about 12 km each from airport and railway station."
      },
      {
        "name": "Department of Engineering Design",
        "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/2.png",
        "content": "The Department of Engineering Design was established in IIT Madras as its 16th Department with a focus on interdisciplinary teaching and research. The Department launched the novel dual degree programme in Engineering Design with a view to providing the much needed leadership in this area. The first of its kind in the country, the programme constitutes a B.Tech specialisation in Engineering Design and M.Tech specilisations in Automotive Engineering and in Biomedical Design with a strong thrust on the modern practices of design."
      }, {
        "name": "Rehabilitation Bioengineering Group",
        "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/3.png",
        "content": "The Rehabilitation Bioengineering Group, a team comprising physicians, health care professionals, engineers and basic scientists. This group works on the broad area of biomedical engineering, its application in healthcare product/ process development and technology Management."
      }, {
        "name": "Regional Labour Institute, Chennai",
        "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/4.gif",
        "content": "The Regional Labour Institute, Chennai was set up in the year 1960 with its Safety, Health and Welfare Centre located in a rented premises at Royapettah. All the activities and facilities of the institute were then consolidated in its own premises at1 Sardar Patel Road in an area donated by the State Government. The institute was formally inaugurated by the then Hon'ble Chief Minister of Tamil Nadu Shri M. Bhakthavathchalam in the presence of the then Hon'ble Union Labour Minister Shri D. Sanjivayya and it serves the Southern States of the country."
      }],
      "locationTravel": [{
        "image1": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/5.jpg",
        "paras": "The IIT campus is located on the Sardar Patel Road, midway between the Raj Bhavan and Adyar bus terminus and is around 12 km from Chennai Central Railway Station. Other landmarks include the Guindy Snake Park near the IIT main gate and the Central Leather Reasearch Institute (CLRI) campus opposite the IIT campus. If you have light luggage (a bag or an attache) you could consider taking a bus to IIT. The bus stop is just across the road from the Central Railway Station. You could use the subway to cross the road which is perpetually busy. There are direct buses to IIT, which start at the Central Station bus stop. If you take any of them, get down at Gandhi Mandapam, which is at walking distance from the IIT main gate. Otherwise, take any bus to Saidapet and from there, any bus heading for Adyar or Besant Nagar which will drop you right in front of the IIT gate. You could also take any bus to Adyar; there are frequent buses from Adyar Signal to the campus. Once you reach the In gate, there are buses to Gajendra Circle (near the administrative block and Central Library), the academic zone and the hostels (they are around 3.8 km from the main gate!) almost every 30 minutes."
      },
      {
        "image1": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/6.png",
        "paras": "If you have luggage, an auto-rickshaw or taxi would be the most comfortable option. The fare will be about Rs. 120 for an auto-rickshaw and Rs. 250 for a taxi. If you arrive at Egmore Station, you could take buses to IIT, Gandhi Mandapam or Adyar from where there are number of buses to the IIT. Current auto- rickshaw and taxi fares from Egmore are approximately Rs.100 and Rs.200 respectively."
      }],


      "accommodation": [{
        "option1": "Limited boarding and lodging facilities will be available in the Taramani guest house at IIT Madras and RLI guest house, Chennai.",

        "title": "Other Hotels with Special tariff for IIT madras",
        "link": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/accomodation/1.pdf"
      }],
      "courseContent": [{

        "content": "Human factors principles and applications"
      }, {
        "content": "Tools for occupational risk analysis"
      }, {
        "content": "Strategies in construction management"
      }, {
        "content": "Case studies of human factors application in construction industry"
      }, {
        "content": "Safety in material handling at construction sites"
      }, {
        "content": "BOCW Act and Rules"
      }, {
        "content": "Accident Prevention"
      }, {
        "content": "Safety in working at height and in excavation"
      }, {
        "content": "First aid and occupational health issues in construction industries"
      }, {
        "content": "Hand-on sessions in ergonomic risk identification and mitigationHuman factors in construction industry"
      }],
      "callForPapers": "",
      "Speakers": [{
        "name": "Dr. Venkatesh Balasubramanian",
        "photo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/7.jpg",

        "content1": "Dr. Venkatesh Balasubramanian is an Associate Professor in the Department of Engineering Design at Indian Institute of Technology (IIT) Madras. Prior to joining IIT Madras, he was a post doctoral fellow in the orthopaedic biomechanics laboratory at Yale University School of Medicine, USA. During that tenure he was actively involved in performing various experimental biomechanics studies investigating the mechanism of whiplash and soft tissue injury. He was also involved in teaching and mentoring undergraduate, graduate and medical students at Yale.",

        "content2": "Before joining Yale, he was a research associate in the Overton Brooks VA Medical Center, USA, and Louisiana Tech University, USA. At the VA medical center, he had helped set up the Rehabilitation Neuroscience Laboratory to perform biomechanical studies of slip and falls. Earlier, he was a graduate research assistant in the Department of Bioengineering at University of Pittsburgh, USA. His focus as a graduate student was in orthopaedic biomechanics, biomedical implants and perceptional psychophysics.",

        "content3": "Dr. Balasubramanian's doctoral dissertation work won the best paper award from the Rehabilitation Engineering and Assistive Technology Society of North America (RESNA), for the year 2001. He has mentored/ supervised many students who worked towards their advanced degrees by research. He has also published extensively in many peer reviewed journals and international conference proceedings."

      },
      {
        "name": "Dr. R. K. Elangovan",
        "photo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/8.jpg",

        "content1": "Dr. R. K. Elangovan is working as Director (Safety) & In Charge at Regional Labour Institute, Chennai, Directorate General Factory Advice Service and Labour Institutes (DGFASLI), Ministry of Labour and Employment, Government of India. He had worked as Inspector of Factories in the Government of Tamilnadu, India for about seventeen years. He received his Ph.D. in Industrial Safety (Education) from Alagappa University, Karaikudi, Tamilnadu, India; his M.Tech in Machine Design from Indian Institute of Technology, Madras, India and his B.E. in Mechanical Engineering from College of Engineering, Guindy, Anna University, Tamilnadu, India.",

        "content2": "He is a Member of Doctoral and adjudicating committees of various technical universities, and guest faculty for renowned institutions in India. He has been a member secretary for various committees of DGFASLI and organized many seminars, workshops and training programmes on Occupational Safety and Health. He is an expert member of the state level safety audit cell, Site Appraisal Committee and other expert committees of various State Governments. He has conducted many safety audits, HAZID studies, Noise and Illumination Studies, On Site emergency planning, Risk Assessment and HIRA studies in industries. He is also the chairman of Construction Safety Cell at Regional Labour Institute, Chennai and specializes in the field of construction safety.",

        "content3": "He is actively involved in safety related activities for two decades and published many thematic and research papers at National and International Conferences, and delivered various technical presentations in the field of industrial safety. He is a fellow member of Institute of Engineers, India and Safety Engineers Association, SEA (India), and member of various other renowned technical bodies."
      },
      {
        "name": "Prof. K. N. Satyanarayana",
        "photo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/9.jpg",

        "content1": "Dr. K.N Satyanarayana is a professor in civil engineering department at IIT madras. He has been at IIT madras since 1991. Prior joining IIT madras he was a Graduate teaching and research assistant in Clemson University, Clemson, South Carolina,USA from august 1984 to May 1991. He was also a visiting professor in Iowa State University,USA from july to Dec 2009. His research interests are Project Management, Quality Management, Construction Methods and Equipment, Construction Contracts,Public Private Partnerships.",

        "content2": "He got an outstanding paper award for the paper entitled “Criteria influencing debt financing of Indian PPP road projects: a case study” in the journal “ Financial Management of Propert and construction “ in 2010 awarded by Emarald Literati Network and the Suchit Kumar Ghosh Memorial Medal for the paper entitled “Management of Privatised Infrastructure Development in India : Key Issues.” Awarded by the Institution of Engineers (India). He is also got IBC Medal in recognition of highly commended paper titled “Civil Engineering Education, Research and Development: Need for Wider Industy-Institute Interaction” and the Institution of Engineers (India) Certificate of Merit for the paper “Deviation Clauses in Indian Government Construction Contracts” published in the Journal of the Institution.",

        "content3": "He has also published many papers and working with various consultancy and sponsored projects."

      },
      {
        "name": "Dr Ashwin Mahalingam",
        "photo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/10.jpg",

        "content1": "Dr. Ashwin Mahalingam is an Assistant Professor at the Building Technology and Construction Management division of the Civil engineering department at IIT-Madras. He has been at IIT-Madras since 2006 as a faculty member, but was also a student there from 1994-1998 where he received a BTech in Civil Engineering. After his B.Tech, Ashwin proceeded to Stanford University for a Masters in Construction Engineering and Management.",

        "content2": "He then helped start up an internet based company in the USA called All Star Fleet, aimed at providing asset management services for construction companies. Following this he returned to Stanford University to pursue a PhD in the area of Infrastructure Project Management. His doctoral thesis work was on understanding how institutional differences lead to increased costs and challenges on large infrastructure projects with international participation.",

        "content3": "Ashwin's current research interests are in the areas of Public Private Partnerships in Infrastructure, IT based Innovation in the architecture-engineering and construction industry, and ways in which organizations react to the globalization of engineering services."

      },
      {
        "name": "Prof Koshy Varghese",
        "photo": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventsWebpage/2/images/11.jpg",

        "content1": "Prof Koshy Varghese is a professor in the Department of Civil Engineering at IIT Madras, Chennai. Prior joining IIT Madras, he was a post doctoral fellow at Univeristy of Texas, Austin, USA. He did his Ph.D in Construction management at University of Texas, USA in 1992. He finished his M.S in civil engineering at University of Texas, USA and B.E in Civil engineering at Anna university, Chennai.",

        "content2": "His research interests are automation in construction, planning - fast Track & concurrent engineering projects, sustainable development and geographic information in civil engineering applications.",

        "content3": "He is the board Member for \"The International Association for Automation and Robotics in Construction (IAARC)\" and editorial board member for International Journal of Automation in Construction. He had published more than 80 papers and working with various consultancy and sponsored projects."

      }],
      "contactUs": [{
        "name": "Prof. Venkatesh Balasubramanian",
        "designation": "",
        "department": "Department of Engineering Design",
        "institute": "Indian Institute of Technology Madras",
        "address1": "Chennai - 600 036,",
        "address2": "Tamilnadu",
        "phone": "91-44-2257-5618",
        "email1": "office@rbg.iitm.ac.in/ vboffice@rbg.iitm.ac.in"
      }, {
        "name": "Dr. R. K. Elangovan",
        "designation": "Director In-Charge",
        "department": "",
        "institute": "Regional Labour Institute",
        "address1": "1, Sardar Patel Road, TTTI Post",
        "address2": "Tharamani, Chennai - 600 113",
        "phone": "(+91-44)-2235-5690",
        "email1": "chennai.rli@gmail.com"
      }]
    },
    {
      "eventNo": "3",
      "buttonName": "Driver Training",
      "headerTitle": "Factoring the Human in the Journey for Safe Roads",
      "Title": "Capacity Building and Quality Standards for Driver Training ",
      "subTitle": "",
      "logoLinks": [   
        {
        "logo": "https://ed.iitm.ac.in/~vb/3STP/MoRTH.png",
        "link": "https://www.iitm.ac.in/"
      }, {
        "logo": "https://ed.iitm.ac.in/~vb/3STP/IITMadras.png",
        "link": "https://ed.iitm.ac.in/~vb/index.html"
      }, {
        "logo": "https://ed.iitm.ac.in/~vb/3STP/CoERS_logo.png",
        "link": "http://www.tn.gov.in/"
      }, 
      {
        "logo": "https://ed.iitm.ac.in/~vb/3STP/RBGlogo.png",
        "link": "https://ed.iitm.ac.in/~vb/index.html"
      }
    ],
      "date": "July, 2023",
      // "Brochure": "https://ed.iitm.ac.in/~vb/3STP/Agenda.png",
      "registrationForm": "http://rbg.iitm.ac.in/31JulyRegistration.html",
      "schedule": "https://ed.iitm.ac.in/~vb/3STP/Agenda.png",

      "earlyBirdRegistration": "",
      "lastDateForRegistration": "",



      "add1": "IC&SR",
      "add2": "Indian Institute of Technology Madras",
      "add3": "Chennai - 600 036",

      "importantLinks": [{
        "name": "Indian Institute of Technology Madras",
        "link": "https://www.iitm.ac.in/"
      },
       {
        "name": "Department of Engineering Design",
        "link": "https://ed.iitm.ac.in/"
      }],

      "objective": [{
        "para": "One of the leading causes of road accidents resulting in grievous injuries and fatalities is driver error. 84% of the road crashes that create accidents, are due to a driver’s fault"  
      },

       
      {
        "para": "Driver errors can happen for several reasons such as deliberately violating rules or distracted driving. The behaviour of each learning driver and understanding how a driver performs, in the long run, is important.  "
      },
      {
        "para": "The release of the report on the Driver Training Programme (DTP) and the launch of the 3-Step Training Programme (3STP) by The Centre of Excellence for Road Safety (CoERS) envisions instilling responsible driver behaviour, at a national level, by revitalising India’s Driving Schools with institutional mechanisms and Training of Drivers (TOD) with an emphasis on building responsible driving habits"
      }
      
      ],

      "aboutUs": [{
        "name": "The 3-Step Training Programme as an Intervention ",
        "image": "https://ed.iitm.ac.in/~vb/3STP/Poster.jpg",
        "content": "The CoERS proposes a 3-Step Driver Training Program (3STP) to impart driver knowledge, skill, and practice, which addresses concerns with driver learning seen in the Driver Training Institutions (DTIs) in India. The CoERS previously advised as a part of its Road Safety Programmes, that the 3-Gate Licensing System (3GL) be an evaluation method in India for licensing examinations and issuances.The 3STP covers the auditing of DTIs, their capacity building, and continuing audits. Auditing addresses the gaps in the capacity of DTIs. Capacity building trains the trainers of drivers to improve teaching methods. It also involves equipping DTIs with tools for good quality driver training and will bridge the gaps addressed in the preliminary audits. The continuing audits will monitor the performance of DTIs post-capacity building and equipment and enable us to rate the DTIs.The objective is to bring a mindset change in the drivers where they prioritize road safety. The 3STP’s particulars address two wings of concerns – the drivers and the trainers of drivers. Training to acquire Defensive Driving Techniques and Hazard Perception skills is necessary for drivers, in addition to mindset changes.The DTIs shall be equipped with benchmarking teaching tools, such as simulators, training/ testing vehicles, well-thought curriculum and pedagogy to teach driving lessons, and trained trainers to utilize these teaching tools appropriately to assure quality learning for trainee drivers."
      },
      {
        "name": "Training of Drivers (TOD)",
        "image": "https://ed.iitm.ac.in/~vb/3STP/Agenda.png",
        "content": "The CoERS, with a vision of fast-tracking the need to bring about a scientifically backed mindset change among drivers, have proposed a 3-Gate Licensing system (3GL). 3GL is an improved licensing process that compels new license applicants to understand road regulations and to adhere to road rules while driving. From comprehending road rules as a theoretical concept to making sure the drivers are competent enough, effective training is necessary. This can be made possible using ‘Theory to Simulator’ based Training of Drivers (TOD) programmes conducted by CoERS. Flagged off with the initiative of equipping drivers, CoERS’ TOD programmes in association with Red Chariots and HL Mando, have successfully assessed and trained more than 2000 drivers in and around Chennai, Tamil Nadu. The programme was conducted in four modules which included kiosk engagement, simulator-on-wheels, tailored performance analysis and app-based re-learning and retaining, after which inferences were drawn based on drivers’ performance. "
      },
      {
        "name": "Scan the QR code below if you would like to Register for the 3STP programme ",
        "image": "https://ed.iitm.ac.in/~vb/3STP/3STPQR.png",
        // "content": "The Rehabilitation Bioengineering Group, a team comprising physicians, health care professionals, engineers and basic scientists. This group works on the broad area of biomedical engineering, its application in healthcare product/ process development and technology Management."
      },
      ],
  
      "contactUs": [{
        "name": "Prof. Venkatesh Balasubramanian ",
        "department": "Department of Engineering Design",
        "institute": "Indian Institute of Technology Madras",
        "address1": "Chennai - 600 036",
        "address2": "Tamilnadu",
        "phone": "91-44-2257-5618",
        "email1": "office@rbg.iitm.ac.in/ vboffice@rbg.iitm.ac.in"
      }]
    }
  ];

  public projectPage = [
    {
      "projectNo": 2,
      "projectCategory": " Bicycle, Motorcycle and Helicopter Studies",
      "titles": [
        {
          "subprojectNo": 1,
          "Title": "Evaluation of bicycle design and saddle height measurement methods based on sEMG",
          "Content": ["In RBG Lab, surface Electromyography (sEMG) used to analyze the parameters affecting the design of bicycle. Researchers evaluate and optimize the parameters from the analysis information",
            "Presently, bicycles came out with adjustable input parameters such as saddle height, saddle to handlebar distance, handlebar width, etc., which allow the user to customize them to their comfort. Vague design of bicycles results in discomfort, which leads to rider injury and in some cases muscle fatigue.",
            "Investigations has been carried out to know the muscle fatigue on different saddle height. Standard techniques (Hamley, Lemond and Holmes methods) are adopted to evaluate the comfort and muscle fatigue using surface electromyography (sEMG).  Muscle groups are recorded bilaterally using sEMG to observe the muscle fatigue as shown in Figure 4. From the sEMG, it is observed that muscle fatigue occurs in the ES muscle groups when the saddle height is at its lowest position. However, at the highest position of saddle height, muscle fatigue occurs in the TM muscle groups that is significantly higher. The higher fatigue is due to opposite nature of muscle fatigue in lower back and neck when Hamley method is used. It occurs when saddle height is placed at different level than ideal [2]. In further study, muscle fatigue is compared between the people with/without lower back pain (LBP). The group of people having LBP suffered higher muscle fatigue than their cohorts [1]. Later, a comparison is made on three categories of bicycle i.e., rigid frame bicycle (RF), suspension bicycle (SU) and sport bicycle (SP), using EMG and fatigue. It is observed that there is a poor balance of bicycle while maneuvering SP bicycle compared to the RF and the SU bicycles [3]."
          ],

          "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/images/2/2/1.jpg",
          "caption": "Physical locations of the surface electrodes on a typical participant. Muscles that were examined included extensor carpi radialis (ECR); trapezius medial (TM); latissimus dorsi medial (LDM); erector spinae (ES).",
          "projectPublications": [{
            "authourName": "J. Srinivasan and V. Balasubramanian",
            "paperTitle": "Low back pain and muscle fatigue due to road cycling – An sEMG study",
            "conferenceName": "Journal of Bodywork and Movement Therapies, vol 11(3), 260-266",
            "conferenceVenue": "",
            "date": "2007"
          },
          {
            "authourName": "V. Balasubramanian, M. Jagannath and K. Adalarasu",
            "paperTitle": "Muscle Fatigue Based Evaluation of Bicycle Design",
            "conferenceName": "Applied Ergonomics, 45 (2), Part B, 339-345",
            "conferenceVenue": "",
            "date": "2014"
          },
          {
            "authourName": "M. Jagannath, K. Adalarasu and V. Balasubramanian",
            "paperTitle": "Evaluating bicycle design using sEMG to study muscle fatigue",
            "conferenceName": "n: Proc. of the Seventh International Conference on Prevention of Work-Related Musculoskeletal Disorders (PREMUS 2010),p.178",
            "conferenceVenue": "France",
            "date": "2010"
          }
          ]
        },
        {
          "subProjectNo": 2,
          "Title": "Powered Two Wheelers -Physical Fatigue and Discomfort Study in Motorcycles",
          "Content": ["Motorcyclists must undergo excessive physical demands during riding that may have impact on rider. Maintaining same posture for prolonged periods leads to muscle stiffness and reduced blood flow in turn resulting in discomfort and possibly fatigue. The existing methods of estimating rider fatigue during riding are limited to subjective experience/observations. Objective measurements of vehicle parameters like steering torque, shock absorption level, acceleration, etc. These parameters estimate same fatigue for all riding postures. The subjective experiences of fatigue have not always been reliable. In a study done at RBG Labs, IIT Madras, riders fatigue was evaluated based on EMG and seat pressure analysis along with other physiological system such as, ECG and Blood pressure. It is found from observation that Fatigue accumulated to driver during his course driving (Balasubramanian and Jagannath, 2014)."],
          "projectPublications": [{
            "authourName": "V. Balasubramanian and M. Jagannath",
            "paperTitle": "Detecting Motorcycle Rider Fatigue using Surface Electromyography and Seat Interface Pressure",
            "conferenceName": "Transportation Research Part F: Traffic Psychology and Behaviour, 22, 150-158",
            "conferenceVenue": "",
            "date": "2014"
          },
          {
            "authourName": "V. Sai Praveen, V. Balasubramanian, K. Adalarasu, Babu and Venkata Mangaraju",
            "paperTitle": "Muscle fatigue due to motorcycle riding",
            "conferenceName": "Small Engine Technology Conference & Exposition, No. 2010-32-0100, Austria, September",
            "conferenceVenue": "",
            "date": "2010"
          }
          ]
        },
        {
          "subProjectNo": 3,
          "Title": "Estimation of Muscle Fatigue in Helicopter Pilots",
          "Content": ["Helicopter pilots must face vibratory environments and ergonomically unfavorable working conditions during his ride, which over a time may cause back pain. One of the most important health problems is the onset of low back pain (LBP) due to straining of erector spine muscle. Pre- and post-flight sEMG analysis indicates fatigue in both trapezius and erector spinae muscle groups. Statistical analysis showed that fatigue in right trapezius muscle is more than left trapezius muscle, which correlates with the right-handed handling of the helicopter stick by the pilots (Balasubramanian et al., 2011)."],
          "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/images/2/3/1.jpg",
          "caption": "Cockpit of Alouette III (Chetak) used extensively by the Indian Coast Guard for maritime patrol.",

          "projectPublications": [{
            "authourName": "S. Rai, A. Dutt, S. Karthik and V. Balasubramanian",
            "paperTitle": "EMG Study of Neck Muscles While using Standard Issue Helicopter Air Crew Headgear",
            "conferenceName": "International conference on Ergonomics, HWWE 2005",
            "conferenceVenue": "",
            "date": "Dec 10–12-2005"
          },
          {
            "authourName": "A. Dutt, S. Rai, S. Karthik and V. Balasubramanian",
            "paperTitle": "EMG Study of Flight Induced Fatigue of Chetak Helicopter Pilots",
            "conferenceName": "International conference on Ergonomics, HWWE 2005",
            "conferenceVenue": "",
            "date": "Dec 10–12, 2005"
          }
          ]
        }
      ]
    },
    {
      "projectNo": 1,
      "projectCategory": "RBG Innovation Paradigm (RIP)",
      "titles": [
        {
          "Title": "RBG Innovation Paradigm (RIP)",
          "Content": ["RBG Innovation Paradigm is a problem-solving tool to bring process innovation in the organization considering lean tools along with human and organizational factors for productivity improvement. Many Small and Medium Enterprises (SMEs) have been trained on RIP and yield positive results. The result of the training program on RIP was reflected in variety of projects which includes productivity improvement of workstation, improving assembly line efficiency, reduction of human fatigue and improvement in process capability.  RIP has been leading to number of new process improvement tools such as RBGMN which has been developed for implementing lean and TQM in leather and garments industries."],
          "projectPublications": ""
        }, {
          "Title": "Implementing Lean Ergonomics in Service Industry – A Case Study in Indian Postal Service",
          "Content": ["The objective of this case study is to improve the productivity through identification/elimination of waste, cellular approach, layout modifications and modifying the work design in manual sorting centre. After implementation of lean ergonomics concept, significant advantages such as, implemented housekeeping concept, colour stickers for town delivery (TD) is yellow and non- town delivery is blue to reduce the time for identification TD & Non-TD bags in an initial bag opening section and improved aesthetics of an existing layout by providing show cards inspiring quotes on cleaning. Green plant (gang way) is not only provided for separate TD & Non-TD section but also gives pleasant effect. Fixed scanner is used instead of moving scanner for reducing the shoulder pain (reduction in human effort)."],
          "projectPublications": [{
            "authourName": "S M Vadivel, V. Balasubramanian and Mervin Alexander",
            "paperTitle": "Lean Ergonomics in Indian Postal Service - A Case Study",
            "conferenceName": "International Ergonomic Conference, HWWE 2014",
            "conferenceVenue": "",
            "date": " December 3-5, 2014"
          }

          ]

        },
        {
          "subprojectNo": 3,
          "Title": "New Manufacturing Strategy for Niche Manufacturing – RBG Manufacturing Strategy for Niche Manufacturing (RBGMN)",
          "Content": ["In emerging economies labour-intensive small and medium-sized enterprises, such as Leather, Textile and Garment, utilize skilled workforce with low technology awareness. To stay ahead of open competition, Leather Small and Medium-sized Enterprises (LSMEs) resorted to manufacturing strategies that were popular in other sectors. This paper discusses the pathway by which leather goods manufacturers had implemented our novel lean manufacturing (LM) strategy.  The effectiveness of this strategy is described using the case method in two different genres of leather manufacturers. Two types of analyses, viz., within and across the cases were conducted using simulation and analytical hierarchy process (AHP).  Analysis of the cases led to the identification of factors such as top management commitment, appropriate tools and technical usage of performance measures, the mindset of managers, sufficient training, importance of layout and formation of coordinating team that are important for designing the framework.  The Rehabilitation Bioengineering Group Manufacturing Strategy for Niche Manufacturing (RBGMN)has been designed with Value Stream Mapping (VSM)and Statistical Process Control (SPC) to provide sufficient training for coordinating team with small incremental learning on what-to-do with how-to-do that can help top management to reduce the redundant use of time, energy and money while implementing a manufacturing strategy at the shop floor level for niche enterprise."]
        },
        {
          "subProjectNo": 4,
          "Title": "Suzhal Management System (SMS)",
          "Content": ["Sustaining Lean manufacturing in mid-volume, mid-variety environment such as mixed model system poses a few challenges. Typically, these are Cellular Manufacturing Systems in which the prevalence of manual work makes ergonomic studies relevant. Considering the industry's need for productivity improvement while adhering to governmental regulations on manual labour at the workplace, we propose a viable framework that integrates human factors, lean tools and job rotation to seamlessly interface men, machines, and methods", "The study focuses on a configuration of continuous job rotation cell, also referred as Nagare cell, in which workers walk along the line to complete a cycle. In this configuration, the presence of automated or semi-automated equipment hinders productivity and affects workforce utilisation. Suzhal, a configuration with sub cells, is a new layout that overcomes such difficulties. In this study, we examine the hypothesis that Suzhal cell yields higher productivity improvement and provides safety to workmen. We tested this hypothesis in a case study of an automotive enterprise using discrete event simulation. An analytical model is developed for optimum cell configuration (sub cells) corresponding to number of operators. Our analysis, using simulation, shows a significant improvement in throughput, work force utilisation, process cycle efficiency and considerable improvement in safety. From the results, we conclude that the integrated approach aids the implementation of lean ergonomics and promises to improve any industrial processes.", "SMS has been continuously evaluated in various industry contexts over the years to test for its agility, fidelity, robustness and ease of implementation. Some of these industries include automotive, niche manufacturing, service, etc. Improvements that have been brought about are process cost reduction; cost of poor quality; process optimisation; manpower optimisation; efficiency improvement; downtime reduction; consumable cost reduction and new product development. SMS is being extensively used by Southern Railways, TVS group, Anand group, etc."],
          "projectPublications": [{
            "authourName": "V. Balasubramanian",
            "paperTitle": "Process Excellence Using Suzhal Management System (SMS) – Concepts to Practice",
            "conferenceName": "National Health Mission, Chennai, India",
            "conferenceVenue": "",
            "date": "February 28, 2017"
          }
          ]
        },
        {
          "subProjectNo": 5,
          "Title": "Rehabilitation Bioengineering Group Risk Scale (RBGRS) - An Integrated Tool for Ergonomic Risk Assessments",
          "Content": ["Manufacturing in developing economies continue to be labour intensive owing to its cost benefits. Productivity improvement in this circumstance is brought about by continuous evaluation of manual work for ergonomic risks and taking corrective actions. Existing tools for risk assessment seek to measure risk in isolation while risk often depends on several factors such as posture, loads, injury proneness of a job and environmental factors (EFs) (temperature, lighting conditions, etc.). In the absence of an integrated measurement tool for ergonomic risk assessment, we propose a composite measure called RBG risk scale. It provides a single measure of the ergonomic assessment in terms of several factors (e.g. posture, biomechanical forces, environmental, etc.) collectively contributing to ergonomic impairments. This integrated score provides a clearer picture of the risk involved in the job and hence it can be used as a basis for prioritising operations for ergonomic interventions.", "While the existing measures for ergonomic assessment of job address specific factors of the job, we propose an index which is a composite measure of major factors affecting work. It has the potential to serve as a tool to rank and prioritise manual operations that need intervention either in the form of automation or in the form of methods improvement. Spread over a range of 11 points from 0 to 10, the magnitude of RBGRS serves as a clear pointer towards high-risk operations. An RBGRS score of 8 or more indicates that such operations are potential candidates for automation. Similarly, operations having high RULA/RWL scores or having high frequency of accidents can also be analysed for reducing their impacts on productivity and health."],
          "projectPublications": [{
            "authourName": "V. Balasubramanian",
            "paperTitle": "Operational Risk Management using RBG Risk Scale (RBGRS)",
            "conferenceName": "42nd National Safety Day, L&T Chennai",
            "conferenceVenue": "",
            "date": " March 4, 2013"
          },
          {
            "authourName": "V. Balasubramanian",
            "paperTitle": "Limiting Occupational Hazards and Enhancing Operational Risk Management using RBGRS",
            "conferenceName": "Regional Labor Institute (RLI), Chennai",
            "conferenceVenue": "",
            "date": " January 23, 2012"
          }
          ]
        }

      ]
    },
    {
      "projectNo": 3,
      "projectCategory": "Posture and Behaviour Studies",
      "titles": [
        {
          "subprojectNo": 1,
          "Title": "Proper Sitting Posture while Car Driving",
          "Content": ["Vehicle driver postures are a big concern in occupant safety. Posture should be appropriate such that the muscles should get less fatigue to avoid road accidents. Objective of this study is to use different optimization techniques to minimize the muscle forces using piezoresistive grip sensor during simulated car driving. Groups of objective functions were developed to minimize the muscle forces during car driving. It is observed that the nonlinear objective functions are more realistic than the linear objective functions, when minimizing muscle forces. It has also been observed that extending or leaning backward while driving leads to less exertion of muscles forces. These informative results can help the drivers to maintain the correct posture to reduce muscles fatigue.", "We have performed the experiment by taking three conditions for both the hands with varying angles of brachioradialis, brachialis and biceps brachii muscles group. From the results calculated for both hands, it is evident that optimization of the muscle force is not good if we consider linear programming method. For n=1, the force exerted by the biceps brachii and brachioradialis on the steering wheel is zero and by increasing the order(n) to 2 or 3, it gives optimal value of force exerted on the steering wheel. It is also observed that, by increasing the order (non-linear objective function), force exerted by brachioradialis decreased drastically as compared to the forces calculated from biceps brachii and brachialis muscles group for both the hands. The variation seen in biceps brachii and brachialis muscles groups was found to be very less. Changes in muscles force has also been observed on the steering wheel by varying angle between arm and fore arm. In most cases, exertion of forces on steering wheel was found to have decreased with the increase in joint angle. Based on the above results, the perfect posture of the car driver while driving can be determined to avoid the muscles fatigue."
          ],
          "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/images/3/1/1.jpg",
          "caption": "Free body diagram of right hand acting on the steering wheel in which Biceps brachii (80.3 degrees from horizontal, 4.6 cm from elbow), Brachialis (68.7 degrees from horizontal, 3.4 cm from the elbow) and Brachioradialis (23 degrees from the horizontal, 7.5 cm from the elbow) muscles group have been shown.",
          "projectPublications": [{
            "authourName": "S. K. M. Varadhan and V. Balasubramanian",
            "paperTitle": "Analysis of Muscle Fatigue during Supported and Unsupported Sitting using Surface Electromyography",
            "conferenceName": "Proc of 3rd International Conference on Advances in Medical, signal and Information Processing, Glasgow, UK",
            "conferenceVenue": "",
            "date": "July 17– 19, 2006"
          }
          ]
        },
        {
          "subprojectNo": 2,
          "Title": "Pressure Sensor based Health Monitoring",
          "Content": ["Pressure mat is thin film piezoresistive array of many sensors which detects pressure applied on it. It is also used for estimating physical fatigue based on the postural changes and behavior of the drivers. Fatigue is estimated based on the acquired features such as, contact area, seat pressure distribution% (SPD%) and contact pressure. Variations in the above parameters were taken as the fatigue indicator (Jagannath and Balasubramanian, 2014).", "RBG Labs has developed a device called Intelliseat™ with joint-collaboration from M/S Harita Seating System Limited (HSSL) to address this epidemic of road accidents. Intelliseat™ is viable and cost-effective products to enhance road safety and it is used to monitor behaviour, posture and fatigue of the drivers. Patent was filed for this technology and it was transferred to M/S Harita seating system limited, Hosur, Tamil Nadu. Intelliseat™ is an IoT device that monitors the driver 24x7 and is confined within the existing footprint of regular seats.  This system operates independently and can be used for in-vehicle information of status as well as help a central tracking by fleet owners.  It can also be used for driver training and fleet risk evaluation, which would eventually have a bearing on the overall fleet insurance and ownership cost", "Intelliseat Video Link: https://www.youtube.com/watch?v=QEUFR7swGcc"
          ],
          "projectPublications": [{
            "authourName": "V. Balasubramanian",
            "paperTitle": "A seat assembly for monitoring and alerting a driver based on his/her fatigue and/or behavior",
            "conferenceName": "Indian Patent Application No. 1921/CHE",
            "conferenceVenue": "",
            "date": "2013"
          }
          ]
        },
        {
          "subprojectNo": 3,
          "Title": "Pedestrians’ Perception and Response during Road-Crossing at Night Time",
          "Content": ["There are many causal factors for vehicle-pedestrian crashes, and one of the key factors is the poor visibility in nocturnal conditions. In this study, we have estimated the pedestrian’s response towards an approaching vehicle and the time taken to correctly recognize it while they crossed the road in dim-light conditions during night time. A collection of six videos, which comprised of different vehicle scenarios were shown to each of the participants. It was observed that correct identification and time to recognize the vehicle was fastest when light emitting diode (LED) strip was fixed between headlights of a four–wheeler (Figure 12-17).", "Average time to recognize a low beam car and a high beam car with an LED strip was 7.62±2.39 seconds and 11.23± 2.94 seconds respectively, whereas correct identification rates of the said low beam and high beam cars with LED strips were 93.33% and 86.67% respectively. Earlier when no LED was used, time to recognize low beam car and high beam car without LED strip were 20.55±3.50 seconds and 25.57±4.14 seconds respectively whereas correct identification of low beam car without LED strip and high beam car without LED strip were 90.00% and 56.67% respectively. Pedestrians are therefore less confused and can take right decision while crossing the road–particularly in a poor lighting environment–when there is a demarcating illumination between headlights of vehicle.", "Social Impact of the study could be seen by the installation of retro reflective strips between vehicle headlights by the traffic police in Tamil Nadu."
          ],
          "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/images/3/3/7.jpg",
          "caption": "Images of reflective strips installed between vehicle headlights by the traffic police of Tamil Nadu",

          "projectPublications": [{
            "authourName": "Venkatesh Balasubramanian, Rahul Bhardwaj",
            "paperTitle": "Pedestrian's perception and response towards vehicles during road crossing",
            "conferenceName": "Accident Analysis and prevention, pp.128-135",
            "conferenceVenue": "",
            "date": "2017"
          }
          ]
        }
      ]
    },
    {
      "projectNo": 4,
      "projectCategory": "Driver Fatigue and Health Assessment based on cECG and EEG",
      "titles": [
        {
          "subprojectNo": 1,
          "Title": "Assessment of Driver’s Health on Simulator Car",
          "Content": ["Driver health/ fatigue have been estimated widely since a decade using multimodal technology in RBG Labs. These multimodal technologies includes electromyography(EMG), electroencephalography (EEG, non-contact electrocardiography (cECG), pressure sensor, grip sensor and some other physiological indicators such as, pulse oximeter, blood pressure etc."],
          "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/images/4/1/1.jpg",
          "caption": "Methods to Estimate Driver’ Health/ Performance.",

        },
        {
          "subprojectNo": 2,
          "Title": "Assessment of Cognitive Fatigue Condition based on Electroencephalography (EEG)",
          "Content": ["As mentioned earlier that EMG is used to estimate physical fatigue whereas, EEG used to estimate mental/ cognitive fatigue in drivers. EEG electrodes are fixed on specific position on the scalp to record the brain activity of the person. Like EMG, features are also extracted from EEG signals to estimate the cognitive fatigue. Fatigue is measured from variations in EEG bands (beta, alpha, theta and delta) and sometimes ratio of these indices. During driving process, it was observed that the EEG band such as beta was decreasing whereas, alpha was increasing."],
          "projectPublications": [{
            "authourName": "V. Balasubramanian, K. Adalarasu and A. Gupta",
            "paperTitle": "EEG based analysis of cognitive fatigue during simulated driving",
            "conferenceName": "International Journal of Industrial and Systems Engineering, 7 (2), 135-149",
            "conferenceVenue": "",
            "date": "2011"
          }
          ]
        },
        {
          "subprojectNo": 3,
          "Title": "Heart Monitoring System based on Electrocardiographic (cECG)",
          "Content": ["ECG is also well known for estimating the driver’s heath and a lot of researchers have given their remarkable contribution in this field. ECG records electrical activity of heart. In this type of fatigue detection technique, it has been observed by many researchers that, the heart rate decreases due to decrease in RR interval of the ECG wave on the onset of fatigue. Though these are the contact based ECG system in which ECG electrodes come in direct contact with the skin.", "To get rid of the contact method, we have designed and developed a non-contact method of ECG system called cECG to estimate driver fatigue. In this study, we have used a non-contact capacitive coupled ECG (cECG). Ten male volunteers participated in this study. cECG electrodes were place at the seat back and other cECG electrodes were placed at the seat base. cECG signals were acquired from both seat back and seat base. We have correlated seat back cECG and seat base cECG with conventional one lead ECG systems to validate the cECG system. Based on Magnitude square coherence (MSC) analysis, it was observed that all the ECG signals acquired from different source had good coherence among each other. On progression of driving time, it was observed that the quality of cECG signal acquired from the seat base was getting better as compared to seat back. However, combined cECG from seat back and seat base was better than using a single source for sensor."
          ],
          "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/images/4/3/1.jpg",
          "caption": "Diagram represents location of the active cECG and driven ground plane electrodes in the seat. It shows the signal acquisition, processing and feature extraction of cECG signal.",


        }

      ]
    },
    {
      "projectNo": 5,
      "projectCategory": "Grip Sensor and EMG based Driver Fatigue Studies",
      "titles": [
        {
          "subprojectNo": 1,
          "Title": "Electromyography (EMG) based Estimation of Physical Fitness of Drivers",
          "Content": ["Driver fatigue is broadly divided in two categories: 1. Physical fatigue and 2. Mental/ Cognitive fatigue. Physical fatigue can be measured by using EMG technique. In this method EMG electrodes are put on the specific muscle to acquire the muscles activity during driving period. After that, physical fatigue estimated based on features extracted from EMG signals. In the fatigue state, it was observed that the RMS values of the EMG signals were increasing (Balasubramanian and Adalarasu, 2007; Jagannath and Balasubramanian, 2014)."],
          "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/images/5/1/1.jpg",
          "caption": "Experimental setup includes driving simulator, data acquisition systems for surface electromyographic and electroencephalographic signals, seat interface pressure mapping system and photoplythesmography unit for heart rate and blood pressure monitoring.",
          "projectPublications": [{
            "authourName": "V. Balasubramanian and K. Adalarasu",
            "paperTitle": "EMG-based analysis of change in muscle activity during simulated driving",
            "conferenceName": "Journal of Bodywork and Movement Therapies, vol 11(2), 151-158",
            "conferenceVenue": "",
            "date": "2007"
          },
          {
            "authourName": "M. Jagannath and V. Balasubramanian",
            "paperTitle": "Assessment of Early Onset of Driver Fatigue using Multimodal Fatigue Measures in a Static Simulator",
            "conferenceName": "Applied Ergonomics, 45 (4), 1140-1147",
            "conferenceVenue": "",
            "date": "2014"
          }
          ]
        },
        {
          "subprojectNo": 2,
          "Title": "Estimation of Driver Fatigue using Grip Pressure and sEMG in a Static Simulator",
          "Content": ["In non-intrusive type fatigue detection system, getting information of the steering wheel grip force and pressure on different types of road and speed of the vehicle might be useful to the vehicle designer from safety point of view. This study estimated driver fatigue using static simulator steering wheel grip pressure and correlate it with the muscle fatigue determined using surface electromyography (sEMG). It was observed during entire driving process that force trajectory was acting on the lumbrical muscles which are base of all the fingers of both the hands which implies that maximum pressure was acted by lumbrical muscles on the steering wheel. In this study, grip pressure sensor, a non-intrusive method was used as a tool to estimate fatigue and the results were also supported with sEMG study, a “gold standard” fatigue estimation method. The study revealed very much similar result as the events of occurrence of fatigue in drivers were almost same. The findings of this study would be useful in developing a non-intrusive driver fatigue detection system to reduce road accidents."],
          "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/images/5/2/1.jpg",
          "caption": "Acquisition of sEMG by placing electrodes on (a) trapezius medial (TM) and (b) extensor carpi radialis (ECR) muscle–groups bilaterally and grip sensor data were collected by placing sensors on the cotton gloves simultaneously.",
          "projectPublications": [{
            "authourName": "R. Bhardwaj, N Singh, M. Jagannath and V. Balasubramanian",
            "paperTitle": "Assessment of human hand grasp and release movement using sEMG",
            "conferenceName": "International Conference on Human Factors and Ergonomics, HWWE 2011, December 15–17, p. 99",
            "conferenceVenue": "",
            "date": "2011"
          }
          ]
        },
        {
          "subprojectNo": 3,
          "Title": "Assessment of Driver Fatigue based on Deep Learning using Physiological Signals",
          "Content": ["Driver fatigue is one of the major concerns from road safety point of view. Driver fatigue can be detected by physiological signal. EEG is the earliest and most prevalent indicator used as driver fatigue measurement. In this proposed model driver fatigue is detected based on patterns of different EEG waveforms during the driving period. Delta waves happen in a sleep state or transition stage to drowsiness; theta waves are related to low levels of vigilance and they will degenerate to delta component when drowsiness is onset; alpha rhythm occurs markedly at eye closure time and attention attenuated; beta waves are active EEG component due to arousal and increased alertness. The use of sophisticated components ensures accuracy and makes it reliable [1].", "The real time detection of fatigue and drowsiness on a vehicle can bring down the accident rate in our country. In this paper, a novel approach towards real time fatigue detection based on heart rate variability (HRV) is proposed. This detection system combines the behavioral and physiological features which provide high accuracy and detection rate. The deep learning network designed can accurately classify normal and fatigue conditions. HRV analysis in time and frequency domains gives reliable information about normal and fatigue status. The warning system inside the vehicle will alert the driver and the information will be send to the remote monitoring center [2]."],
          "projectPublications": [{
            "authourName": "Bhardwaj, R., Piyus, C. and V. Balasubramanian",
            "paperTitle": "Cognitive Assessment of Driver based on Deep Learning Using EEG Signals",
            "conferenceName": "Proceeding of the International Conference on Ergonomics and Human Factors (HWWE, 2017), India, 8-10 December",
            "conferenceVenue": "",
            "date": "2017"
          },
          {
            "authourName": "Cherian, A., Bhardwaj, R. and V. Balasubramanian",
            "paperTitle": "Real-Time Driver Fatigue Detection from ECG Using Deep Learning Algorithm",
            "conferenceName": "Proceeding of the International Conference on Ergonomics and Human Factors (HWWE, 2017), India, 8-10 December",
            "conferenceVenue": "",
            "date": "2017"
          }
          ]
        },
        {
          "subprojectNo": 4,
          "Title": "Different Strategies for Steering Wheel Holding Among Drivers",
          "Content": ["The position of the hands on the steering wheel while driving varies considerably among drivers depending on their habit of driving and the way they have been trained. In this study we have estimated muscle fatigue of the drivers based on interfacial pressure sensor and sEMG while drivers held the steering wheel in clock positions of 10-2, 9-3 and 8-4 during simulated driving (Figure 7). sEMG study did not show a significant (p<0.05) rate of increase in muscle fatigue while driving in 8-4 position when compared to 10-2 and 9-3 position.", "Interfacial pressure sensor showed that the mechanical loading on the steering wheel was distributed in the palms of the drivers’ hands when holding the steering wheel in 8-4 positions compared to 10-2 and 9-3 position where point load was observed. In 8-4 position the rate of decrease in interfacial pressure sensor features such as, contact area, contact pressure and normal force were found to be lesser as compared to 10-2 and 9-3 position which can be inferred that the rate of fatigue was lesser the steering wheel is held in 8-4 position. Based on the results from this study, we concluded that the 8-4 position is the most ergonomically suitable position to hold the steering wheel, reducing the risk of muscle fatigue and other related injuries in drivers."],
          "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/images/5/4/1.jpg",
          "caption": "Representation of different steering wheel holding position analogous to clock numbering system (a) 10-2 position (b) 8-4 position and (c) 9-3 position.",
          "projectPublications": [{
            "authourName": "V. Balasubramanian",
            "paperTitle": "A steering assembly for monitoring and alerting a driver based on his/her fatigue and/or behavior",
            "conferenceName": "Indian Patent Application No. 1920/CHE",
            "conferenceVenue": "",
            "date": "2013"
          }
          ]
        }
      ]
    },
    {
      "projectNo": 6,
      "projectCategory": "Assessment of Driver Fatigue Using Non-Physiological Parameters",
      "titles": [
        {
          "subprojectNo": 1,
          "Title": "Comparison of Fatigue Trend among Different Aged Driver with and Without PTSD on Simulator and On-road Driving",
          "Content": ["Driver’s performance on the road is vital from road safety point of view. This paper reports the estimation of driver fatigue in different age group bus drivers and drivers with and without post-traumatic stress disorder (PTSD) based on seat interface pressure sensor. Forty professional bus drivers participated in this study. Feature such as, contact area, contact pressure and peak contact pressure were estimated for the period of one hour on simulated as well as on-road driving condition. Result from seat interface pressure sensor showed significant (P>0.05) difference in the all the groups of the driver considered in this study. It was observed that most of the drivers exert more pressure and force with their right thigh and buttock and almost every driver has been observed leaning back after onset of the fatigue. Old drivers fatigue rate was higher compared to younger drivers and rate of increase of SPD% were less. Finding of this study will be very helpful in designing cabin ergonomics, seats and giving proper training to the drivers to avoid road accidents."],
          "projectPublications": [{
            "authourName": "Bhardwaj, R., Sathish, K. S and V. Balasubramanian",
            "paperTitle": "Comparison of Fatigue Trend among Different Aged Driver with and Without PTSD on Simulator and On-road Driving",
            "conferenceName": "Proceeding of the International Conference on Ergonomics and Human Factors (HWWE, 2017), India, 8-10 December",
            "conferenceVenue": "",
            "date": "2017"
          }
          ]
        },
        {
          "subprojectNo": 2,
          "Title": "Assessment of Bus Driver Performance Based on Reaction Time on Simulator and On-road Driving",
          "Content": ["Reaction time is the time span between start of the stimulus and response towards stimulus. Reaction time depends on many physiological parameters of the person. The aim of this study is to assess the performance in different kind of driver based on reaction time parameters on simulator and on-road. Forty professional bus drivers participated in this study. In both simulator and on-road scenarios, reaction time of all the drivers calculated before and after driving. Increase in reaction time was observed between pre and post driving sessions in both simulator and real road driving scenarios. There was significant difference (p>0.05) in reaction time between less experienced drivers and drivers with minimum 10 years of experience between simulated and on road driving conditions. Based on the result of this study, it can be concluded that the reaction time varies among different aged person and it also depends on the accidents faced by drivers. Finding of this study would be helpful in rehabilitating the drivers and giving trainings to enhance road safety."],
          "projectPublications": [{
            "authourName": "Bhardwaj, R., Sathish, K. S and V. Balasubramanian",
            "paperTitle": "Assessment of Bus Driver Performance Based on Reaction Time on Simulator and On-road Driving",
            "conferenceName": "Proceeding of the International Conference on Ergonomics and Human Factors (HWWE, 2017), India, 8-10 December",
            "conferenceVenue": "",
            "date": "2017"
          }
          ]
        },
        {
          "subprojectNo": 3,
          "Title": "Comparative Assessment of Mini Mental State Examination in Bus Drivers for On Road and Simulator Study Conditions",
          "Content": ["According to the report by national safety council, cognitive workload contributes to around 21% of total vehicle crashes happening all over the world. Bus drivers are at higher risk of cognitive workload as their job involves multitasking. Bus driver’s cognitive impairment can often lead to accidents. Hence Mini Mental State Examination (MMSE) was performed to estimate progression of cognitive impairment over a period. Bus drivers who work for metropolitan transport corporation participated in the study. They were classified into two groups, fatal and control group (non-fatal drivers) and their performance were studied in two different scenarios i.e. static simulator and on-road testing. A total of 84 bus drivers participated in our study. Significance tests (p<0.05) were carried out to identify differences between fatal and control (non-fatal) group drivers for both scenarios. Mean MMSE scores decreases after one hour of simulated driving for both on road and simulator conditions for fatal drivers. Also, the scores were higher during simulated driving than in on road testing condition. Results from the present study can help in rehabilitative training among fatal drivers during reinstating to services."],
          "projectPublications": [{
            "authourName": "Sathish, K. S., Bhardwaj, R. and V. Balasubramanian",
            "paperTitle": "Comparative Assessment of Mini Mental State Examination in Bus Drivers for On Road and Simulator Study Conditions",
            "conferenceName": "Proceeding of the International Conference on Ergonomics and Human Factors (HWWE, 2017), India, 8-10 December",
            "conferenceVenue": "",
            "date": "2017"
          }
          ]
        },
        {
          "subprojectNo": 4,
          "Title": "Subjective Evaluation of Musculoskeletal Disorders Among Fatal And Non-Fatal Bus Drivers In Different Scenarios",
          "Content": ["Occupational health of the bus drivers is studied worldwide owing to various hazards among professional bus drivers. Such studies have demonstrated that bus drivers are at higher risk category among various occupational groups since bus driving professions demands heavy workload both physically and mentally. The aim of this study is to capture the musculoskeletal problem associated with drivers when their demand exceeds physical strength. Bus drivers who work for metropolitan transport corporation participated in the study. They are classified into two groups, fatal and control group (non-fatal drivers) and their performance were studied in two different scenarios i.e. static simulator and on-road testing. 45 bus drivers took part in Simulator studies and 39 bus drivers took part in on road driving. They are asked to rate the perceived pain on RBG Pain Score (RBGPS) chart prepared by Rehabilitation Bioengineering Group, IIT Madras. Non-parametric tests are carried out to identify the significant difference between two groups of drivers. No significant differences are observed between the groups. However, neck, shoulder, lower back and lower leg are identified as body parts subjected to pain due to driving."],
          "projectPublications": [{
            "authourName": "Sathish, K. S., Bhardwaj, R. and V. Balasubramanian",
            "paperTitle": "Subjective Evaluation of Musculoskeletal Disorders among Fatal and Non-Fatal Bus Drivers in Different Scenarios",
            "conferenceName": "Proceeding of the International Conference on Ergonomics and Human Factors (HWWE, 2017), India, 8-10 December",
            "conferenceVenue": "",
            "date": "2017"
          }
          ]
        },
        {
          "subprojectNo": 5,
          "Title": "On-road Assessment of Bus Driver Behavior, Performance and Fatigue",
          "Content": ["Driver performance and fatigue has been estimated on-road with the collaboration with Institute of Road Transport (IRT), Chennai, Tamil Nadu. This exhaustive work on objective measurement of driver performance and fatigue on active drivers of a major transportation fleet is perhaps one of the first in the world.  In this study, we had studied three driving conditions to estimate driver's performance, behaviour and fatigue. Three different driving modalities, i.e., RBG Static driving simulator, driving simulator on motion platform and on-road driving were studied.  Forty drivers participated in the study and the sequence of their driving environment. All forty drivers were selected based on age group and accident history. Drivers were divided into four sub categories, i.e., (i) drivers who were involved in major accidents and having an experience less than 3 years (ii) drivers who were not involved in major accidents and having an experience of less than 3 years (iii) drivers who were involved in major accidents and having an experience more than 10 years (iv) drivers who were not involved in major accidents having experience more than 10 years.", "Driver’s performance and fatigue were estimated based on two questionnaires, RBG Pain Scale (RBGPS) and Mini Mental State Examination (MMSE), reaction time and electrophysiological system and sensors. The questionnaires (RBGPS and MMSE) and reaction time were administered before and after the driving task.  Electrophysiological signals such as, electromyography (EMG) and electroencephalography (EEG) were measured along with seat pressure during one hour of driving in each environment. Suggestions put forth based on this study were"
          ],
          "image": "https://ed.iitm.ac.in/~vb/assets/Gallery/images/6/5/1.jpg",
          "caption": "Suggestion to improve driver performance and reduce fatigue",
          "projectPublications": [{
            "authourName": "Sathish Kumar, Siva Sankaran, Rahul Bharadwaj and V. Balasubramanian",
            "paperTitle": "Challenges and problems faced by Bus Drivers",
            "conferenceName": "Journal of road Transport, Volume 1, Issue 10, Jan-March",
            "conferenceVenue": "",
            "date": "2017"
          }
          ]
        }

      ]
    }


  ];





  public personalwebpageteam = [

    {
      "name": "Dr.E.R. Rajkumar",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/rajkumar.jpg",
      "qualification": "Chief Operating Officer & Principal Data Scientist",
      "joinedOn": "2020",
      "content1": "Dr.E.R. Rajkumar is currently with RBG Labs as Chief Operating Officer and Principal Data Scientist. Previously he was with Robert Bosch Engineering & Business Solutions., Bangalore as Senior Architect with deftness in handling multiple business units, competency & innovative product development.",
      "content2": "Successfully completed executive education programme on new business model innovation with special commendation University Berkeley and Haas School Business.",
      "content3": "Currently Leading the strategy development and execution team for Artificial Intelligence / Machine Learning / Deep Learning Programs for OEMS and Tier 1 industries in co-creation focused to target applications. Rich experience in research, product design, design thinking and teaching/training. Demonstrated technical excellence in leading by content, practiced design engineering process in performing testing and investigation.",
      "content4": "Actively collaborating with different business entities in project conception, ideation, and management and with other industries in co-petition mode. Guided the team in intelligent product development, compliances, and certification.",
      // "content5": "Successfully guided Two PhDs and Two MS by research along with over 150 Capstone Projects for bachelor’s and Master’s.",
      "content6": "He has represented India as an Indian Delegate to The Netherlands on Innovative & Futuristic health care product development. Also have demonstrated expertise in business model innovation, lean start-up methodology & strategic business planning. Successfully guided Two PhDs and Two MS by research along with over 150 Capstone Projects for bachelor’s and Master’s.",

      "content7": "Dr. Rajkumar’s passion towards health care has started his Computer based brialler from 2006 and striving his biomedical research in the area of cognitive computing & effective computing towards wearables; stress management; sleep disorders; and meditation and its impact on different health conditions.The following are the active projects which is leading with his collaborators.",
      "content8": "Dreams Research in collaboration with Brain Research Institute of Natal, Brazil.",
      "content9": "Digital health in collaboration with Southern Cross University, Australia."

    },



    {
      "name": "Mr. Sathish kumar Sivasankaran",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/sathish.jpg",
      "qualification": "Senior Manager and Data Scientist",
      "joinedOn": "2014",
      "buttonname1": "Curriculum vitae",
      "cvLink": "https://ed.iitm.ac.in/~vb/assets/Gallery/Events/CV_Sathish Kumar Sivasankaran.pdf",
      "areaOfInterest": "Human factors in Transportation, Road accident analysis, Road Safety, Ergonomics for improving productivity, Industrial Ergonomics, Occupational ergonomics, Human factors in Design",
      "about": "Mr. Sathish kumar Sivasankaran is currently Doctoral Student at the Rehabilitation Bioengineering Group, Department of Engineering Design, IIT Madras. His research and work interest broadly spans the field of Human factors and Ergonomics. Currently he works on Human factors in Transportation, Road accident analysis, Road Safety, Ergonomics for improving productivity, Industrial Ergonomics and Occupational ergonomics.",
      "researchProposalTitle": "Investigation of factors associated with road crashes due to occupant behaviours and pedestrians in indian scenarios",
      "researchProposal": "The safety of pedestrians and occupants is of growing concern with an increasing number of traffic accidents, especially in developing economies like India. Report by Ministry of Road Transport and Highways (MoRTH, 2017) shows that fatality victims in the country are majorly due to behaviours of the occupants and pedestrians. The major problem in analysing the crash data and determining the risk factors is the availability of data in these nations. In the recent past, there has been increased interest in developing nations to measure the risk involved in crashes and to propose remedial measures for them. Despite this, little has been explored to understand the risk factors associated with the behaviour of occupants and pedestrians, particularly in developing nations. The primary objective of this research study is to examine the possible causes and the contributing factors to the crashes. The secondary aim of this research study is to develop crash prediction models for the process of investigation. Therefore interdependence of factors that contribute to pedestrian crashes is explored in this research study. The commonly faced behavioural problem of occupants (drivers) which contributes significantly to the crashes but are least explored in the context of developing nations (i.e) Pedestrian hit-and-run crashes and exceeding speed limits are studied here. This study used the data from the Government of Tamilnadu Road Accident Traffic Management System (RADMS) database, to analyse accident data related to pedestrian crashes and other occupant behaviours. Pedestrian safety is of growing concern with an increasing number of traffic accidents in Tamilnadu.In 2017, there were 20, 457 pedestrian fatalities in India.In this study, Multiple Correspondence Analysis(MCA), an exploratory data analysis technique was used to explore the roadway, traffic, crash, and pedestrian- related variables influencing pedestrian crashes.The results of the study show that crashes occurring on the express highways on a multilane road are often associated with hit - and - run behaviour among drivers.Factors such as lighting conditions, location, pedestrian behaviour, crossings, and physical separation are also significantly contributing to pedestrian crashes.The study identifies a possible association between various contributing factors.\nHit-and-run crashes are a serious road safety problem threatening the world especially in developing economies like India. The recent figures according to the Ministry of Road Transport and Highways (MoRTH), Government of India shows that hit-and-run crashes account for 11.6% (55,942) of all crashes and number of people died due to hit-and-run crashes was 15.2% (22,962) of total persons killed in the country during 2016. Traffic deaths and injuries due to speeding (i.e., driving above the speed limits) and inappropriate speed (i.e., driving too fast for the given conditions, within limits) is also the most important driver error responsible and has accounted for 66.5% of driver error related faults in India.Pedestrian hit- and - run crash models were developed to investigate risk factors.Results show that the perpetrator's tendency to leave the spot of crash increases in the dark unlighted conditions. Increased likelihood of hit-and-run crashes is found during summer, winter season and in urban areas. Among pedestrian characteristics, pedestrians who are intoxicated, pedestrian locations such as footpath, crossing the road and shoulder, pedestrian victims who are injured, significantly contribute to hit-and-run crashes. Factors such as day of the week, road category, collision cause, vehicle type, vehicle maneuver, weather conditions, driver alcohol status, pedestrian residence type, and traffic movement were found to be statistically not significant with a 95% confidence interval.Lastly, the speeding behaviour of drivers was examined to identify significant risk factors associated with this traffic violation in Chennai City using recent two - year crash data.Risk factors including driver characteristics, vehicle, environmental and crash / accident attributes were considered.Contingency tables were constructed to assess the association between the risk factors and speeding behaviour at a 10 % significance level.Results showed that(i) male drivers, (ii) drivers without a valid driving license, (iii) single lane roads, (iv)uncontrolled junction roads, (v) all type of vehicles, (vi) presence of central dividers(vii) daylight were associated with speeding - related accidents.The models developed in this research have viable applications including the identification of critical factors that influence the occupants including pedestrians and their behaviours on road.The results of the present research support the idea that identifying influencing factors and site features(spatial variables) could improve the safety aspects of the occupants in this state as well as in the developing nations.Moreover, policies and road safety strategies(introducing nation - wide crash database with a good collection of quality data, enforcement of traffic laws, enforcing speed limits, understanding legal contexts, improving practices, etc…) are need of the hour to safeguard the occupants and improve their behaviour in the developing nations.",
      "journalPublications": [
        {
          "number": "1",
          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Investigation of factors contributing to pedestrian hit-and-run crashes in India",
          "conferenceName": "Journal of Transportation Safety & Security",
          "date": "2020",
          "place": ""
        },
        {
          "number": "2",
          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": " Exploring the Severity of Bicycle - Vehicle Crashes Using Latent Class Clustering Approach in India",
          "conferenceName": "Journal of Safety Research",
          "date": "2020",
          "place": ""
        },
        {
          "number": "3",
          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Investigation of Pedestrian crashes using Multiple Correspondence Analysis in India",
          "conferenceName": "International Journal of Injury Control and Safety Promotion, DOI: 10.1080 / 17457300.2019.1681005",
          "date": "2019",
          "place": ""
        }, {
          "number": "4",
          "authorName": "Venkatesh Balasubramanian and Sathish Kumar Sivasankaran",
          "paperName": "Analysis of factors associated with exceeding lawful speed traffic violations in Indian metropolitan city",
          "conferenceName": "Journal of Transportation Safety and Security, DOI: 10.1080/19439962.2019.1626962",
          "date": "2019",
          "place": ""
        }],

      "conferencePublications": [
        {
          "authorName": "Sathish Kumar Sivasankaran,Priya Natarajan and Venkatesh Balasubramanian",
          "paperName": "Identification of Contributing Factors in Vehicle Pedestrian Crashes in Chennai using Multiple Correspondence Analysis",
          "conferenceName": "15th World Conference on Transport Research 2019, WCTRS 2019,",
          "date": "May 2019",
          "place": "Mumbai - India"
        },
        {
          "authorName": "Sathish Kumar Sivasankaran,Priya Natarajan and Venkatesh Balasubramanian",
          "paperName": "Identifying Patterns of Pedestrian Crashes in Urban Metropolitan Roads in India using Association Rule Mining",
          "conferenceName": "15th World Conference on Transport Research 2019 , WCTRS 2019,",
          "date": "May 2019",
          "place": "Mumbai - India"
        },
        {

          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Analysis of Driver Injury Severity in Metropolitan Roads of India Through Classification Tree",
          "conferenceName": "in the 20th Congress of the International Ergonomics Association (IEA 2018)",
          "date": "August 2018",
          "place": "Florence – Italy"
        },
        {
          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Data Mining Based Analysis of Hit-and-Run Crashes in Metropolitan City",
          "conferenceName": "in the 20th Congress of the International Ergonomics Association (IEA 2018)",
          "date": "August 2018",
          "place": "Florence – Italy"
        },
        {
          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Risk Factors Associated With Accident Severity In Urban Chennai",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {

          "authorName": "Sathish kumar Sivasankaran, Rahul Bharadwaj, Venkatesh Balasubramanian",
          "paperName": "Comparative assessment of mini mental state examination in bus drivers for on road and simulator study conditions",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {

          "authorName": "Sathish kumar Sivasankaran, Rahul Bharadwaj, Venkatesh Balasubramanian",
          "paperName": "Subjective evaluation of musculoskeletal disorders among fatal and non-fatal bus drivers in different scenarios",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {

          "authorName": "Sathish kumar Sivasankaran, Venkatesh Balasubramanian",
          "paperName": "Risk factors associated with accident severity in urban Chennai",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {

          "authorName": "Rahul Bhardwaj, Sathish Kumar Sivasankaran, Venkatesh Balasubramanian",
          "paperName": "Comparison of Fatigue Trend among Different Aged Driver With and Without PTSD on Simulator and On-road Driving",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {

          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Ergonomic risk assessment of operators in shop floor CNC Environments",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2014",
          "place": "IIT Guwahati"
        },
        {

          "authorName": "S.Sathish Kumar, R.Senthil Kumar and S.Jayavel",
          "paperName": "Numerical Investigation of Forced Convective Cooling of Electronic Components",
          "conferenceName": "in the proceedings of 22nd National and 11th International ISMHT-ASME Heat and Mass Transfer Conference",
          "date": "December 2013",
          "place": "IIT Kharagpur"
        },
        {

          "authorName": "S.Sathish Kumar, R.Senthil Kumar and S.Jayavel",
          "paperName": "Computation of Flow Past Various Cylinder Geometries",
          "conferenceName": "in the proceedings of Indian Conference on Applied Mechanics (INCAM)",
          "date": "May 2013",
          "place": "IIT Madras"
        },]
    },

    {
      "name": "Mr. Keerthi Kumar B",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/keerthi.jpg",
      "qualification": "Project Manager",
      "joinedOn": "2019",
    },

    {
      "name": "Mr. Manikandan D",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/mani.jpg",
      "qualification": "Junior Executive",
      "joinedOn": "2019",
    },
    {
      "name": "Mr. Kush Trivedi",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/kush.jpg",
      "qualification": "Senior Project Engineer",
      "joinedOn": "2020",
    },

    {
      "name": "Mr. Vishal Kannan",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/vishal.jpg",
      "qualification": "Project Engineer",
      "joinedOn": "2020",
    },
    {
      "name": "Mr. Praveen Kumar",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/praveen.jpg",
      "qualification": "Project Associate",
      "joinedOn": "2020",
    },
    {
      "name": "Ms. Lavanya",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/lavanyak.jpg",
      "qualification": "software developer",
      "joinedOn": "2018",
    },
    {
      "name": "Dr. Srinath",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Srinath.jpg",
      "qualification": "Senior Manager",
      "joinedOn": "2020",
    },

    {
      "name": "Ms. Minerva",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Minerva.jpg",
      "qualification": "Senior Manager",
      "joinedOn": "2020",
    },

    {
      "name": "Ms. Swathy P",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Swathy.jpg",
      "qualification": "Senior Manager",
      "joinedOn": "2020",
    },
    {
      "name": "Dr. Nijina M Nazar",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/nijina.jpg",
      "qualification": "Senior Manager",
      "joinedOn": "2020",
    },


    {
      "name": "Vadhul Krishnan V",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/vadhul.jpg",
      "qualification": "Project Engineer",
      "joinedOn": "2020",
    },
    {
      "name": "Bhagavath Sinth",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/bhagavath.jpg",
      "qualification": "Project Engineer",
      "joinedOn": "2020",
    },
    {
      "name": "Praveen R.J",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/praveenrj.jpg",
      "qualification": "Junior Technician",
      "joinedOn": "2020",
    },
    {
      "name": "Giri Goutham",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/giri.jpg",
      "qualification": "Project Associate",
      "joinedOn": "2020",
    },


















  ];



  public personalwebpage = [
    {
      "name": "Mr. Venkataraman G, (IPS)",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/download.jpg",
      "qualification": "ADGP, Cyber Crime Wing, O/o the Director General of Police, Chennai",
      "joinedOn": "2018",
      // "AreaOfInterest": "Product Design and Manufacturing",
      // "buttonname1": "Curriculum vitae",
      // "cvLink": "https://ed.iitm.ac.in/~vb/assets/Gallery/Events/2_hari.pdf"

    },

    {
      "name": "Mr. Rangam Harikrishna",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Rangam.jpg",
      "qualification": "M.Tech (Industrial Design)",
      "joinedOn": "2018",
      "AreaOfInterest": "Product Design and Manufacturing",
      "buttonname1": "Curriculum vitae",
      "cvLink": "https://ed.iitm.ac.in/~vb/assets/Gallery/Events/2_hari.pdf"

    },
    {
      "name": "Mr. Harikrishna Manager, Ashok Leyland",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Harikrishna.jpg",
      "qualification": "B.E (Mechanical Engineering) ",
      "joinedOn": "2018",
      "AreaOfInterest": "Transportation Human Factors",
    },
    {
      "name": "Ms. Priya Natarajan",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/priya.jpg",
      "qualification": "M.Tech.(Biomedical Engineering)",
      "joinedOn": "2017",
      "AreaOfInterest": "Biomedical Devices and Rehabilitation Engineering",
      "about": "Main research interests lie in Human-machine/computer-interfaces and their application in Clinical Neurosciences, Human Factors, Artificial Intelligence Biomedical Signal Analysis",
      "conferencePublications": [{
        "number": "1",
        "authorName": "Priyadarshini Natarajan, Venkatesh Balasubramanian",
        "paperName": "Evaluation of Smartphone as a Real-Time Tool for Hand Tremor Assessment",
        "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
        "date": "December 2017",
        "place": "Aligarh Muslim University (AMU)"
      }]
    },
    {
      "name": "Ms. Minerva",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Minerva.jpg",
      "qualification": "M.Tech.(Biomedical Engineering)",
      "joinedOn": "2014",
      "areaOfInterest": "Cognitive Sciences, EEG Analysis, Sustained Attention",
      "about": "Mind wandering! An unavoidable phenomenon experienced by everyone at any time. My research area focuses on identifying the factors contributing to mind wandering and analyzing the underlying electrophysiological changes due to mind wandering.",
      "researchProposalTitle": "Detection of mind wandering using EEG",
      "researchProposal": "Humans often find themselves contemplating thoughts about past or future events which are completely irrelevant to the present task. Especially during reading and driving , thinking about random thoughts unrelated to current work is a common phenomenon experienced by all readers and drivers. This shift of attention from the current external task to internal thoughts which are task unrelated is referred to as mind wandering. Killingsworth & Gilbert (2010) had reported that individuals spent nearly 47% of their time mind wandering irrespective of the nature of the current work. Many studies had reported accidents, errors and decline in performance due to mind wandering during driving, lectures, continuous monitoring of patient’s critical signs and supervisory tasks in industries etc. Hence, detecting the onset of mind wandering might help prevent the mind from spending more time in task unrelated thoughts and improve attention and performance. Thus, identifying the causal factors of mind wandering becomes essential to determine its onset.",
      "conferencePublications": [{
        "number": "1",
        "authorName": "Niketha Kailash, Minerva Rajendran, Swathy P., and Venkatesh Balasubramanian",
        "paperName": "Survey comparing lower extremity muscle pain in women wearing high heels and flat footwear",
        "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2014)",
        "date": "December 2014",
        "place": "IIT Guwahati"
      }]
    },
    {
      "name": "Ms. Swathy P",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/Swathy.jpg",
      "qualification": "M.Tech.(Biomedical Engineering) ",
      "joinedOn": "2014",
      "areaOfInterest": "Biosignal Processing",
      "about": "Distress is characterized by episodes of anxiety and depression. A transition from stress to distress has so far been studied through questionnaires and empirical evidence of the same is yet to be established. I am interested in determining the onset for distress from physiological manifestation. Research Interest: Bio Signal Processing, Psycho Physiology",
      "researchProposalTitle": "Characterising Distress",
      "researchProposal": "Distress as an aversive, negative state in which coping and adaptation processes fail to return an organism to physiological and/or psychological homeostasis. Epidemiological study by National Mental Health Survey of India (NMHS), 2015-16, has reported 10.3% of noncommunicable diseases accounting to psychological distress. Distress has also been a causal factor of neural degenerative diseases, cardiovascular ailments and respiratory disorders. Progressive maladaptation to severe or prolonged stressor results in transition from stress to distress. This necessitates a study to understand body’s response to such stressor in order to help people adapt to the distress. Changes in heart rate variability, blood pressure, galvanic skin response, symmetry in electrical activity of brain, electrical activities of muscle and presence of biomarkers such as cortisol, salivary amylase are objective metrics of distress. These physiological measurements have only served as monitoring tool in people already clinically diagnosed with distress. Empirical evidences of transition from stress to distress are yet to be explored. The proposed research aims at establishing the transition by measuring onset of distress using physiological measurements on a predetermined group of people by conducting a longitudinal study.",
      "conferencePublications": [{
        "number": "1",
        "authorName": "P Swathy and V. Balasubramanian",
        "paperName": "EMG Based human computer interfacefor below knee amputee",
        "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2014)",
        "date": "December 2014",
        "place": "IIT Guwahati"
      }]
    },
    {
      "name": "Mr. Sathish kumar Sivasankaran",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/sathish.jpg",
      "qualification": "M.Des.(Mechanical Systems Design)",
      "joinedOn": "2014",
      "buttonname1": "Curriculum vitae",
      "cvLink": "https://ed.iitm.ac.in/~vb/assets/Gallery/Events/CV_Sathish Kumar Sivasankaran.pdf",
      "areaOfInterest": "Human factors in Transportation, Road accident analysis, Road Safety, Ergonomics for improving productivity, Industrial Ergonomics, Occupational ergonomics, Human factors in Design",
      "about": "Mr. Sathish kumar Sivasankaran is currently Doctoral Student at the Rehabilitation Bioengineering Group, Department of Engineering Design, IIT Madras. His research and work interest broadly spans the field of Human factors and Ergonomics. Currently he works on Human factors in Transportation, Road accident analysis, Road Safety, Ergonomics for improving productivity, Industrial Ergonomics and Occupational ergonomics.",
      "researchProposalTitle": "Investigation of factors associated with road crashes due to occupant behaviours and pedestrians in indian scenarios",
      "researchProposal": "The safety of pedestrians and occupants is of growing concern with an increasing number of traffic accidents, especially in developing economies like India. Report by Ministry of Road Transport and Highways (MoRTH, 2017) shows that fatality victims in the country are majorly due to behaviours of the occupants and pedestrians. The major problem in analysing the crash data and determining the risk factors is the availability of data in these nations. In the recent past, there has been increased interest in developing nations to measure the risk involved in crashes and to propose remedial measures for them. Despite this, little has been explored to understand the risk factors associated with the behaviour of occupants and pedestrians, particularly in developing nations. The primary objective of this research study is to examine the possible causes and the contributing factors to the crashes. The secondary aim of this research study is to develop crash prediction models for the process of investigation. Therefore interdependence of factors that contribute to pedestrian crashes is explored in this research study. The commonly faced behavioural problem of occupants (drivers) which contributes significantly to the crashes but are least explored in the context of developing nations (i.e) Pedestrian hit-and-run crashes and exceeding speed limits are studied here. This study used the data from the Government of Tamilnadu Road Accident Traffic Management System (RADMS) database, to analyse accident data related to pedestrian crashes and other occupant behaviours. Pedestrian safety is of growing concern with an increasing number of traffic accidents in Tamilnadu.In 2017, there were 20, 457 pedestrian fatalities in India.In this study, Multiple Correspondence Analysis(MCA), an exploratory data analysis technique was used to explore the roadway, traffic, crash, and pedestrian- related variables influencing pedestrian crashes.The results of the study show that crashes occurring on the express highways on a multilane road are often associated with hit - and - run behaviour among drivers.Factors such as lighting conditions, location, pedestrian behaviour, crossings, and physical separation are also significantly contributing to pedestrian crashes.The study identifies a possible association between various contributing factors.\nHit-and-run crashes are a serious road safety problem threatening the world especially in developing economies like India. The recent figures according to the Ministry of Road Transport and Highways (MoRTH), Government of India shows that hit-and-run crashes account for 11.6% (55,942) of all crashes and number of people died due to hit-and-run crashes was 15.2% (22,962) of total persons killed in the country during 2016. Traffic deaths and injuries due to speeding (i.e., driving above the speed limits) and inappropriate speed (i.e., driving too fast for the given conditions, within limits) is also the most important driver error responsible and has accounted for 66.5% of driver error related faults in India.Pedestrian hit- and - run crash models were developed to investigate risk factors.Results show that the perpetrator's tendency to leave the spot of crash increases in the dark unlighted conditions. Increased likelihood of hit-and-run crashes is found during summer, winter season and in urban areas. Among pedestrian characteristics, pedestrians who are intoxicated, pedestrian locations such as footpath, crossing the road and shoulder, pedestrian victims who are injured, significantly contribute to hit-and-run crashes. Factors such as day of the week, road category, collision cause, vehicle type, vehicle maneuver, weather conditions, driver alcohol status, pedestrian residence type, and traffic movement were found to be statistically not significant with a 95% confidence interval.Lastly, the speeding behaviour of drivers was examined to identify significant risk factors associated with this traffic violation in Chennai City using recent two - year crash data.Risk factors including driver characteristics, vehicle, environmental and crash / accident attributes were considered.Contingency tables were constructed to assess the association between the risk factors and speeding behaviour at a 10 % significance level.Results showed that(i) male drivers, (ii) drivers without a valid driving license, (iii) single lane roads, (iv)uncontrolled junction roads, (v) all type of vehicles, (vi) presence of central dividers(vii) daylight were associated with speeding - related accidents.The models developed in this research have viable applications including the identification of critical factors that influence the occupants including pedestrians and their behaviours on road.The results of the present research support the idea that identifying influencing factors and site features(spatial variables) could improve the safety aspects of the occupants in this state as well as in the developing nations.Moreover, policies and road safety strategies(introducing nation - wide crash database with a good collection of quality data, enforcement of traffic laws, enforcing speed limits, understanding legal contexts, improving practices, etc…) are need of the hour to safeguard the occupants and improve their behaviour in the developing nations.",
      "journalPublications": [
        {
          "number": "1",
          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Investigation of factors contributing to pedestrian hit-and-run crashes in India",
          "conferenceName": "Journal of Transportation Safety & Security",
          "date": "2020",
          "place": ""
        },
        {
          "number": "2",
          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": " Exploring the Severity of Bicycle - Vehicle Crashes Using Latent Class Clustering Approach in India",
          "conferenceName": "Journal of Safety Research",
          "date": "2020",
          "place": ""
        },
        {
          "number": "3",
          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Investigation of Pedestrian crashes using Multiple Correspondence Analysis in India",
          "conferenceName": "International Journal of Injury Control and Safety Promotion, DOI: 10.1080 / 17457300.2019.1681005",
          "date": "2019",
          "place": ""
        }, {
          "number": "4",
          "authorName": "Venkatesh Balasubramanian and Sathish Kumar Sivasankaran",
          "paperName": "Analysis of factors associated with exceeding lawful speed traffic violations in Indian metropolitan city",
          "conferenceName": "Journal of Transportation Safety and Security, DOI: 10.1080/19439962.2019.1626962",
          "date": "2019",
          "place": ""
        }],

      "conferencePublications": [
        {
          "authorName": "Sathish Kumar Sivasankaran,Priya Natarajan and Venkatesh Balasubramanian",
          "paperName": "Identification of Contributing Factors in Vehicle Pedestrian Crashes in Chennai using Multiple Correspondence Analysis",
          "conferenceName": "15th World Conference on Transport Research 2019, WCTRS 2019,",
          "date": "May 2019",
          "place": "Mumbai - India"
        },
        {
          "authorName": "Sathish Kumar Sivasankaran,Priya Natarajan and Venkatesh Balasubramanian",
          "paperName": "Identifying Patterns of Pedestrian Crashes in Urban Metropolitan Roads in India using Association Rule Mining",
          "conferenceName": "15th World Conference on Transport Research 2019 , WCTRS 2019,",
          "date": "May 2019",
          "place": "Mumbai - India"
        },
        {

          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Analysis of Driver Injury Severity in Metropolitan Roads of India Through Classification Tree",
          "conferenceName": "in the 20th Congress of the International Ergonomics Association (IEA 2018)",
          "date": "August 2018",
          "place": "Florence – Italy"
        },
        {
          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Data Mining Based Analysis of Hit-and-Run Crashes in Metropolitan City",
          "conferenceName": "in the 20th Congress of the International Ergonomics Association (IEA 2018)",
          "date": "August 2018",
          "place": "Florence – Italy"
        },
        {
          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Risk Factors Associated With Accident Severity In Urban Chennai",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {

          "authorName": "Sathish kumar Sivasankaran, Rahul Bharadwaj, Venkatesh Balasubramanian",
          "paperName": "Comparative assessment of mini mental state examination in bus drivers for on road and simulator study conditions",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {

          "authorName": "Sathish kumar Sivasankaran, Rahul Bharadwaj, Venkatesh Balasubramanian",
          "paperName": "Subjective evaluation of musculoskeletal disorders among fatal and non-fatal bus drivers in different scenarios",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {

          "authorName": "Sathish kumar Sivasankaran, Venkatesh Balasubramanian",
          "paperName": "Risk factors associated with accident severity in urban Chennai",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {

          "authorName": "Rahul Bhardwaj, Sathish Kumar Sivasankaran, Venkatesh Balasubramanian",
          "paperName": "Comparison of Fatigue Trend among Different Aged Driver With and Without PTSD on Simulator and On-road Driving",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {

          "authorName": "Sathish Kumar Sivasankaran and Venkatesh Balasubramanian",
          "paperName": "Ergonomic risk assessment of operators in shop floor CNC Environments",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE)",
          "date": "December 2014",
          "place": "IIT Guwahati"
        },
        {

          "authorName": "S.Sathish Kumar, R.Senthil Kumar and S.Jayavel",
          "paperName": "Numerical Investigation of Forced Convective Cooling of Electronic Components",
          "conferenceName": "in the proceedings of 22nd National and 11th International ISMHT-ASME Heat and Mass Transfer Conference",
          "date": "December 2013",
          "place": "IIT Kharagpur"
        },
        {

          "authorName": "S.Sathish Kumar, R.Senthil Kumar and S.Jayavel",
          "paperName": "Computation of Flow Past Various Cylinder Geometries",
          "conferenceName": "in the proceedings of Indian Conference on Applied Mechanics (INCAM)",
          "date": "May 2013",
          "place": "IIT Madras"
        },]
    },
    {
      "name": "Ms. Sivasankari",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/18.jpg",
      "qualification": "B.E (Production Engineering) ",
      "joinedOn": "2012",
      "areaOfInterest": "Spine Modeling",
      "about": "Development and validation of Hi-fidelity 3D Finite Element Modelling and analysis of Lumbar & Thoracic Spine. This Research focuses on converting the medical images into the mechanical simulation model, in which the model is aimed at representing the high Fidel bio-mechanical behavior, as that of a human spine. Fidelity is to gain importance in terms of physiological mechanism and material behavior, by primarily developing and validating it, using the finite element tool",
      "researchProposalTitle": "Characterising Distress",
      "researchProposal": "Distress as an aversive, negative state in which coping and adaptation processes fail to return an organism to physiological and/or psychological homeostasis. Epidemiological study by National Mental Health Survey of India (NMHS), 2015-16, has reported 10.3% of noncommunicable diseases accounting to psychological distress. Distress has also been a causal factor of neural degenerative diseases, cardiovascular ailments and respiratory disorders. Progressive maladaptation to severe or prolonged stressor results in transition from stress to distress. This necessitates a study to understand body’s response to such stressor in order to help people adapt to the distress. Changes in heart rate variability, blood pressure, galvanic skin response, symmetry in electrical activity of brain, electrical activities of muscle and presence of biomarkers such as cortisol, salivary amylase are objective metrics of distress. These physiological measurements have only served as monitoring tool in people already clinically diagnosed with distress. Empirical evidences of transition from stress to distress are yet to be explored. The proposed research aims at establishing the transition by measuring onset of distress using physiological measurements on a predetermined group of people by conducting a longitudinal study.",
      "conferencePublications": [{
        "number": "1",
        "authorName": "Sivasankari and V. Balasubramanian",
        "paperName": "Validation Methodology for High Fidelity Numerical Spine and its Ergonomics Aspects."

      }]
    },

    {
      "name": "Dr. Rahul Bhardwaj",
      "profilePicture": "https://ed.iitm.ac.in/~vb/assets/Gallery/ProfilePicture/15.jpg",
      "qualification": "Ph.D",
      "joinedOn": "2012",
      "buttonname2": "Ph.D. Thesis",
      "areaOfInterest": "Human Factors in Transportation,  Road Safety, Sensor and System, Prduct Development",
      "about": "Mr. Rahul Bhardwaj is currently Doctoral Student at the Rehabilitation Bioengineering Group, Department of Engineering Design, IIT Madras. His research and work interest broadly spans the field of Human factors and Ergonomics especially in transportation safety and product development.",
      "researchProposalTitle": "Evaluation of Behaviour and Cognitive State to Improve Occupant and Pedestrian Safety",
      "researchProposal": "Road traffic accidents (RTA) are one of the biggest concerns in developing economies such as India, as it leads to huge socio-economical loss. Pedestrians are one of the important subset of road user hence their safety is major concern. There are many causal factors for vehicle-pedestrian crashes, and one of the key factors is the poor visibility in nocturnal conditions. In this study, while crossing the road in nocturnal condition where ambient light is minimal, recognition of proper vehicle approaching towards pedestrian and the time taken to correctly recognize have been estimated. Road accidents due to driver fatigue have been a big concern for researchers globally in the recent past since it is a major cause for a large proportion of accidents. Driver fatigue may be defined as the decline in performance of the driver and it leads to decrease in physiological arousal, distorted cognitive response and increase in reaction time, which can weaken a driver's cognitive ability. Driver fatigue is a very serious concern in transportation and it leads to a large number of accidents. Driver fatigue may occur in two forms; physical and mental/ cognitive fatigue. However, physical and cognitive fatigues are different from each other but depending on the circumstances, these two can co-exist together.",
      "journalPublications": [{
        "number": "1",
        "authorName": "Balasubramanian, V., and Bhardwaj, R.",
        "paperName": "Pedestrians’ Perception and Response towards Vehicles during Road-crossing at Nighttime",
        "conferenceName": "Accident Analysis & Prevention, 110, 128-135",
        "date": "2018",
        "place": ""
      },
      {
        "number": "2",
        "authorName": " Sivasankaran,KS., Bhardwaj, R., and Balasubramanian, V",
        "paperName": "Challenges and problem faced by bus drivers",
        "conferenceName": " Journal of road transport, 10, 12",
        "date": "2017",
        "place": ""
      }],
      "conferencePublications": [
        {
          "number": "1",
          "authorName": "Rahul Bhardwaj and Venkatesh Balasubramanian",
          "paperName": "Driver’s Cardiac Activity Performance Evaluation Based on Non-contact ECG System Placed at Different Seat Locations",
          "conferenceName": "20th Congress of the International Ergonomics Association (IEA 2018), Florence",
          "date": "August 26-30, 2018",
          "place": ""
        },
        {
          "number": "2",
          "authorName": "Rahul Bhardwaj and Venkatesh Balasubramanian",
          "paperName": "EEG Based Assessment of Pedestrian Perception of Automobile in Low Illumination Road",
          "conferenceName": "20th Congress of the International Ergonomics Association (IEA 2018), Florence",
          "date": "August 26-30, 2018",
          "place": ""
        },
        {
          "number": "3",
          "authorName": "Bhardwaj, R., Janannath. M and V. Balasubramanian",
          "paperName": "Changes in Steering Wheel Grip Interface Pressure during Simulated Driving",
          "conferenceName": "International Conference on Biosignals, Images and Instrumentation, 103",
          "date": "14-16 March",
          "place": ""
        },
        {
          "number": "4",
          "authorName": "Bhardwaj, R., and V. Balasubramanian",
          "paperName": "Optimization of Muscles Forces of Lower Arm in Car Driving",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2014)",
          "date": "December 2014",
          "place": "IIT Guwahati"
        },
        {
          "number": "5",
          "authorName": "Bhardwaj, R., and V. Balasubramanian",
          "paperName": " Palm Pressure Based Sensing of Automobile Driver Alertness",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2011)",
          "date": "December 2014",
          "place": "IIT Guwahati"
        },
        {
          "number": "6",
          "authorName": "Vijay, V., Bhardwaj, R., and V. Balasubramanian",
          "paperName": "Evaluation of Yoga Postures with sEMG",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2014)",
          "date": "December 2014",
          "place": "IIT Guwahati"
        },
        {
          "number": "7",
          "authorName": "Kailash, N.,Vijay, V., Bhardwaj, R., and V. Balasubramanian",
          "paperName": "Survey of Human Cognitive Response to Vehicles during Night Conditions",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2014)",
          "date": "December 2014",
          "place": "IIT Guwahati"
        },
        {
          "number": "8",
          "authorName": "Bhardwaj, R. and V. Balasubramanian",
          "paperName": "A Low Cost Reaction Time Estimator Based Hand Exercises for Stroke Rehabilitation",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2017)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {
          "number": "9",
          "authorName": "Piyus, C., Bhardwaj, R. and V. Balasubramanian",
          "paperName": "Virtual Reality based Training System for Autistic children",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2017)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {
          "number": "10",
          "authorName": "Bhardwaj, R., Sathish, K. S and V. Balasubramanian",
          "paperName": "Comparison of Fatigue Trend among Different Aged Driver With and Without PTSD on Simulator and On-road Driving",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2017)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {
          "number": "11",
          "authorName": "Sathish, K. S., Bhardwaj, R. and V. Balasubramanian",
          "paperName": "Subjective Evaluation of Musculoskeletal Disorders among Fatal and Non-Fatal Bus Drivers in Different Scenarios",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2017)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {
          "number": "12",
          "authorName": "Cherian, A., Bhardwaj, R. and V. Balasubramanian",
          "paperName": "Real-Time Driver Fatigue Detection from ECG Using Deep Learning Algorithm",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2017)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {
          "number": "13",
          "authorName": "Bhardwaj, R., Piyus, C. and V. Balasubramanian",
          "paperName": "Cognitive Assessment of Driver based on Deep Learning Using EEG Signals",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2017)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {
          "number": "14",
          "authorName": "Bhardwaj, R., Sathish, K. S and V. Balasubramanian",
          "paperName": "Assessment of Bus Driver Performance Based on Reaction Time on Simulator and On-road Driving",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2017)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        },
        {
          "number": "15",
          "authorName": "Sathish, K. S., Bhardwaj, R. and V. Balasubramanian",
          "paperName": "Comparative Assessment of Mini Mental State Examination in Bus Drivers for On Road and Simulator Study Conditions",
          "conferenceName": "in the proceedings of International Ergonomics Conference, Humanizing work and work environment (HWWE 2017)",
          "date": "December 2017",
          "place": "Aligarh Muslim University (AMU)"
        }]
    }
  ];
  public patents = {
    "Patents": [
      {
        "Number": "1",
        "Name": "V. Balasubramanian",
        "Tittle": "A steering assembly for monitoring and alerting a driver based on his/her fatigue and/or behavior",
        "Patent": "Indian Patent Application No. 1920/CHE/2013"
      },
      {
        "Number": "2",
        "Name": "V. Balasubramanian",
        "Tittle": "A seat assembly for monitoring and alerting a driver based on his/her fatigue and/or behavior",
        "Patent": "Indian Patent Application No. 1921/CHE/2013"
      },
      {
        "Number": "3",
        "Name": "S. Guhathakurta and V. Balasubramanian",
        "Tittle": "A Bioreactor for Tissue Engineering",
        "Patent": "Indian Patent Application No. 2062/CHE/2013"
      },
      {
        "Number": "4",
        "Name": "V. S. Anand and V. Balasubramanian",
        "Tittle": "Polymeric biomaterial for dental applications",
        "Patent": "Indian Patent Application No. 2709/CHE/2013"
      },
      {
        "Number": "5",
        "Name": "S. Guhathakurta and V. Balasubramanian",
        "Tittle": "Engineered Pericardium and Derivatives for uses in Medicine, Pharmaceuticals, Food and Cosmetics",
        "Patent": "Indian Patent Application No. 138/CHE/2014"
      },
      {
        "Number": "6",
        "Name": "V. Balasubramanian, S. Guhathakurta and S. Robert Rajkumar",
        "Tittle": "Electrophysiological monitoring of the heart using dry electrodes on non-traditional, non-boney regions of the chest",
        "Patent": "Indian Patent Application No. 940/CHE/2014"
      }

    ]
  }
  public reports = {
    "Reports": [
      {
        "Number": "1",
        "Name": "V. Balasubramanian",
        "Tittle": "Analysis of Muscle Fatigue and Objective Assessment of Ride Comfort in powered Two Wheeler Development",
        "ReportSubmittedTo": "Submitted to M/s TVS Motors",
        "Date": "September, 2009"
      },
      {
        "Number": "2",
        "Name": "V. Balasubramanian",
        "Tittle": "Objective Trainee Assessment using Wearable Wireless Sensor during Small Arms Firing",
        "ReportSubmittedTo": "Submitted to Simulator Development Division, Army Training Command, India",
        "Date": "July, 2009"
      },
      {
        "Number": "3",
        "Name": "V. Balasubramanian and K. Adalarasu",
        "Tittle": "Analysis of Muscle Fatigue during Indoor Rowing",
        "ReportSubmittedTo": " Submitted to M/s National Sports Medicine Center",
        "Date": " February,2009"
      },
      {
        "Number": "4",
        "Name": "V. Balasubramanian",
        "Tittle": "Finite Element ATD Neck Model for use in Rollover Simulations",
        "ReportSubmittedTo": "Submitted to India Science Lab of M/s General Motors R&D",
        "Date": "October, 2007"
      },
      {
        "Number": "5",
        "Name": "V. Balasubramanian and T. T. Narendran",
        "Tittle": "Ergonomic Evaluation and Productivity Improvement for EM Shop Floor",
        "ReportSubmittedTo": "Submitted to M/s Wheels India Limited",
        "Date": "September, 2007"
      },
      {
        "Number": "6",
        "Name": "V. Balasubramanian",
        "Tittle": "Ergonomics in Manufacturing and Product Design",
        "ReportSubmittedTo": "Proc of Technology Appreciation Program, IIT Madras",
        "Date": "September, 2007"
      },
      {
        "Number": "7",
        "Name": "V. Balasubramanian and T. T. Narendran ",
        "Tittle": "Ergonomic Evaluation and Productivity Improvement for LP Shop Floor",
        "ReportSubmittedTo": "Submitted to M/s Wheels India Limited",
        "Date": " October, 2006"
      },
      {
        "Number": "8",
        "Name": "V. Balasubramanian and T. T. Narendran",
        "Tittle": "Planning Layout Optimization and Work Place Design",
        "ReportSubmittedTo": "Submitted to M/s BorgWarner Cooling Systems India Ltd",
        "Date": " October, 2006"
      },
      {
        "Number": "9",
        "Name": "V. Balasubramanian and T. T. Narendran",
        "Tittle": "Productivity Improvement and Resource Planning",
        "ReportSubmittedTo": "Submitted to M/s Leather Crafts India Limited",
        "Date": " October,2005"
      },
      {
        "Number": "10",
        "Name": "V. Balasubramanian and T. T. Narendran",
        "Tittle": "Ergonomic Evaluation and Productivity Improvement for CV Shop Floor",
        "ReportSubmittedTo": " Submitted to M/s Wheels India Limited",
        "Date": " October, 2006"
      },
      {
        "Number": "11",
        "Name": "V. Balasubramanian and T. T. Narendran",
        "Tittle": "Ergonomic Evaluation and Productivity Enhancement of Leather Manufacturing Workplace",
        "ReportSubmittedTo": " Submitted to M/s Rabia Industries Limited, India ",
        "Date": " October, 2005"
      },
      {
        "Number": "12",
        "Name": "V. Balasubramanian and T. T. Narendran",
        "Tittle": "Ergonomic Evaluation and Productivity Enhancement of Leather Manufacturing Workplace",
        "ReportSubmittedTo": "Submitted to M/s Rabia Industries Limited, India",
        "Date": " October, 2005"
      },
      {
        "Number": "13",
        "Name": "V. Balasubramanian",
        "Tittle": "Biomechanical assessment of Prospective A1 Race car Drivers for Team India",
        "Date": " August, 2005"
      },
      {
        "Number": "14",
        "Name": "V. Balasubramanian",
        "Tittle": "Ergonomics of Computer Centric Workplaces",
        "ReportSubmittedTo": " Proc of Technology Appreciation Program, IIT Madras",
        "Date": " September, 2005"
      },
      {
        "Number": "15",
        "Name": "V. Balasubramanian, S. K. M. Varadhan, G. Swami Prasad and T. T. Narendran",
        "Tittle": "Ergonomic Evaluation of ITES Office Workplace",
        "ReportSubmittedTo": " Submitted to M/s Sundaram Business Solutions, India",
        "Date": " May, 2005"
      },
      {
        "Number": "16",
        "Name": "V. Balasubramanian",
        "Tittle": "Primer Course in Biomedical Engineering",
        "ReportSubmittedTo": " Proc of AICTE Sponsored Workshop on Biomedical engineering, IIT Madras",
        "Date": " June, 2004"
      },
      {
        "Number": "17",
        "Name": "V. Balasubramanian,  K. Adalarasu, and R. Ranganathan",
        "Tittle": "Wheelchair Accessibility in IIT Madras – A Study Report",
        "ReportSubmittedTo": " Presented to The Director, IIT Madras, Chennai",
        "Date": " June, 2003"
      },
      {
      "Number":"18",
      "Name":"V. Balasubramanian",
      "Tittle":"Developing a Commercially Viable Real-Time Driver Behaviour and Fatigue Monitoring System",
      "ReportSubmittedTo":"Submitted to Ministry of Road Transport & Highways, New Delhi",
      "Date": "November 2020"
      },
      {

      "Number":"19",
      "Name":"V. Balasubramanian",
      "Tittle":"Identifying Real Time Physiological Parameters to Test Physical and Cognitive Fatigue While Driving",
      "ReportSubmitted":"Submitted to Transport Commissioner, Government of Tamil Nadu",
      "Date":"August 2017"
      },
      {
        "Number":"20",
      "Name":"66.	G. Swami Prasad, S. K. M. Varadan and V. Balasubramanian ",
      "Tittle":"Low back pain in bar benders",
      "ReportSubmitted":"Advanced Biotech, Vol 3 (7), 15",
      "Date":"2005"
      }





    ]
  }
  public manufacturing = [

    {
      "authorName": [21, 0],
      "paperName": "Ergonomic Risk Assessment of operators in CNC machining environments",
      "conferenceName": "International Ergonomic Conference, HWWE 2014",
      "Date": "December 3-5, 2014"
      // "paperlink":""
    },
    {
      "authorName": [22, 0, 9],
      "paperName": "Modified shift system to improve productivity and worker well-being",
      "conferenceName": "International Ergonomic Conference, HWWE 2014",
      "Date": "December 3-5, 2014",
      //"paperlink":"Ergonomic Risk Assessment of operators in CNC machining environments"
    },
    {
      "authorName": [22, 0, 9],
      "paperName": "Rotational work schedule to improve productivity - A case study in a production line",
      "conferenceName": "International Ergonomic Conference, HWWE 2014",
      "Date": "December 3-5, 2014"
      // "paperlink":""
    },
    {
      "authorName": [0, 9, 10],
      "paperName": "RBG Risk Scale – An Integrated Tool for Ergonomic Risk Assessments.",
      "conferenceName": "International Journal of Industrial and Systems Engineering, [Accepted for Publication]",
      "Date": "2010",
      "paperlink": "https://www.inderscienceonline.com/doi/abs/10.1504/IJISE.2011.040768"
    },
    {
      "authorName": [0],
      "paperName": "Is intermittent walking a better alternative to stationary standing in shop floor design?",
      "conferenceName": "International Ergonomics Conference, HWWE 2009, Kolkata",
      "Date": "December 17-19, 2009",
      "paperlink": "https://onlinelibrary.wiley.com/doi/abs/10.1002/hfm.20132"
    },
    {
      "authorName": [0, 2, 23],
      "paperName": "Comparing Dynamic and Stationary Standing Postures in an Assembly Task",
      "conferenceName": " International Journal of  Industrial Ergonomics, DOI: 10.1016/j.ergon.2008.10.017",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S0169814108001546"
    },
    {
      "authorName": [0, 2, 23],
      "paperName": "Influence of a Dynamic Standing Posture on Standing Fatigue and Comfort during Shop-Floor Duties",
      "conferenceName": "Human Factors and Ergonomics in Manufacturing, Vol 18, No. 6, 666-677",
      "Date": "2008",
      "paperlink": "https://www.researchgate.net/publication/223581883_Comparing_dynamic_and_stationary_standing_postures_in_an_assembly_task"
    },
    {
      "authorName": [24, 0, 9],
      "paperName": "Lessons from Implementing TQM in Leather SME",
      "conferenceName": "Proc 7th Manufacturing Summit, pp 17-23, Mumbai",
      "Date": "September 22-23, 2008"
      // "paperlink":""
    },
    {
      "authorName": [0, 25, 9],
      "paperName": "Conducting an Ergonomic Risk Intervention Program in a Manufacturing Industry – A Case Study",
      "conferenceName": "Proc 7th Manufacturing Summit, pp 25-31, Mumbai",
      "Date": "September 22-23, 2008"
      // "paperlink":""
    },
    {
      "authorName": [0, 20],
      "paperName": "Manual Bar Bending – an Occupational Hazard for Construction Workers in Developing Nations",
      "conferenceName": "ASCE Journal  of Construction Engineering and Management, Volume 133, Issue 10, pp. 791-797",
      "Date": "2007",
      "paperlink": "https://www.researchgate.net/publication/245283714_Manual_Bar_Bending-An_Occupational_Hazard_for_Construction_Workers_in_Developing_Nations#:~:text=Manual%20Bar%20Bending%E2%80%94An%20Occupational%20Hazard%20for%20Construction%20Workers%20in%20Developing%20Nations,-Article%20in%20Journal&text=Bar%20bending%20is%20the%20process,in%20civil%20and%20construction%20engineering.&text=Fc%20was%20higher%20than%20the,when%20bending%208%20mm%20bars."
    },
    {
      "authorName": [0, 20],
      "paperName": "An EMG-based ergonomic evaluation of manual bar bending",
      "conferenceName": "International Journal of Industrial and Systems Engineering, 2(3), 299-310",
      "Date": "2007",
      "paperlink": "https://www.inderscienceonline.com/doi/abs/10.1504/IJISE.2007.012464"
    },
    {
      "authorName": [0, 20],
      "paperName": "Ergonomic assessment of Manual Bar Cutting of Reinforcement Bars in Civil Construction.",
      "conferenceName": "International Journal of Industrial and Systems Engineering, vol. 1 (3), 321–332",
      "Date": "2007",
      "paperlink": "https://www.researchgate.net/publication/245528344_Ergonomic_assessment_of_bar_cutting_process_in_construction"
    },
    {
      "authorName": [0, 20, 26],
      "paperName": "Quantitative Evaluation of Low Back Pain in Bar Benders",
      "conferenceName": "NICMAR Journal of  Construction Management, vol. 20 (4), 31–36",
      "Date": "2005"
      // "paperlink":""
    },
    {
      "authorName": [0, 20],
      "paperName": "Ergonomic Assessment of Bar Cutting Process in Construction",
      "conferenceName": "International conference on Ergonomics, HWWE 2005",
      "Date": "Dec 10–12, 2005",
      "paperlink": "https://www.researchgate.net/publication/245528344_Ergonomic_assessment_of_bar_cutting_process_in_construction"
    },
    {
      "authorName": [20, 26, 0],
      "paperName": "Low back pain in bar benders",
      "conferenceName": "Advanced Biotech, Vol 3 (7), 15",
      "Date": "2005"
      // "paperlink":""
    },
    {
      "authorName": [0, 20, 12],
      "paperName": "Biomechanical Analysis of Manual Bar Bending in Civil Construction",
      "conferenceName": "Proc. National Conference on Humanizing Work and Working Environment, India",
      "Date": "2004",
      "paperlink": "https://ascelibrary.org/doi/abs/10.1061/%28ASCE%290733-9364%282007%29133%3A10%28791%29"
    }
  ];
  public neuroscience = [
    {
      "authorName": [5, 0],
      "paperName": "A Low Cost Reaction Time Estimator based Hand Exercises for Stroke Rehabilitation",
      "conferenceName": "International Ergonomics Conference, HWWE 2017",
      "Date": "December 8-10, 2017",
      "paperlink": "https://www.springerprofessional.de/en/a-low-cost-reaction-time-estimator-based-hand-and-foot-exercises/18996426"
    },
    {
      "authorName": [102, 5, 0],
      "paperName": "Virtual Reality based Training System for Autistic Children",
      "conferenceName": "International Ergonomics Conference, HWWE 2017",
      "Date": "December 8-10, 2017"
      // "paperlink":""
    },
    {
      "authorName": [104, 0],
      "paperName": "Evaluation of Smartphone as a Real-Time Tool for Hand Tremor assessment",
      "conferenceName": "International Ergonomics Conference, HWWE 2017",
      "Date": "December 8-10, 2017"
      // "paperlink":""
    },
    {
      "authorName": [45, 0],
      "paperName": "EMG Based human computer interfacefor below knee amputee",
      "conferenceName": "International Ergonomic Conference, HWWE 2014",
      "Date": "December 3-5, 2014",
      "paperlink": "https://www.researchgate.net/publication/303173283_EMG_Based_human_computer_interface_for_below_knee_amputee"
    },
    {
      "authorName": [46, 47, 45, 0],
      "paperName": "Survey comparing lower extremity muscle pain in women wearing high heels and flat foot wear",
      "conferenceName": "International Ergonomic Conference, HWWE 2014",
      "Date": "December 3-5, 2014",
      "paperlink": "https://www.researchgate.net/publication/303173029_Survey_Comparing_Lower_Extremity_Muscle_Pain_in_Women_Wearing_High_Heels_and_Flat_Footwear"
    },
    {
      "authorName": [0, 1, 2],
      "paperName": "EEG based evaluation of viewer's response towards TV commercials",
      "conferenceName": "International Journal of Industrial and Systems Engineering, 13 (4),480-495",
      "Date": "2012",
      "paperlink": "https://www.inderscienceonline.com/doi/abs/10.1504/IJISE.2013.052611"
    },
    {
      "authorName": [0, 2, 48],
      "paperName": "Product Human Factors Evaluation in TV Commercials Using Psychophysical Test",
      "conferenceName": "International Ergonomics Conference HWWE 2009, Kolkata",
      "Date": "December 17-19, 2009"
      // "paperlink":""
    },
    {
      "authorName": [2, 0],
      "paperName": "Muscle Fatigue in Young Professional Female Athletes during Ergometer Rowing",
      "conferenceName": "International Ergonomics Conference HWWE 2009, Kolkata",
      "Date": "December 17-19, 2009"
      // "paperlink":""
    },
    {
      "authorName": [0],
      "paperName": "Multimodal Human System Interface Using Physiological Signals",
      "conferenceName": "National Workshop on Scientific computing on Biomedical Engineering, Agra",
      "Date": "August 30-31, 2008"
      // "paperlink":""
    },
    {
      "authorName": [8, 49, 0],
      "paperName": "A sEMG based analysis of muscle activity during mobile phone SMS",
      "conferenceName": "International Ergonomics Conference HWWE 2007, Bhopal",
      "Date": "December 10-12, 2007"
      // "paperlink":""
    },
    {
      "authorName": [50, 0, 9],
      "paperName": "EEG Based Statistical Analysis of the Effect of Microtonal Music on Human CNS",
      "conferenceName": "Proc 12th International Conference on Biomedical Engineering (ICBME 2005), Singapore",
      "Date": "Dec 7–10, 2005"
      // "paperlink":""
    },
    {
      "authorName": [0],
      "paperName": "Closing the Feedback Loop in Simulators",
      "conferenceName": "Proc. National Seminar on Use of Simulator in Defense Forces, India",
      "Date": "2005"
      // "paperlink":""
    },
    {
      "authorName": [15, 0, 53],
      "paperName": "Independent Component Analysis of Generalized Tonic Clonic Seizure",
      "conferenceName": "Innovation and Technology in Biology and Medicine (ITBM-RBM), vol. 27, 19–24",
      "Date": "2006",
      "paperlink": "https://www.researchgate.net/publication/223765316_Independent_component_analysis_of_generalized_tonic_clonic_seizure"
    },
    {
      "authorName": [73, 52, 0, 74],
      "paperName": "Texture Analysis of Foot Sole Soft Tissue Images in Diabetic Neuropathy Using Wavelet Transform",
      "conferenceName": "Medical & Biological Engineering & Computing, vol. 43 (6), 756–763",
      "Date": "2005",
      "paperlink": "https://link.springer.com/article/10.1007/BF02430954"
    },
    {
      "authorName": [15, 0, 53],
      "paperName": "Identification of Inter Ictal Abnormality of Complex Partial Seizure Using Independent Component Analysis and Fast Fourier Transforms",
      "conferenceName": "Proc 12th International Conference on Biomedical Engineering (ICBME 2005), Singapore",
      "Date": "Dec 7–10, 2005"
      // "paperlink":""
    },
    {
      "authorName": [15, 0, 52, 53],
      "paperName": "Quantitative Analysis of Absence Seizure",
      "conferenceName": "Advanced Biotech, Vol 3 (7), 14",
      "Date": "2005"
      // "paperlink":""
    },
    {
      "authorName": [51, 52, 0, 74],
      "paperName": "Foot Sole Soft Tissue Characterization in Diabetic Neuropathy Using Wavelet Transform",
      "conferenceName": "Proc of International Conference on Biomedical Engineering, Austria, 230–5",
      "Date": "May, 2005",
      "paperlink": "https://www.actapress.com/PaperInfo.aspx?paperId=44183"
    },
    {
      "authorName": [51, 52, 0, 74],
      "paperName": "Texture Characterization of Plantar Ulcers From Foot Sole Soft Tissue Ultrasound Images in Diabetic Neuropathy",
      "conferenceName": "National Conference on Image Processing (Sponsored by IEEE Signal Processing Society, IEEE and EMB), IISc Bangalore",
      "Date": "3rd–25th March 2005",
      "paperlink": "https://link.springer.com/article/10.1007/BF02430954"
    },
    {
      "authorName": [15, 0, 52, 53],
      "paperName": "Quantitative analysis of generalized tonic clonic seizures using ICA and wavelet transforms",
      "conferenceName": "Proc. International Conference of Biomedical Engineering and Telecommunication, Visakhapatnam, 222–224",
      "Date": "Dec 9–10, 2004",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S1297956205001452"
    },
    {
      "authorName": [51, 52, 0, 74, 75],
      "paperName": "Footsole soft tissue characterization in diabetic neuropathy using texture analysis,” Proc. National Conference on Biomechanics, Delhi, India, 26–33",
      "conferenceName": "Proc. National Seminar on Use of Simulator in Defense Forces, India",
      "Date": "November 2004",
      "paperlink": "https://pubmed.ncbi.nlm.nih.gov/16594303/"
    },
    {
      "authorName": [76, 52, 77, 0, 78, 75],
      "paperName": "Does increased In Hardness and Reduced Foot Sole Soft Tissue Thickness Cause Plantar Ulcers in Diabetic Neuropathy? A computer Simulated Analysis",
      "conferenceName": "International Conference on Wound healing , India ",
      "Date": "2003",
      "paperlink": "https://www.researchgate.net/publication/8580719_Three-dimensional_stress_analysis_for_the_mechanics_of_plantar_ulcers_in_diabetic_neuropathy"
    },
    {
      "authorName": [76, 52, 77, 0, 78, 75],
      "paperName": "Optimal Therapeutic Footwear In Diabetics – A Computer Simulated Analysis",
      "conferenceName": "Diabetics Society",
      "Date": "2002"
      // "paperlink":""

    },
    {
      "authorName":[0,104,2,114],
      "paperName":"Analyzing the Effect of Visual Cue on Physiological Hand Tremor Using Wearable Accelerometer Sensors",
       "conferenceName":"In Proceedings of the 21st Congress of the International Ergonomics Association (IEA 2021). Lecture Notes in Networks and Systems, vol 223, 2022. ",
      "Date":"",
      "paperlink":"https://link.springer.com/chapter/10.1007/978-3-030-74614-8_66"
      },

      {
        "authorName":[0,117],
        "paperName":"An Experimental Study to Analyze the Effects of Self Stretching and Postural Re Education Program for Classical Carnatic Violin Artistes in Reducing Playing Related Musculoskeletal Disorder (PRMD) of Cervical Flexor Muscle Group",
         "conferenceName":"In Proceedings of the 21st Congress of the International Ergonomics Association (IEA 2021). Lecture Notes in Networks and Systems, vol 222, 2021.",
        "Date":"2021",
        "paperlink":"http://repository-tnmgrmu.ac.in/6192/"
        },
        {
          "authorName":[0,127,128,119,120],
          "paperName":"The effects of Alpha/Theta neurofeedback due to Shirodhara Treatment",
           "conferenceName":"Virtual Seminar of Applied Mechanics, VSAM-2020, September 4-5, 2020.",
          "Date":"",
          //"paperlink":""
          }

  ];
  public ergonomics = [

    {
      "authorName": [79, 0, 85],
      "paperName": "Lean Ergonomics in Indian Postal Service - A Case Study",
      "conferenceName": "International Ergonomic Conference, HWWE 2014",
      "Date": "December 3-5, 2014",
      "paperlink": "https://www.researchgate.net/publication/311913497_Implementing_Lean_Ergonomics_in_Postal_Service_Industries"
    },
    {
      "authorName": [46, 47, 45, 0],
      "paperName": "Survey comparing lower extremity muscle pain in women wearing high heels and flat foot wear",
      "conferenceName": "International Ergonomic Conference, HWWE 2014",
      "Date": "December 3-5, 2014",
      "paperlink": "https://www.researchgate.net/publication/303173029_Survey_Comparing_Lower_Extremity_Muscle_Pain_in_Women_Wearing_High_Heels_and_Flat_Footwear"
    },
    {
      "authorName": [80, 81, 82, 2, , 0],
      "paperName": "Analysis of musculoskeleton problems in Indian Classical dancers",
      "conferenceName": "International Conference on Human Factros and Ergonomics, HWWE 2011",
      "Date": "December 15-17, p.91, 2011.",
      "paperlink":"https://www.semanticscholar.org/paper/Analysis-of-Lower-Extremity-Muscle-Flexibility-Anbarasi-Rajan/8c69c9cb1c3122bc87f331cb5253e3808d4c36be"
    },
    {
      "authorName": [1, 83, 0],
      "paperName": "Variation of physiological responses during treadmill jogging and weight-lifting",
      "conferenceName": "International Conference on Human Factros and Ergonomics, HWWE 2011",
      "Date": "December 15-17, p.91, 2011."
      // "paperlink":""
    }, {
      "authorName": [5, 84, 1, 0],
      "paperName": "Assessment of human hand grasp and release movement using sEMG",
      "conferenceName": "International Conference on Human Factros and Ergonomics, HWWE 2011",
      "Date": "December 15-17, p.91, 2011."
      // "paperlink":""
    },
    {
      "authorName": [26, 0],
      "paperName": "Analysis of Leg Muscle Fatigue Using Electromyography – Insights into Chair Ergonomics",
      "conferenceName": "Journal of Biomechanics, 39, S167",
      "Date": "2006",
      "paperlink": "https://www.researchgate.net/publication/246537275_Analysis_of_leg_muscle_fatigue_using_electromyography-Insights_into_chair_ergonomics"
    }, {
      "authorName": [26, 0],
      "paperName": "Analysis of Muscle Fatigue during Supported and Unsupported Sitting using Surface Electromyography",
      "conferenceName": "Proc of 3rd International Conference on Advances in Medical, signal and Information Processing, Glasgow, UK",
      "Date": "July 17 – 19, 2006",
      "paperlink": "https://ieeexplore.ieee.org/document/4225209"
    },
    {
      "authorName": [26, 0],
      "paperName": "Fatigue Differences of Leg Muscles Due to Change in Chair Height",
      "conferenceName": "9th International Fatigue Congress, Atlanta , Georgia , USA ",
      "Date": "May 14 – 19, 2006"
      // "paperlink":""
    },
    {
      "authorName": [8, 0],
      "paperName": "An EMG Based Muscle Fatigue Analysis of Computer Game Players",
      "conferenceName": "International conference on Ergonomics,      HWWE 2005 ",
      "Date": "Dec 10–12, 2005"
      // "paperlink":""
    },
    {
      "authorName": [2, 0],
      "paperName": "An EMG Based Ergonomic Evaluation of Chairs for Computer Related Works",
      "conferenceName": "International conference on Ergonomics, HWWE 2005 ",
      "Date": "Dec 10–12, 2005"
      // "paperlink":""
    },
    {
      "authorName": [26, 20, 9, 0],
      "paperName": "Ergonomic Assessment of Computer Workplace in ITES Establishment and Educational Institution",
      "conferenceName": "International conference on Ergonomics, HWWE 2005 ",
      "Date": "Dec 10–12, 2005"
      // "paperlink":""
    }
  ];
  public perceptional = [
    {
      "authorName": [0, 2, 91],
      "paperName": "Analysis of postural stability in diabetes/peripheral neuropathy during threshold level acceleration perturbation",
      "conferenceName": "(ISPGR 2005) P 196, XVIIth Conference of International Society for Posture and Gait Research – Marseille, France",
      "Date": "May 29th to June 2nd, 2005",
      "paperlink": "https://files.eric.ed.gov/fulltext/ED456594.pdf#page=436"
    },
    {
      "authorName": [0, 2, 91],
      "paperName": "Effect of Diabetes/Peripheral Neuropathy on Postural Stability at Threshold Level of Acceleration  Perturbation",
      "conferenceName": "Advanced Biotech, Vol 3 (7), 11",
      "Date": "2005"
      // "paperlink":""

    },
    {
      "authorName": [2, 0, 91],
      "paperName": "Effect of Diabetes/Peripheral Neuropathy on Ankle Strategy to Detect Perturbation",
      "conferenceName": "Advances in Medical Diagnostic Techniques and Procedures, Editors, M. Singh and S. Radhakrishnan, ISBN 81-88342-38-6, 82-85",
      "Date": "April, 2004"
      // "paperlink":""
    },
    {
      "authorName": [91, 92, 93, 0, 94, 95],
      "paperName": "Comparing Acceleration and Displacement Detection Thresholds to Short Anterior Platform Perturbations in Young Adults",
      "conferenceName": "Proc Soc for Neuroscience, New Orleans, LA",
      "Date": "Nov 2003",
      "paperlink": "https://www.researchgate.net/publication/224746635_Comparison_of_reaction_times_between_acceleration_and_displacement_threshold_testing_in_young_adults_on_an_anterior_translating_platform"
    },
    {
      "authorName": [93, 95, 96, 0, 97, 91],
      "paperName": "Imparted Energy Affects Reaction Times to Small Postural Disturbances",
      "conferenceName": "Proc Houston Society for Engineering in Medicine and Biology, Houston, Texas",
      "Date": "Apr 2003"
      // "paperlink":""
    },
    {
      "authorName": [0, 97, 91, 98, 99],
      "paperName": "Effect of Adult–Onset Diabetes and/or Peripheral Neuropathy on Acceleration Threshold Detection During Horizontal Translations",
      "conferenceName": "IEEE Engineering in Medicine and Biology Magazine, vol. 21 (2), 48",
      "Date": "2002"
      // "paperlink":""
    },
    {
      "authorName": [96, 100, 91, 0, 97, 99],
      "paperName": "Platform Movement Detection Latencies in Young Adults, Elders with Peripheral Neuropathy and Non-Diabetic Elders",
      "conferenceName": "Proc. Second Joint EMBS/BMES Conference, 2463-4, Houston , Texas ",
      "Date": "October 23-26,2002",
      "paperlink": "https://www.researchgate.net/publication/224726328_Platform_movement_detection_latencies_in_young_adults_elders_with_peripheral_neuropathy_and_non-diabetic_elders"
    },
    {
      "authorName": [96, 100, 91, 0, 97, 99],
      "paperName": "Detection Latencies to Platform Movement in Young and Elder Adults",
      "conferenceName": "Proc Soc for Neuroscience, Orlando, FL",
      "Date": "Nov 2002",
      "paperlink":"https://ieeexplore.ieee.org/document/1053376"
    },
    {
      "authorName": [97, 0, 91, 100, 99],
      "paperName": "Effects of Peripheral Neuropathy on Acceleration Thresholds of Short Linear Translations ",
      "conferenceName": "Annual Conference of VA Rehabilitation Research and Development",
      "Date": "2001"
      // "paperlink":""
    },
    {
      "authorName": [0, 100, 91],
      "paperName": "Postural Control Threshold Detection Mechanisms in Diabetes and Aging",
      "conferenceName": "Proc HSEMB",
      "Date": " Houston, 2001",
      "paperlink": "https://www.tandfonline.com/doi/abs/10.1080/00140130500071028"
    },
    {
      "authorName": [0],
      "paperName": "Postural balance and acceleration threshold detection for anterior horizontal translation in diabetic and non–diabetic elderly",
      "conferenceName": "Ph.D.,Louisiana Tech University, UMI, AAT 9995016, DAI-B 61/11, p. 5985",
      "Date": "  May 2001",
      "paperlink": "https://digitalcommons.latech.edu/dissertations/136/"
    },
    {
      "authorName": [101, 0, 100, 97, 99],
      "paperName": "Acceleration threshold detection for postural control in diabetes and aging",
      "conferenceName": "Proc Annual Society of Neuroscience",
      "Date": "2001",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S0966636202001893"
    },
    {
      "authorName": [0, 97, 91, 98, 99],
      "paperName": "Effect of adult-onset diabetes and/or peripheral neuropathy on acceleration threshold detection during horizontal translations [AWARD PAPER]",
      "conferenceName": "Proc. Rehabilitation Engineering and Assistive Technology Society of North America 2001 Annual Conference, 427-429, RESNA press",
      "Date": "2001",
      "paperlink": "https://www.ncbi.nlm.nih.gov/pmc/articles/PMC2945352/"
    },
    {
      "authorName": [0, 91],
      "paperName": "Models to Determine Acceleration Thresholds to Small Displacements",
      "conferenceName": "Annals of Biomedical Engineering, vol.29 (S1), S-15",
      "Date": "2001"
      // "paperlink":""
    },
    {
      "authorName": [101, 94, 0],
      "paperName": "Innovative Psychophysical Methods to Study Postural Stability",
      "conferenceName": "Symposium on Identifying Control Mechanisms for Postural Behaviors, UCLA, Los Angeles",
      "Date": "1998",
      "paperlink": "https://ieeexplore.ieee.org/abstract/document/744688"
    }
  ];
  public biomaterials = [
    {
      "authorName": [27, 0],
      "paperName": "Comparision of Bisphenol A (BPA) elution from a nanocomposite and microhybrid composite and its correlation to Degree of Conversion (DC)",
      "conferenceName": "Bio-medical Materials and Engineering.(Under Review)"
      // "paperlink":""
    },
    {
      "authorName": [28, 0, 29, 30, 31],
      "paperName": "Is Gamma Irradiation as a sterilization procedure required for decellularized xenogenic tissue material",
      "conferenceName": " Bio-medical Materials and Engineering.(Under Review)",
      "paperlink": "https://www.researchgate.net/publication/292347892_Is_Gamma_Irradiation_as_a_Secondary_Sterilization_Procedure_Required_for_Decellularized_Xenogenic_Tissue_Material"
    },
    {
      "authorName": [27, 0],
      "paperName": "Effect of resin chemistry on depth of cure and cytotoxicity of dental resin composites",
      "conferenceName": "Material Science and Engineering : Part B,181, 33-38",
      "Date": "2014",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S0921510713003140"
    },
    {
      "authorName": [27, 0],
      "paperName": "Sensitivity of different cell lines to dental resin based composites with different compositions",
      "conferenceName": " Material Science and Engineering: Part C",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S0109564115004698"
    },
    {
      "authorName": [28, 0, 32, 33, 34, 29, 35],
      "paperName": "Thrombogenicity studies of three different variants of processed bovine pericardium",
      "conferenceName": "ITBM-RBM, Vol 29, Issue 4, 223-230",
      "Date": "2008",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S1297956207000903"
    },
    {
      "authorName": [28, 0, 35],
      "paperName": "Processing Of Xenograft Conduit As Cardiovascular Implants",
      "conferenceName": " Tongariro National Conference of Cardio Thoracic and Vascular Surgery, New Zealand and Australia",
      "Date": "April 20-22, 2007"
      // "paperlink":""
    },
    {
      "authorName": [28, 36, 0, 37, 38, 33, 39, 35],
      "paperName": "Technique to Process Xenogenic Tissues for Cardio Vascular Implantation",
      "conferenceName": " Current Science, 91(8), 1068-1073",
      "Date": "2006",
      "paperlink": "https://www.researchgate.net/publication/279895814_Technique_to_process_xenogenic_tissues_for_cardiovascular_implantation_-_A_preliminary_report"
    },
    {
      "authorName": [28, 0, 35],
      "paperName": "Indigenously Processed Porcine Xenograft for Clinical Cardiovascular Applications",
      "conferenceName": " Indo-US conference on cardiovascular prosthetic devices, Trivandrum",
      "Date": "February 1-3, 2007",
      "paperlink": "https://academic.oup.com/icvts/article/12/3/360/758880"
    },
    {
      "authorName": [32, 0, 33, 34, 35, 28],
      "paperName": "Tissue engineered small vascular grafts from Human Cadaver Veins",
      "conferenceName": "Indo-US conference on cardiovascular prosthetic devices, Trivandrum",
      "Date": "February 1-3, 2007"
      // "paperlink":""
    },
    {
      "authorName": [41, 28, 0],
      "paperName": "Antimicrobial Processing of Xenografts for their Clinical Use",
      "conferenceName": "Indo-Australian Conference on Biomaterials, Implants, Tissue Engineering and Regenerative Medicine, Thiruvananthapuram",
      "Date": "January 10-12, 2007",
      "paperlink": "https://link.springer.com/article/10.1007/s12055-007-0049-y"
    },
    {
      "authorName": [42, 0, 43],
      "paperName": "Effect of Yoga and Pranayama on Lung Compliance after Fontan Operations",
      "conferenceName": "Proc of Scientific Validation, Testing and Evaluation of Alternative Medicine, IIT Delhi",
      "Date": "February, 2006"
      // "paperlink":""
    },
    {
      "authorName": [28, 36, 44, 35, 0],
      "paperName": "Decellularisation of Xenograft Tissue for Clinical Use",
      "conferenceName": "Proc of TESI Annual Meeting, Shanghai ,China",
      "Date": "Oct 22–25, 2005"
      // "paperlink":""
    },
    {
      "authorName": [28,44,106,107,108],
      "paperName": "“Generation of clinical-grade red blood cells from human umbilical cord blood mononuclear cells.” ",
       "conferenceName": "Cell and tissue research, 1-13, 2018. [IF 4.044, Cite Score __]",
      "Date": "2018",
      "paperlink": "https://link.springer.com/article/10.1007/s00441-018-2919-6"
      },
      {
        "authorName": [0,34,11,109,110,111,33,28],
        "paperName":"Post processing complete microbe free Porcine xenograft suitable for clinical use,",
         "conferenceName": "Indian Journal of Thoracic Cardiovascular Surgery, 23:240-245, 2007",
        "Date":"2007",
        "paperlink":""
        }
  ];
  public orthopaedic = [
    {
      "authorName": [54, 0],
      "paperName": "Validation methodology for high fidelity Numerical spine and its ergonomics aspects",
      "conferenceName": "International Ergonomic Conference, HWWE 2014",
      "Date": "December 3-5, 2014"
      // "paperlink":""
    },

    {
      "authorName": [0],
      "paperName": "Evolution of Total Knee Replacement ",
      "conferenceName": "2nd National SMF Knee Course on Total Knee Replacement",
      "Date": "July, 2003"
      // "paperlink":""
    },
    {
      "authorName": [0],
      "paperName": "Experimental Biomechanics",
      "conferenceName": "Continuum Mechanics Workshop, IIT Madras Chennai",
      "Date": "2002",
      "paperlink": "https://apm.iitm.ac.in/smlab/clr/acad.html"
    },
    {
      "authorName": [0],
      "paperName": "Total Joint Replacement",
      "conferenceName": "AICTE – ISTE Training Program on Recent Advances in Biomedical Engineering – Theory and Practice, pp 64-71",
      "Date": "2002"
      // "paperlink":""
    },
    {
      "authorName": [55, 56, 57, 58, 0, 72],
      "paperName": "Radiofrequency Treatment of Injured Rabbit ACL",
      "conferenceName": "Trans. Orthopaedic Research Society",
      "Date": "2002",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S0268003304002815"
    },
    {
      "authorName": [0, 59, 60, 61],
      "paperName": "Effect of flexion on stresses in UHMWPE tibial liner",
      "conferenceName": "Transactions of Orthopaedic Research Society, vol. 22, sec.2, Feb 9-13",
      "Date": "1997"
      // "paperlink":""
    },
    {
      "authorName": [62, 63, 64, 65, 0, 59, 61],
      "paperName": "Functional comparison of UHMWPE  intramedullary plugs used in cemented total hip arthroplasty",
      "conferenceName": "Poster presentation at the American Academy of Orthopaedic Surgeon",
      "Date": "1997"
      // "paperlink":""
    },
    {
      "authorName": [66, 67, 68, 0, 69],
      "paperName": "Similarities and differences in wear debris associated with failed total hip and knee arthroplasties",
      "conferenceName": "Scientific Exhibit at the American Academy of Orthopaedic Surgeon",
      "Date": "1997"
      // "paperlink":""
    },
    {
      "authorName": [0, 59, 60, 61],
      "paperName": "Correlation of stresses and wear in UHMWPE tibial liners",
      "conferenceName": " Podium Presentation at the Golden Triangle Biomechanics Research Symposium, Johns Hopkins University",
      "Date": "1997",
      "paperlink": "https://onlinelibrary.wiley.com/doi/abs/10.1002/(SICI)1097-4636(2000)53:1%3C100::AID-JBM14%3E3.0.CO;2-4"
    },
    {
      "authorName": [0, 59, 70, 60, 59],
      "paperName": "Correlation between stress distribution from finite element analysis and wear patterns in retrieved tibial liner",
      "conferenceName": "The Pittsburgh Orthopedics journal, vol. 8, 142-3",
      "Date": "1997"
      // "paperlink":""
    },
    {
      "authorName": [0, 59, 63, 71, 60, 61],
      "paperName": "A parametric study of stresses in UHMWPE tibial liner",
      "conferenceName": "Annals of Biomedical Engineering, vol. 24 (s1), 75;",
      "Date": "1996"
      // "paperlink":""
    },
    {
      "authorName": [0, 63, 69, 59],
      "paperName": "Stress analysis of UHMWPE tibial liner",
      "conferenceName": "The Pittsburgh Orthopedics Journal, vol. 7, 42-43",
      "Date": "1996",
      "paperlink": "https://onlinelibrary.wiley.com/doi/abs/10.1002/(SICI)1097-4636(2000)53:1%3C100::AID-JBM14%3E3.0.CO;2-4"
    },

    {
      "authorName":[27,0],
      "paperName":"“Correlation of elution and sensitivity of cell lines to dental composites,”",
       "conferenceName": "Dental Materials, Volume 32 (3), e63-e72, 2016. [IF 4.496, Cite Score 8.0]",
      "Date":"",
      "paperlink":"https://pubmed.ncbi.nlm.nih.gov/26792620/",
      },
      {
        "authorName":[0,101,112],
        "paperName":"“Analysis of postural stability in diabetes/peripheral neuropathy during threshold level acceleration perturbation”, ",
         "conferenceName":"International Journal of Scientific Research, Vol.16, 275 – 279, 2006",
        "Date":"2006",
        "paperlink":"https://ur.booksc.eu/book/18148383/4826b0"
        },
        {
          "authorName":[0,73,74,113],
          "paperName": "“Texture Analysis of Foot Sole Soft Tissue Images in Diabetic Neuropathy Using Wavelet Transform,” ",
           "conferenceName":"Medical & Biological Engineering & Computing, vol. 43 (6), 756–763, 2005. ",
          "Date":"2005",
          "paperlink":"https://pubmed.ncbi.nlm.nih.gov/16594303/"
          }
  ];

  public mining = [
    {
      "authorName": [21, 0],
      "paperName": "Applying fast and frugal tree heuristic algorithm to identify factors influencing crash severity of bicycle–vehicle crashes in Tamil Nadu",
      "conferenceName": "International Journal of Injury Control and Safety Promotion",
      "Date": "2020",
       "paperlink": "https://www.tandfonline.com/doi/full/10.1080/17457300.2020.1812669"
    },

    {
      "authorName": [21, 0],
      "paperName": "Investigation of factors contributing to pedestrian hit-and-run crashes in India",
      "conferenceName": "Journal of Transportation Safety & Security",
      "Date": "2020",
      "paperlink": "https://www.tandfonline.com/doi/full/10.1080/19439962.2020.1781313"
    },
    {
      "authorName": [21, 0],
      "paperName": "Exploring the Severity of Bicycle - Vehicle Crashes Using Latent Class Clustering Approach in India",
      "conferenceName": "Journal of Safety Research",
      "Date": "2020",
      "paperlink": "https://www.sciencedirect.com/science/article/pii/S002243751930670X"
    },
    {
      "authorName": [21, 0],
      "paperName": "Investigation of Pedestrian crashes using Multiple Correspondence Analysis in India",
      "conferenceName": "International Journal of Injury Control and Safety Promotion, DOI: 10.1080 / 17457300.2019.1681005",
      "Date": "2019",
      "paperlink": "https://www.tandfonline.com/doi/abs/10.1080/17457300.2019.1681005"
    },

    {
      "authorName": [0, 21],
      "paperName": "Analysis of factors associated with exceeding lawful speed traffic violations in Indian metropolitan city",
      "conferenceName": "Journal of Transportation Safety and Security, DOI: 10.1080/19439962.2019.1626962",
      "Date": "2019",
      "paperlink": "https://www.tandfonline.com/doi/abs/10.1080/19439962.2019.1626962"
    },
    {
      "authorName": [21, 0],
      "paperName": "Identification of Contributing Factors in Vehicle Pedestrian Crashes in Chennai using Multiple Correspondence Analysis",
      "conferenceName": "15th World Conference on Transport Research 2019, WCTRS 2019, Mumbai - India",
      "Date": "May 2019",
      "paperlink":"https://www.sciencedirect.com/science/article/pii/S2352146520305202"
    },
    {
      "authorName": [21, 0],
      "paperName": "Identifying Patterns of Pedestrian Crashes in Urban Metropolitan Roads in India using Association Rule Mining",
      "conferenceName": "15th World Conference on Transport Research 2019 , WCTRS 2019, Mumbai - India",
      "Date": "May 2019",
       "paperlink":"https://www.sciencedirect.com/science/article/pii/S2352146520305184"
    },
    {
      "authorName": [21, 0],
      "paperName": "Investigating Factors associated with Hit-and-run Crashes in Indian Metropolitan City Using Association Rules",
      "conferenceName": "Australian Road Safety Conference,ARSC 2018, October 3-5",
      "Date": "2018",
       "paperlink": "https://acrs.org.au/article/market-basket-analysis-of-powered-two-wheeler-crashes-in-metropolitan-roads-a-case-study-from-chennai-city-india//"
    },

    {
      "authorName": [21, 0],
      "paperName": "Market Basket Analysis of Powered Two-Wheeler Crashes in Metropolitan Roads- A Case Study from Chennai City, India",
      "conferenceName": "Australian Road Safety Conference, ARSC 2018, October 3-5",
      "Date": "2018",
       "paperlink": "https://acrs.org.au/article/market-basket-analysis-of-powered-two-wheeler-crashes-in-metropolitan-roads-a-case-study-from-chennai-city-india/"
    },
    {
      "authorName": [21, 0],
      "paperName": "Data Mining- Based Analysis of Hit-And-Run Crashes in Metropolitan City",
      "conferenceName": "20th Congress of International Ergonomics Association, IEA 2018, August 26-30 ",
      "Date": "2018",
      "paperlink": "https://link.springer.com/chapter/10.1007%2F978-3-319-96074-6_12"
    },

    {
      "authorName": [21, 0],
      "paperName": "Analysis of Driver Injury Severity in Metropolitan Roads of India Through Classification Tree",
      "conferenceName": "20th Congress of the International Ergonomics Association (IEA 2018), Florence",
      "Date": "August 26-30, 2018",
      "paperlink": "https://link.springer.com/chapter/10.1007/978-3-319-96074-6_13"
    },
    {
      "authorName": [21, 0],
      "paperName": "Data Mining Based Analysis of Hit-and-Run Crashes in Metropolitan City",
      "conferenceName": "20th Congress of the International Ergonomics Association (IEA 2018), Florence",
      "Date": "August 26-30, 2018",
      "paperlink": "https://link.springer.com/chapter/10.1007/978-3-319-96074-6_12"
    },

    {
      "authorName": [5, 35, 0],
      "paperName": "Real-Time Pedestrian Detection in various Climate Conditions using Deep Learning",
      "conferenceName": "International Ergonomics Conference, HWWE 2017",
      "Date": "December 8-10, 2017",
       "paperlink": "https://link.springer.com/chapter/10.1007/978-3-319-96074-6_12"
    },

    {
      "authorName": [0,21,105],
      "paperName": "Investigation of Factors Contributing to Injury Severity in Single Vehicle Motorcycle Crashes in India",
      "conferenceName": "International Journal of Injury Control and Safety Promotion. DOI:10.1080/17457300.2021.1908367, 2021). [IF 1.342, Cite Score 2]",
      "Date":"2021",
      "paperlink":"https://pubmed.ncbi.nlm.nih.gov/33820490/"

    },


      {
        "authorName": [104,21,0],
        "paperName": "Identification of Contributing Factors in Vehicle Pedestrian Crashes in Chennai using Multiple Correspondence Analysis",
         "conferenceName": "Transportation Research Procedia, Vol 48, 3486-3495, DOI:https://doi.org/10.1016/j.trpro.2020.08.104 [IF 1.2 (SJR), Cite Score 2.5]",
        "Date": "2020.",
        "paperlink": "https://www.sciencedirect.com/science/article/pii/S2352146520305202"
        },

        {
          "authorName":[0,21],
          "paperName":"Identifying Human Factors and Other Characteristics that Contribute to Injury Severity in Single-Vehicle Four-Wheeler Crashes in Tamilnadu",
           "conferenceName":"In Proceedings of the 21st Congress of the International Ergonomics Association (IEA 2021). Lecture Notes in Networks and Systems, vol 221, 2021.",
          "Date":"2021",
          "paperlink":"https://www.springerprofessional.de/en/identifying-human-factors-and-other-characteristics-that-contrib/19170132"
          },

          {
            "authorName":[0,21],
            "paperName":"Severity of Pedestrians in Pedestrian - Bus Crashes: An Investigation of Pedestrian, Driver and Environmental Characteristics Using Random Forest Approach",
             "conferenceName":"In Proceedings of the 21st Congress of the International Ergonomics Association (IEA 2021). Lecture Notes in Networks and Systems, vol 221, 2021.",
            "Date":"2021",
            "paperlink":"https://link.springer.com/chapter/10.1007/978-3-030-74608-7_101"
            },
            {
              "authorName":[0,21,105],
              "paperName":". Investigation of Injury patterns in Heavy-duty Single Vehicle crashes based on real-world accident data in Tamilnadu, India",
               "conferenceName":"Journal of Road Safety, Australasian Road Safety Conference, ARSC 2021, 32(2), 30-40, 2021.",
              "Date":"2021",
              "paperlink":"https://acrs.org.au/article/investigation-of-injury-patterns-in-heavy-duty-single-vehicle-crashes-based-on-real-world-accident-data-in-tamilnadu-india/"
              }




  ];



  public biomechanics = [


    {
      "authorName": [0, 5],
      "paperName": "Grip and Electrophysiological Sensor Based Estimation of Muscle Fatigue while Holding Steering Wheel in Different Positions",
      "conferenceName": "IEEE Sensors Journal, Volume 19 (5), 1951-1960",
      "Date": "2019",
       "paperlink": "https://ieeexplore.ieee.org/document/8425048"
    },

    {
      "authorName": [5, 0],
      "paperName": "Viability of Cardiac Parameters Measured Unobtrusively using Capacitive Coupled Electrocardiography (cECG) to Estimate Driver Performance",
      "conferenceName": "IEEE Sensors Journal, DOI 10.1109/JSEN.2019.2898450",
      "Date": "2019",
       "paperlink": "https://publications.iitm.ac.in/publication/viability-of-cardiac-parameters-measured-unobtrusively-using"
    },

    {
      "authorName": [0, 5],
      "paperName": "Pedestrians’ perception and response towards vehicles during road-crossing at night time",
      "conferenceName": "Accident Analysis & Prevention 110, 128-135",
      "Date": "2018",
       "paperlink": "https://www.sciencedirect.com/science/article/pii/S0001457517303810"
    },

    {
      "authorName":[0,5,45],
      "paperName":"Performance Comparison of Machine Learning and Deep Learning While Classifying Driver’s Cognitive State",
      "conferenceName":"2018 IEEE 13th International Conference on Industrial and Information",
      "Date": "2018",
      "paperlink":"https://ieeexplore.ieee.org/document/8721374"

    },
    {
    "authorName":[0,5,104],
    "paperName":"Study to determine the effectiveness of deep learning classifiers for ECG based driver fatigue classification",
    "conferenceName":"2018 IEEE 13th International Conference on Industrial and Information",
    "Date": "2018",
    "paperlink":"https://ieeexplore.ieee.org/document/8721391"
    },

    {
      "authorName":[5,45,0],
      "paperName":"Comparison of Driver Fatigue Trend on simulator and on-road driving based on EMG correlation",
      "conferenceName":"2018 IEEE 13th International Conference on Industrial and Information",
      "Date": "2018",
      "paperlink":"https://ieeexplore.ieee.org/document/8721431"
      },

    {
      "authorName": [0, 5],
      "paperName": "Can cECG be An Unobtrusive Surrogate to Determine Cognitive State of Driver? Transportation Research Part F: Traffic Psychology and Behaviour",
      "conferenceName": "58, 797-806",
      "Date": "2018",
       "paperlink": "https://www.sciencedirect.com/science/article/pii/S1369847817302073"
    },


    {
      "authorName": [0, 5],
      "paperName": "Driver’s Cardiac Activity Performance Evaluation Based on Non-contact ECG System Placed at Different Seat Locations",
      "conferenceName": "20th Congress of the International Ergonomics Association (IEA 2018), Florence",
      "Date": "August 26-30, 2018",
      "paperlink": "https://link.springer.com/chapter/10.1007/978-3-319-96074-6_30"
    },
    {
      "authorName": [0, 5],
      "paperName": "EEG Based Assessment of Pedestrian Perception of Automobile in Low Illumination Road",
      "conferenceName": "20th Congress of the International Ergonomics Association (IEA 2018), Florence",
      "Date": "August 26-30, 2018",
      "paperlink": "https://link.springer.com/chapter/10.1007/978-3-319-96089-0_43"
    },
    {
      "authorName": [0, 5],
      "paperName": "Pedestrians’ perception and response towards vehicles during road-crossing at nighttime",
      "conferenceName": "Accident Analysis & Prevention 110, 128-135",
      "Date": "December 3-5, 2018",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S0001457517303810"
    },
    {
      "authorName": [21, 0, 5],
      "paperName": "Challenges and problems faced by Bus Drivers",
      "conferenceName": "Journal of road Transport, Volume 1 (10), 12-23",
      "Date": "2017",
      // "paperlink": "https://link.springer.com/chapter/10.1007/978-3-319-96074-6_30"
    },

    {
      "authorName": [21, 0],
      "paperName": "Risk Factors Associated With Accident Severity In Urban Chennai",
      "conferenceName": "International Ergonomics Conference (HWWE 2017)",
      "Date": "December 8-10, 2017",
      "paperlink": "https://www.researchgate.net/publication/326479376_Risk_Factors_Associated_with_Accident_Severity_in_Urban_Chennai"
    },
    {
      "authorName": [21, 5, 0],
      "paperName": "Subjective Evaluation Of Musculoskeletal Disorders Among Fatal And Non-Fatal Bus Drivers In Different Scenarios",
      "conferenceName": "International Ergonomics Conference (HWWE 2017)",
      "Date": "December 8-10, 2017",
      "paperlink": "https://www.researchgate.net/publication/322680387_Subjective_Evaluation_Of_Musculoskeletal_Disorders_Among_Fatal_And_Non-Fatal_Bus_Drivers_In_Different_Scenarios"
    },
    {
      "authorName": [21, 5, 0],
      "paperName": "Comparative Assessment of Mini Mental State Examination in Bus Drivers For On Road And Simulator Study Conditions",
      "conferenceName": "International Ergonomics Conference (HWWE 2017)",
      "Date": "December 8-10, 2017",
      "paperlink": "https://www.researchgate.net/publication/322680303_Comparative_Assessment_Of_Mini_Mental_State_Examination_In_Bus_Drivers_For_On_Road_And_Simulator_Study_Conditions"
    },
    {
      "authorName": [5, 21, 0],
      "paperName": "Comparison of Fatigue Trend among Different Aged Driver on Simulator and On-road Driving",
      "conferenceName": "International Ergonomics Conference (HWWE 2017)",
      "Date": "December 8-10, 2017",
      "paperlink": "https://www.researchgate.net/publication/322678817_Comparison_of_Fatigue_Trend_among_Different_Aged_Driver_With_and_Without_PTSD_on_Simulator_and_On-road_Driving"
    },
    {
      "authorName": [5, 21, 0],
      "paperName": "Assessment of Bus Driver Performance Based on Reaction Time on Simulator and On-road Driving",
      "conferenceName": "International Ergonomics Conference (HWWE 2017)",
      "Date": "December 8-10, 2017",
      "paperlink": "https://www.researchgate.net/publication/322679105_Assessment_of_Bus_Driver_Performance_Based_on_Reaction_Time_on_Simulator_and_On-road_Driving"
    },
    {
      "authorName": [5, 102, 0],
      "paperName": "Cognitive assessment of Driver based on Deep learning using EEG Signals",
      "conferenceName": "International Ergonomics Conference (HWWE 2017)",
      "Date": "December 8-10, 2017",
      "paperlink": "https://www.researchgate.net/publication/322680197_Cognitive_Assessment_of_Driver_based_on_Deep_Learning_Using_EEG_Signals"
    },
    {
      "authorName": [103, 5, 0],
      "paperName": "Real-Time Driver Fatigue detection from ECG using Deep Learning Algorithm",
      "conferenceName": "International Ergonomics Conference (HWWE 2017)",
      "Date": "December 8-10, 2017",
      "paperlink": "https://www.researchgate.net/publication/322657059_Real-Time_Driver_Fatigue_Detection_from_ECG_Using_Deep_Learning_Algorithm"
    },
    {
      "authorName": [5, 0],
      "paperName": "Palm pressure based sensing of automobile driver alertness",
      "conferenceName": "Humanizing Work and Work Environment (HWWE 2014)",
      "Date": "December 3-5, 2014",
      "paperlink": "https://www.researchgate.net/publication/270103694_Palm_Pressure_Based_Sensing_of_Automobile_Driver_Alertness"
    },
    {
      "authorName": [5, 0],
      "paperName": "Optimization of muscle forces of lower arm in car driving",
      "conferenceName": "Humanizing Work and Work Environment (HWWE 2014)",
      "Date": "December 3-5, 2014",
      "paperlink": "https://www.researchgate.net/publication/270103681_Optimization_of_Muscles_Forces_of_Lower_Arm_in_Car_Driving"
    },
    {
      "authorName": [3, 4, 5, 0],
      "paperName": "Survey of Human Cognitive Response to Vehicles during Night conditions",
      "conferenceName": "Humanizing Work and Work Environment (HWWE 2014)",
      "Date": "December 3-5, 2014",
      "paperlink": "https://www.researchgate.net/publication/270104029_Survey_of_Human_Cognitive_Response_to_Vehicles_during_Night_Conditions"
    },
    {
      "authorName": [1, 0],
      "paperName": "Assessment of Early Onset of Driver Fatigue using Multimodal Fatigue measures in a Static Simulator",
      "conferenceName": "Applied Ergonomics, 45(4), 1140-1147",
      "Date": "2014",
      "paperlink": "https://pubmed.ncbi.nlm.nih.gov/24581559/"
    },
    {
      "authorName": [0, 1, 2],
      "paperName": "Muscle Fatigue Based Evaluation of Bicycle Design",
      "conferenceName": "Applied Ergonomics, 45 (2), Part B, 339-345",
      "Date": "2014",
      "paperlink": "https://pubmed.ncbi.nlm.nih.gov/23647886/"
    },
    {
      "authorName": [0, 1],
      "paperName": "Detecting Motorcycle Rider Fatigue using Surface Electromyography and Seat Interface Pressure",
      "conferenceName": "Transportation Research Part F: Traffic Psychology and Behaviour, 22, 150-158",
      "Date": "2014",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S1369847813001393"
    },
    {
      "authorName": [0, 6, 7],
      "paperName": "Analysis of muscle fatigue in helicopter pilots",
      "conferenceName": "Applied Ergonomics, 42 (6), 913-918",
      "Date": "2011",
      "paperlink": "https://pubmed.ncbi.nlm.nih.gov/21411058/"
    },
    {
      "authorName": [8, 0],
      "paperName": "Uni-model human system interface using sEMG.",
      "conferenceName": "Lecture Notes in Computer Science, Vol 6762 (2), 446-453",
      "Date": "2011",
      "paperlink": "https://link.springer.com/chapter/10.1007/978-3-642-21605-3_49",
      "conferenceName2": "14th International Conference on Human-Computer Interaction, HCI International, Orlando, FL",
      "Date2": "2011"
    },
    {
      "authorName": [0, 9, 10],
      "paperName": "RBG Risk Scale – An Integrated Tool for Ergonomic Risk Assessments",
      "conferenceName": " International Journal of Industrial and Systems Engineering, [Accepted for Publication]",
      "Date": "2009",
      "paperlink": "https://scholar.google.co.in/scholar?q=RGB+Risk+Scale+%E2%80%93+An+Integrated+Tool+for+Ergonomic+Risk+Assessment&hl=en&as_sdt=0&as_vis=1&oi=scholart"
    },
    {
      "authorName": [0, 2, 11],
      "paperName": "EEG Based Analysis of Cognitive Fatigue during Simulated Driving",
      "conferenceName": "International Journal of Industrial and Systems Engineering, [In Print]",
      "Date": "2009",
      "paperlink": "https://www.inderscienceonline.com/doi/abs/10.1504/IJISE.2011.038563"
    },
    {
      "authorName": [0, 12],
      "paperName": "Biomechanical Analysis of Main Gun Loader in an Armored Combat Vehicle",
      "conferenceName": "International Journal of Industrial and  Systems Engineering, Vol. 4, No.1 pp. 46 – 59",
      "Date": "2009",
      "paperlink": "https://www.researchgate.net/publication/245528190_Biomechanical_analysis_of_main_gun_loader_in_an_armoured_combat_vehicle"
    },
    {
      "authorName": [0, 8],
      "paperName": "Surface EMG based muscle activity analysis for aerobic cyclist",
      "conferenceName": "Journal of Bodywork and Movement Therapies, Volume 13, Issue 1, Pages 34 – 42",
      "Date": "2009",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S1360859208000326"
    },
    {
      "authorName": [8, 13, 0],
      "paperName": "Cognitive Effect of Music for Joggers using EEG",
      "conferenceName": "Proc 13th International Conference on Biomedical Engineering (ICBME2008), Singapore",
      "Date": "2008",
      "paperlink": "https://link.springer.com/chapter/10.1007/978-3-540-92841-6_275"
    },
    {
      "authorName": [8, 0],
      "paperName": "Low back Pain Evaluation for Cyclist Using sEMG: A Comparative Study between Bicyclist and Aerobic Cyclist",
      "conferenceName": "Proc 13th International Conference on Biomedical Engineering (ICBME2008), Singapore",
      "Date": "2008",
      "paperlink": "https://link.springer.com/chapter/10.1007%2F978-3-540-92841-6_280"
    },
    {
      "authorName": [8, 0],
      "paperName": "Low back pain and muscle fatigue due to road cycling –An sEMG study.",
      "conferenceName": "Journal of Bodywork and Movement Therapies, vol 11(3), 260-266",
      "Date": "2007",
      "paperlink": "https://www.researchgate.net/publication/251111445_Low_Back_Pain_Evaluation_for_Cyclist_using_sEMG_A_Comparative_Study_between_Bicyclist_and_Aerobic_Cyclist"
    },
    {
      "authorName": [0, 2],
      "paperName": "EMG-based analysis of change in muscle activity during simulated driving",
      "conferenceName": "Journal of Bodywork and Movement Therapies, vol 11(2), 151-158",
      "Date": "2007",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S1360859207000034"
    },
    {
      "authorName": [0],
      "paperName": "Modeling the Cervical Spine for High Fidelity ATD’s – Issues and Opportunities",
      "conferenceName": "International Symposium on Quality Aspects of FEA & CFD, EDAF-NAFEMS Bangalore",
      "Date": "2007",
       "paperlink":"https://www.sciencedirect.com/science/article/pii/S1360859208000326"
    },
    {
      "authorName": [0],
      "paperName": "Finite element modeling cervical spine – Necessities, advantages and limitations",
      "conferenceName": "International Symposium on Engineering Analysis and Simulation: Frontiers in FEM and CFD Practices, EDAF-NAFEMS Bangalore",
      "Date": "2007",
       "paperlink":""
    },
    {
      "authorName": [2, 0],
      "paperName": "Measurement of driver’s fatigue using dynamic body pressure distribution",
      "conferenceName": "International Ergonomics Conference HWWE 2007, Bhopal",
      "Date": "2007"
      // "paperlink":""
    },
    {
      "authorName": [14, 0],
      "paperName": "Development and Validation of a Three Dimensional Finite Element Model of Whole Cervical Spine",
      "conferenceName": "Journal of Biomechanics, 39, S420",
      "Date": "2006",
      "paperlink": "https://www.researchgate.net/publication/240062465_Development_and_validation_of_a_three_dimensional_finite_element_model_of_whole_cervical_spine"
    },
    {
      "authorName": [14, 0],
      "paperName": "CT Based Three Dimensional Finite Element Model ofCervical Spine",
      "conferenceName": "International Conference on Biomedical and Pharmaceutical Engineering (ICBPE 2006), Singapore",
      "Date": "2006",
      "paperlink": "https://ieeexplore.ieee.org/abstract/document/4155896/"
    },
    {
      "authorName": [8, 0],
      "paperName": "Effect of LBP on Muscle Activity of Lower back and Upper Extremity while Aerobic Cycling – An sEMG Based       Study",
      "conferenceName": "International Conference on Biomedical and Pharmaceutical Engineering (ICBPE 2006), Singapore",
      "Date": "2006",
      "paperlink": "https://ieeexplore.ieee.org/document/4155935"
    },
    {
      "authorName": [2, 0],
      "paperName": "Muscle fatigue in professional race car drivers – wavelet analysis of sEMG signal",
      "conferenceName": "Proc of 16th World Congress of Ergonomics, IEA 2006, Netherlands",
      "Date": "2006"
      // "paperlink":""
    },
    {
      "authorName": [7, 6, 15, 0],
      "paperName": "EMG Study of Neck Muscles While using Standard Issue Helicopter Air Crew Headgear",
      "conferenceName": "International conference on Ergonomics, HWWE 2005",
      "Date": "2005"
      // "paperlink":""
    },
    {
      "authorName": [0, 7, 6],
      "paperName": "Ergonomic Study of Low Back Pain in Chetak Helicopter Pilots",
      "conferenceName": "International conference on Ergonomics, HWWE 2005",
      "Date": "2005",
      "paperlink":"https://www.sciencedirect.com/science/article/pii/S0003687011000263"
    },
    {
      "authorName": [6, 7, 0],
      "paperName": "EMG Study of Flight Induced Fatigue of Chetak Helicopter Pilots",
      "conferenceName": "International Ergonomics Conference HWWE 2005",
      "Date": "2005"
      // "paperlink":""
    },
    {
      "authorName": [8, 0],
      "paperName": "Muscle Fatigue Analysis for Bicyclist Using sEMG",
      "conferenceName": "Proc 12th International Conference on Biomedical Engineering       (ICBME 2005), [Outstanding Paper Award] Singapore",
      "Date": "2005",
      "paperlink": "https://www.sciencedirect.com/science/article/abs/pii/S1360859208000326"
    },
    {
      "authorName": [16, 17, 18, 0],
      "paperName": "Response of Spine to Vehicular Vibration",
      "conferenceName": "Proc. of the Twelfth International Congress of Sound and Vibration, Lisbon, Portugal",
      "Date": "2005",
      "paperlink": "https://www.researchgate.net/publication/288235217_Response_of_spine_to_vehicular_vibration"
    },
    {
      "authorName": [16, 0, 18],
      "paperName": "Finite Element Modeling and Analysis of L2/3Functional Spine Unit",
      "conferenceName": "Proc. National Conference on Biomechanics, Delhi, India",
      "Date": "2004"
      // "paperlink":""
    },
    {
      "authorName": [0, 19],
      "paperName": "Stress Fractures – A Brief Insight",
      "conferenceName": "Jantar Mantar Children’s Science Observatory",
      "Date": "2004"
      // "paperlink":""
    },
    {
      "authorName": [12, 0, 20, 15],
      "paperName": "Biomechanical Analysis of Loader in Armored Vehicle",
      "conferenceName": "Proc. National Conference on Humanizing Work and Working Environment, India",
      "Date": "2004",
      "paperlink": "https://www.researchgate.net/publication/245528190_Biomechanical_analysis_of_main_gun_loader_in_an_armoured_combat_vehicle"
    },
    {
      "authorName": [5, 0],
      "paperName": "Driver’s Cardiac Activity Performance Evaluation Based on Non-contact ECG System Placed at Different Seat Locations",
      "conferenceName": "20th Congress of the International Ergonomics Association (IEA 2018), Florence",
      "Date": "August 26-30, 2018",
      "paperlink": "https://link.springer.com/chapter/10.1007/978-3-319-96074-6_30"
    },
    {
      "authorName": [5, 0],
      "paperName": "EEG Based Assessment of Pedestrian Perception of Automobile in Low Illumination Road",
      "conferenceName": "20th Congress of the International Ergonomics Association (IEA 2018), Florence",
      "Date": "August 26-30, 2018",
      "paperlink": "https://link.springer.com/chapter/10.1007/978-3-319-96089-0_43"
    },
    {
      "authorName": [21, 0],
      "paperName": "Analysis of Driver Injury Severity in Metropolitan Roads of India Through Classification Tree",
      "conferenceName": "20th Congress of the International Ergonomics Association (IEA 2018), Florence",
      "Date": "August 26-30, 2018",
      "paperlink": "https://link.springer.com/chapter/10.1007/978-3-319-96074-6_13"
    },
    {
      "authorName": [21, 0],
      "paperName": "Data Mining Based Analysis of Hit-and-Run Crashes in Metropolitan City",
      "conferenceName": "20th Congress of the International Ergonomics Association (IEA 2018), Florence",
      "Date": "August 26-30, 2018",
      "paperlink": "https://link.springer.com/chapter/10.1007/978-3-319-96074-6_12"
    },
    {
      "authorName":[11,2,0],
      "paperName": "“EEG based analysis of cognitive fatigue during simulated driving,”",
       "conferenceName":"International Journal of Industrial and Systems Engineering, 7 (2), 135-149, 2011. ",
      "Date":"2011",
      "paperlink":"https://www.inderscience.com/info/inarticle.php?artid=38563"
      },
      {
        "authorName":[0,115,116],
        "paperName":"Determination of the Influence of Music on Working Memory Performance Using EEG Analysis",
         "conferenceName":"In: Black N.L., Neumann W.P., Noy I. (eds) Proceedings of the 21st Congress of the International Ergonomics Association (IEA 2021). IEA 2021. Lecture Notes in Networks and Systems, vol 223, 2022",
        "Date":"",
        "paperlink":"https://link.springer.com/chapter/10.1007/978-3-030-74614-8_69"
        },
        {
          "authorName":[104,125,0],
          "paperName":"Driver’s Cardiac Activity Measurement Using Capacitive ECG Measurements from Realistic Driving on City and Highway Roads.",
           "conferenceName":"In Proceedings of the 21st Congress of the International Ergonomics Association (IEA 2021). Lecture Notes in Networks and Systems, vol 221, 2021.",
          "Date":"2021",
          "paperlink":"https://www.springerprofessional.de/en/driver-s-cardiac-activity-measurement-using-capacitive-ecg-measu/19170330"
          },
          {
            "authorName":[45,125,0],
            "paperName":"Mediating Role of Driving Stress in the Relation Between Reaction Time and Risky Driving",
             "conferenceName":"In Proceedings of the 21st Congress of the International Ergonomics Association (IEA 2021). Lecture Notes in Networks and Systems, vol 221, 2021.",
            "Date":"2021",
            "paperlink":"https://link.springer.com/chapter/10.1007/978-3-030-74608-7_96"
            },

              {
                "authorName":[0,118],
                "paperName":"Impact of Mind Wandering on Driving. In: Stanton N. (eds) Advances in Human Factors of Transportation",
                 "conferenceName":"AHFE 2019. Advances in Intelligent Systems and Computing, vol 964. Springer, Cham. 2020",
                "Date":"2020",
                //"paperlink":""
                },
                {
                  "authorName":[0,45],
                  "paperName":"Assessing the Relation Between Emotional Intelligence and Driving Behavior: An Online Survey",
                   "conferenceName":"International Conference on Applied Human Factors and Ergonomics, pp. 233-239. Springer, Cham, 2019.",
                  "Date":"2019",
                  "paperlink":"https://publications.iitm.ac.in/publication/assessing-the-relation-between-emotional-intelligence-and-driving"
                  },


                {
                  "authorName":[3,,5,4,0],
                  "paperName":"Survey of Human Cognitive Response to Vehicles during Night Conditions",
                   "conferenceName":"HWWE 2014, 3-5 Dec, p. 548, 2014. ",
                  "Date":"2014",
                  //"paperlink":""
                  },
                {
                  "authorName":[54,0],
                  "paperName":"Validation methodology for high fidelity numerical spine and its ergonomics aspects",
                   "conferenceName":"HWWE 2014, 3-5 Dec, p. 722, 2014.",
                  "Date":"2014",
                  //"paperlink":""
                  },
                {
                  "authorName":[0,1,5],
                  "paperName":"Changes in Steering Wheel Grip Interface Pressure during Simulated Driving",
                   "conferenceName":"International Conference on Biosignals, Images and Instrumentation 2013, March 14-16, 2013",
                  "Date":"2013",
                  "paperlink":"https://www.scribd.com/document/470339077/ChangesinSteeringWheelGripInterfacePressureduringSimulatedDriving"
                  },
                {
                  "authorName":[5,84,2,0],
                  "paperName":"Assessment of human hand grasp and release movement using sEMG,",
                   "conferenceName":"International Conference on Human Factors and Ergonomics, HWWE 2011, December 15–17, p. 99, 2011",
                  "Date":"2011",
                  //"paperlink":""
                  },
                {
                  "authorName":[0,2,122,123,124],
                  "paperName":"Muscle fatigue due to motorcycle riding,” Small Engine Technology Conference & Exposition,",
                   "conferenceName":", No. 2010-32-0100, Austria, September 2010. ",
                  "Date":"2010",
                  "paperlink":"https://www.sae.org/publications/technical-papers/content/2010-32-0100/"
                  },
                {
                  "authorName":[0,1,2],
                  "paperName":"Evaluating bicycle design using sEMG to study muscle fatigue,",
                   "conferenceName":",” In: Proc. of the Seventh International Conference on Prevention of Work-Related Musculoskeletal Disorders (PREMUS 2010), France, p.178, 2010.",
                  "Date":"2010",
                  "paperlink":"https://pubmed.ncbi.nlm.nih.gov/23647886/"
                  },
                {
                  "authorName":[7,6,15,0],
                  "paperName":"EMG Study of Neck Muscles While using Standard Issue Helicopter Air Crew Headgear,",
                   "conferenceName":"International conference on Ergonomics, HWWE 2005, ",
                  "Date":"Dec 10–12, 2005",
                  //"paperlink":""
                  },
                {
                  "authorName":[50,0,9,],
                  "paperName":"EEG Based Statistical Analysis of the Effect of Microtonal Music on Human CNS,",
                   "conferenceName":"Proc 12th International Conference on Biomedical Engineering (ICBME 2005), Singapore, Dec 7–10, 2005",
                  "Date":"2005",
                  //"paperlink":""
                  },
                  {
                    "authorName":[0,2,11],
                    "paperName":"EEG based analysis of cognitive fatigue during simulated driving,",
                    "conferenceName":"International Journal of Industrial and Systems Engineering, 7 (2), 135-149,",
                    "Date":"2011",
                    "paperlink":"https://www.inderscienceonline.com/doi/abs/10.1504/IJISE.2011.038563"
                    },
  ];
  public newsarticle = {
    "news": [



      {
        "Index": "12",
        "Title": "National Seminar on Road Safety: Safer Road That Save Lives, in Ranchi, Jharkhand",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/25",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 27
      },

      {
        "Index": "12",
        "Title": "Workshop on Data Driven Approach to Road Safety for Uttar Pradesh Stake Holder Departments",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/22",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 7
      },
      {
        "Index": "13",
        "Title": "Aligning the Andhra Pradesh State for iRAD induction.",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/23",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 7
      },
      {
        "Index": "14",
        "Title": "Training Rajasthan Stake Holder departments in Implementing TN model",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/24",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 3
      },






      {
        "Index": "10",
        "Title": "GoI launches IRAD for Road Safety",
        // "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/18",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 4
      },


      {
        "Index": "11",
        "Title": "Demystifying Design Thinking - A Pathway to Practice",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/19",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 3
      },
      {
        "Index": "1",
        "Title": "Launch of Intelliseat",
        "News": "/Gallery/News/1",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/1",
        "GoogleLink": "https://photos.google.com/share/AF1QipNfXEdychTuD7-C4DyjlJhHdrWzNGdUR0YYdcUj0m4mCHyPfVi751XLkI_pg0ykMw?key=dU9Lazh2cDRCR2x4aEdDYkcyX0pKRkt5OHBXTFdB",
        "count": 26
      },
      {
        "Index": "2",
        "Title": "Health Technology Assessment Partner Meeting with NHM",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/2",
        "GoogleLink": "https://photos.google.com/share/AF1QipNLYSoQWvlj3GvW2cjSULXp78XaFK7hr1NEEb7mrTFCslGYf_xSZniCS-SSolzrSQ?key=RUxPdmdMcGZjaGxVTDFwUEQ5VDdWTWo0ZnFiNnBn",
        "count": 10
      },
      {
        "Index": "3",
        "Title": "Roundtable on Visionary Leadership for Manufacturing",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/3",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipNQGZR8AXfsaXuGQmpgIChx2fvy1tp0OamGaDFt?source=pwa&authKey=CKa0sfT3vbvvZg#slideshow/6275950062901818402",
        "Writeup": "/Gallery/News/3/write_up_v4mii.docx",
        "count": 15
      },
      {
        "Index": "4",
        "Title": "Technology transfer between IITM and Harita Seating System Ltd",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/4",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipOKlp5-ckSQt3DQjP3IP5u8X-n58O6wcAijFZkZ?source=pwa&authKey=CJvD0b_Uk8eBVA#slideshow/6189809970302168098",
        "count": 14
      },
      {
        "Index": "5",
        "Title": "RATH 2015",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/5",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipOyHpI6w_LO47xaJiPiX-GNbGQWC0OTJgofe2Gm?source=pwa&authKey=CPvny6r15PmeDg#slideshow/6111603848661303202",
        "count": 33
      },
      {
        "Index": "6",
        "Title": "Honourable Transport Minister, Thiru. V. Senthil Balaji, Govt. of Tamil Nadu visit to RBG Lab",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/6",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipPBVIfIs9B6LVm7i_cWxItgC6JWHwXg6-qiAgOY?source=pwa&authKey=CMqh08Xb0ajJyQE#slideshow/6041342160026327394",
        "count": 25
      },
      {
        "Index": "7",
        "Title": "RBG Lab Events",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/7",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipN-8YHfkCKDHtmXA_K6_ZxHGTJ391QUshD3dwzo?source=pwa&authKey=CKyE-YG0qJaHhAE#slideshow/5964181785425589762",
        "count": 12
      },
      {
        "Index": "8",
        "Title": "HWWE Conference 2014",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/8",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipNX0bg5uMICJPJlqD9Wb1qa8QkM94-6quNBejlx?source=pwa&authKey=CP-jovv5odLRswE#slideshow/5964609685186901602",
        "count": 27
      },
      {
        "Index": "9",
        "Title": "NTRI Workshop",
        "EventPhotos": "https://ed.iitm.ac.in/~vb/assets/Gallery/EventPhotos/14",
        "GoogleLink": "https://get.google.com/albumarchive/103853939790515914118/album/AF1QipNX0bg5uMICJPJlqD9Wb1qa8QkM94-6quNBejlx?source=pwa&authKey=CP-jovv5odLRswE#slideshow/5964609685186901602",
        "count": 18
      }
    ]
  }

  public simulation = [
    {
      "authorName": [4, 5, 0],
      "paperName": "Evaluation of yoga postures with sEMG",
      "conferenceName": "International Ergonomic Conference, HWWE 2014",
      "Date": "December 3-5, 2014",
      "paperlink": "https://www.researchgate.net/publication/270103791_Evaluation_of_Yoga_Postures_with_sEMG"
    },

    {
      "authorName": [1, 45, 86, 0],
      "paperName": "Design and development of photoplethysmograph: An experimental analysis on treadmill run",
      "conferenceName": "International conference on Human Factors and Ergonomics, HWWE . (Best Paper Award)",
      "Date": "2011"
      // "paperlink":""
    },
    {
      "authorName": [87, 0],
      "paperName": "Breakthrough in Higher Education for Transforming Indian Manufacturing: VLFM Program",
      "conferenceName": "Research in Higher Education - Daigaku Roshna , 42 (3) ,371-386",
      "Date": "2011",
      "paperlink": "https://ir.lib.hiroshima-u.ac.jp/files/public/3/31453/20141016181600913228/DaigakuRonshu_42_371.pdf"
    },
    {
      "authorName": [86, 1, 0],
      "paperName": "Review on different techniques of oxygen saturation measurement",
      "conferenceName": "VIT Conference on Science, Engineering and Technology (VIT-SET)",
      "Date": "2010"
      // "paperlink":""
    },

    {
      "authorName": [0],
      "paperName": "Industry - Institute Collaborations in India - Case Studies from IIT Madras,University – Industry Relations: Creating Alliances for Innovation",
      "conferenceName": "CII Mumbai",
      "Date": "January 17, 2009"
      // "paperlink":""
    },
    {
      "authorName": [0],
      "paperName": "Developing a Business Strategy,” “Program for Senior Managers on Visionary Leaders for Manufacturing ",
      "conferenceName": "CII Gurgaon",
      "Date": "December 21, 2008"
      // "paperlink":""
    },
    {
      "authorName": [0],
      "paperName": "Using FSDP in Teaching Undergraduate Class on Human Factors and Aesthetics at IIT Madras",
      "conferenceName": "Proc 1st VLFM Learning Convention, New Delhi",
      "Date": "February, 2009",
      "paperlink": "https://scholar.google.com/citations?user=TRCIZJcAAAAJ&hl=en"
    },

    {
      "authorName": [88, 0, 9],
      "paperName": "Human computer interactions and their influence on high performance manufacturing systems – A simulation study",
      "conferenceName": "International Ergonomics Conference HWWE 2007, Bhopal",
      "Date": "December 10-12, 2007",
      "paperlink": "https://books.google.co.in/books?hl=en&lr=&id=HudhBQAAQBAJ&oi=fnd&pg=PA306&dq=Human+computer+interaction+and+their+influence+on+high+performance+manufacturing+systems+%E2%80%93+A+simulation+study,&ots=8brudb7gQj&sig=qhFRIqu2omZ1C_QlHqctuja0qPo#v=onepage&q=Human%20computer%20interaction%20and%20their%20influence%20on%20high%20performance%20manufacturing%20systems%20%E2%80%93%20A%20simulation%20study%2C&f=false"
    },
    {
      "authorName": [89, 0, 9],
      "paperName": "A Study of Ergonomics in the Leather Cutting Workplace",
      "conferenceName": "International Ergonomics Conference HWWE 2007, Bhopal",
      "Date": "December 10-12, 2007"
      // "paperlink":""
    },
    {
      "authorName": [0, 9],
      "paperName": "Role of Information Technology in Logistics Management,” Logistics – The Challenges Ahead",
      "conferenceName": "Workshop at Vellore Institute of Technology",
      "Date": "January, 2006"
      // "paperlink":""
    },

    {
      "authorName": [0, 9],
      "paperName": "Who’s to be Blamed? A Case Study in Supply Chain Management,” Logistics – The Challenges Ahead",
      "conferenceName": "Workshop at Vellore Institute of Technology",
      "Date": "January, 2006"
      // "paperlink":""
    },
    {
      "authorName": [0],
      "paperName": "Armoured Combat Decision Support System",
      "conferenceName": "Proc. National Seminar on Emerging Technologies in Defense Preparedness, 7–9, India",
      "Date": "2003"
      // "paperlink":""
    },
    {
      "authorName": [0, 90],
      "paperName": "Shape optimization-using FEM",
      "conferenceName": "National symposium at Coimbatore Institute of Technology",
      "Date": "September 1994"
      // "paperlink":""
    },

    {
      "authorName":[54,0],
      "paperName":"“Developing a heuristic relationship to predict the spinal injury during vertical impact for autonomous vehicle and bioenvironment,” ",
       "conferenceName": "Computer Methods and Programs in Biomedicine",
      "Date": ", Vol 196, 105618, 2020. [IF 3.632, Cite Score 7.5]",
      "paperlink":"https://pubmed.ncbi.nlm.nih.gov/32603988/"
    },
    {
      "authorName": [0,54],
      "paperName": "“Influence of occupant collision state parameters on the lumbar spinal injury during frontal crash,”",
       "conferenceName": "Journal of Advanced Research,",
      "Date": "https://doi.org/10.1016/j.jare.2020.06.010, 2020. [IF 6.992, Cite Score 10.9]",
      "paperlink":"https://www.sciencedirect.com/science/article/pii/S2090123220301193"
      },
      {
        "authorName": [88,0,9],
        "paperName": "“Ergonomic risk incorporated schedules (ERIS) – scheduling using genetic algorithm to reduce operator fatigue in flow-shop based cells,”",
         "conferenceName": "International Journal. Enterprise Network Management, 3 (3), 184-200, ",
        "Date": "2009",
        "paperlink": "https://www.inderscience.com/info/inarticle.php?artid=32394"
        },
        {
          "authorName":[22,0,9],
          "paperName":"Modified shift system to improve productivity and worker well-being",
           "conferenceName":"HWWE 2014, 3-5 Dec, p. 544, 2014",
          "Date":"2014",
          //"paperlink":""
          },
          {
            "authorName":[0,119,120],
            "paperName":"'Fluid Impact under Various Tapping Condition for Biomedical Application (Shirodhara)",
             "conferenceName":", International Mechanical Engineering Congress & Exposition®, ASME, 2018.",
            "Date":"2018",
            "paperlink":"https://publications.iitm.ac.in/publication/fluid-impact-under-various-tapping-conditions-for-biomedical"
            },
            {
              "authorName":[0,119,120],
              "paperName":"Droplet Impact for Various Dripping Condition Falling from Different Height",
               "conferenceName":"SWAYAM, 2018, ISBN: 978-93-86761-73-6, Ane Books Pvt. Ltd.",
              "Date":"2018",

              //"paperlink":""
              },
              {
                "authorName":[0,9,121],
                "paperName":"Suzhal – An Alternative Layout to Improve Productivity and Worker Well-being in Labor Demanded Lean Environment",
                 "conferenceName":"Procedia Manufacturing, Vol 3, pp. 574-580, 2015",
                "Date":"2015",
                "paperlink":"https://publications.iitm.ac.in/publication/suzhal-an-alternative-layout-to-improve-productivity-and-worker"
                },
                {
                "authorName":[0,119,120],
                "paperName":"Deflection response on forehead idealized as plate on elastic foundation associated to shirodhara",
                "conferenceName":"International Journal for Computational Methods in Engineering Science & Mechanics,",
                "Date":"doi: 10.1080/15502287. 2018.1534157, 2018. [IF 0.243 (SJR), Cite Score 1.5]",
                "paperlink":"https://www.tandfonline.com/doi/full/10.1080/15502287.2018.1534157"
                },
                {
                  "authorName":[0,119,120],
                  "paperName":"Characterisation of electromechanical response of forehead tissues due to fluid impact during shirodhara treatment,",
                  "conferenceName":"International Journal of Materials and Structural Integrity, 12 (4), 353 – 366,",
                  "Date":"2018",
                  "paperlink":"http://www.inderscience.com/offer.php?id=95888"
                  }
  ];
  public authors = ["V. Balasubramanian", "M. Jagannath", "K. Adalarasu", "Niketha Kailash", "Vamsavardhana Vijay", "R. Bhardwaj", "A. Dutt", "S. Rai", "J. Srinivasan", "T.T. Narendran", "V. Sai Praveen", "A. Gupta", "S. Sharma", "K. M. Ashwin Kumar", "S. Basa", "S. Karthik", "J. Manjusha", "Z. Jayesh", "C. Sujatha", "Shobit Rai", "G. Swamiprasad", "Sathish Kumar Sivasankaran", "S S Gnanavel", "R. Regulapati", "M. Faisal", "T. A. Krishna", "S. K. M. Varadhan", "V.S Anand", "S.Guhathakurtha", "B.V.R Tata", "S.Ponraju", "M. Mohanakumar", "B. Ananthakrishnan", "S. Veerappan", "R. Balasundari", "K.M. Cherian", "S. Verghese", "B. S. Murthy", "R. Agarwal", "P Padmaja", "R. Balasundari", "R. Gupta", "S. Kulkarni", "S. Saraswati", "S. Nayar", "P Swathy", "Niketha kailash", "Minerva Rajendran", "A. Suryanarayanan", "Priyanka Gopal", "H. M. Bharadwaj", "P. Manika", "K. M. Patil", "Z. A. Sayeed", "Sivasankari", "M.Ozenci", "M. Panjabi", "W. Rubin", " R. Shah", "A. S Shanbhag", "G. LI ", " H. E. Rubash", "M. C. Musolino", "T. C. Doehring", "T. Colan", "B. Marson", "S.Shanbhag", "C. W. Cha", "H. O. Bailey", "H.E. Rubash", "J. D. Towers", "K. J. Fischer", "S. Dodds", "M. Puri", "V. B. Narayanamurthy", "R. Parivalavan", "V.J. Thomas", "S. Radhakrishnan", "V.B N. Murthy", "S M Vadivel", "V. Anbarasi", "D.V. Rajan", "P. Karthikeyan", "S. Vigneshwaran", "N Singh", "Mervin Alexander", "V.Logan", "S. Shiba", "T. Aravind Krishna", "A. Mohammed Faisal", "V. N.Venkatraman", "C.J. Robinson", "X. S. Zollier", "S. G. Morstatt", "L. W. Faulkner", "S. J. Richerson", "R. D. Vanya", "A. M. Hollister", "R. F. Nassar", "T. Ehsan", "S. Richerson", "J. Robinson", "C. Piyus", "A. Cherian", "N. Priyadarshini", "H.Rangam","S.Rallapalli","D.K. Bhishi","P. S. Korrapati","E.Kurien","S.Warrier","K.M.Cherian","K.A.Arasu","K.M.Patil","Kannan.V","Minerva Rajendran","Tanya Malaiya","Srinath.R","Rajendhiran","M.Swathika","C. Lakshmana Rao","S.S.Gnanavel","V. Sai Praveen","Venkata Mangaraju","Babu","Ananthakumar.B","Ramesh.A","Y.Dasari","A. Teladevalapalli"];


  constructor() {

  }

  selectGallery(galleryInfo) {
    this.selectedGallery = galleryInfo
  }

  // selectNews(NewsInfo) {
  //   this.selectedNews = NewsInfo
  // }
}
